export default [{
  sutra: 's1',
  vocabularies: [{
    tag: '1.1',
    v1voc: 'སངས་རྒྱས་ཕལ་པོ་ཆེ་ཞེས་བྱ་བཤིན་ཏུ་རྒྱས་པཆེན་པོའི་མདོ་',
    v2voc: '大方廣佛華嚴經',
    v3voc: '大方廣佛華嚴經',
    v4voc: '佛說菩薩本業經',
    v5voc: '諸菩薩求佛本業經',
    PS: null,
  },
  {
    tag: '1.2',
    v1voc: 'སྤྱོད་ཡུལ་ཡོངས་སུ་དག་པའི་ལེའུ་',
    v2voc: '淨行品',
    v3voc: '淨行品',
    v4voc: '願行品',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '2.1',
    v1voc: 'དེ་ནས',
    v2voc: '爾時',
    v3voc: '爾時',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '2.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ',
    v2voc: '菩薩',
    v3voc: '菩薩',
    v4voc: '菩薩',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '2.3',
    v1voc: 'ཡེ་ཤེས་དཔལ',
    v2voc: '智首',
    v3voc: '智首',
    v4voc: '智首',
    v5voc: '𢜪那師利',
    PS: null,
  },
  {
    tag: '2.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ་འཇམ་དཔལ་',
    v2voc: '文殊師利',
    v3voc: '文殊師利',
    v4voc: '敬首',
    v5voc: '文殊師利菩薩',
    PS: null,
  },
  {
    tag: '2.5',
    v1voc: 'འདི་སྐད་ཅེས་སྨྲས་སོ',
    v2voc: '問……言',
    v3voc: '問……言',
    v4voc: '問……曰',
    v5voc: '問',
    PS: null,
  },
  {
    tag: '3.1',
    v1voc: 'ཀྱེ་རྒྱལ་བའི་སྲས',
    v2voc: '佛子！',
    v3voc: '佛子！',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '3.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ',
    v2voc: '菩薩',
    v3voc: '菩薩',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '3.3',
    v1voc: 'ཇི་ལྟར་ན་',
    v2voc: '云何',
    v3voc: '云何',
    v4voc: '本何',
    v5voc: '何因',
    PS: null,
  },
  {
    tag: '3.4',
    v1voc: 'ཁ་ན་མ་ཐོ་བ་མེད་པ',
    v2voc: '無過失',
    v3voc: '不染',
    v4voc: '不念人惡',
    v5voc: '不法他人長短；不說他人長短；不念他人長短',
    PS: '3.1',
  },
  {
    tag: '3.5',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '身',
    v5voc: '身',
    PS: '3.1',
  },
  {
    tag: '3.6',
    v1voc: 'དང་ལྡན་པ་ཡིན',
    v2voc: '得',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '3.1',
  },
  {
    tag: '3.7',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '口',
    v5voc: '口',
    PS: '3.1',
  },
  {
    tag: '3.8',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '意',
    v5voc: '心',
    PS: '3.1',
  },
  {
    tag: '3.10',
    v1voc: 'རྣམ་པར་མ་ཉམས་པ',
    v2voc: '不可壞',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '3.2',
  },
  {
    tag: '3.11',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '3.2',
  },
  {
    tag: '3.12',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '3.2',
  },
  {
    tag: '3.13',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '3.2',
  },
  {
    tag: '3.14',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '-',
    v4voc: '(身)',
    v5voc: '身有所行',
    PS: '3.3',
  },
  {
    tag: '3.15',
    v1voc: 'མ་སྨད་པ',
    v2voc: '不可毀',
    v3voc: '-',
    v4voc: '不得其短',
    v5voc: '不令他人得長短',
    PS: '3.3',
  },
  {
    tag: '3.16',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '-',
    v4voc: '(口)',
    v5voc: '口所言',
    PS: '3.3',
  },
  {
    tag: '3.17',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '-',
    v4voc: '(意)',
    v5voc: '心所念',
    PS: '3.3',
  },
  {
    tag: '3.18',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '(身)',
    v5voc: '身所行',
    PS: '3.4',
  },
  {
    tag: '3.19',
    v1voc: 'མི་འཕྲོགས་པ',
    v2voc: '不害',
    v3voc: '不害',
    v4voc: '仁慈至大，內性明了',
    v5voc: '無有能害',
    PS: '3.4',
  },
  {
    tag: '3.20',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '(口)',
    v5voc: '口所言',
    PS: '3.4',
  },
  {
    tag: '3.21',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '(意)',
    v5voc: '心所念',
    PS: '3.4',
  },
  {
    tag: '3.22',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '(身)',
    v5voc: '身所行',
    PS: '3.5',
  },
  {
    tag: '3.23',
    v1voc: 'མི་ཟློགས་པ',
    v2voc: '不退轉',
    v3voc: '不退轉',
    v4voc: '莫能迴',
    v5voc: '無能逮',
    PS: '3.5',
  },
  {
    tag: '3.24',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '(口)',
    v5voc: '口所言',
    PS: '3.5',
  },
  {
    tag: '3.25',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '(意)',
    v5voc: '心所念',
    PS: '3.5',
  },
  {
    tag: '3.26',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '(身)',
    v5voc: '(身所行)',
    PS: '3.6',
  },
  {
    tag: '3.27',
    v1voc: 'མི་འཁྲུགས་པ',
    v2voc: '不可動',
    v3voc: '不動',
    v4voc: '(莫能)動',
    v5voc: '無有能動轉',
    PS: '3.6',
  },
  {
    tag: '3.28',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '(口)',
    v5voc: '(口所言)',
    PS: '3.6',
  },
  {
    tag: '3.29',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '(意)',
    v5voc: '(心所念)',
    PS: '3.6',
  },
  {
    tag: '3.30',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '(身)',
    v5voc: '-',
    PS: '3.7',
  },
  {
    tag: '3.31',
    v1voc: 'བསྔགས་པ',
    v2voc: '殊勝',
    v3voc: '讚歎',
    v4voc: '(殊過)',
    v5voc: '-',
    PS: '3.7',
  },
  {
    tag: '3.32',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '(口)',
    v5voc: '-',
    PS: '3.7',
  },
  {
    tag: '3.33',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '(意)',
    v5voc: '-',
    PS: '3.7',
  },
  {
    tag: '3.34',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '(身)',
    v5voc: '身所行事',
    PS: '3.8',
  },
  {
    tag: '3.35',
    v1voc: 'རྣམ་པར་དག་པ',
    v2voc: '淸淨',
    v3voc: '淸淨',
    v4voc: '淨',
    v5voc: '淨潔',
    PS: '3.8',
  },
  {
    tag: '3.36',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '(口)',
    v5voc: '口所言',
    PS: '3.8',
  },
  {
    tag: '3.37',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '(意)',
    v5voc: '心所念',
    PS: '3.8',
  },
  {
    tag: '3.38',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '-',
    v5voc: '身所行',
    PS: '3.9',
  },
  {
    tag: '3.39',
    v1voc: 'ཉེ་བར་ཉོན་མོངས་པ་མེད་པ',
    v2voc: '無染',
    v3voc: '離煩惱',
    v4voc: '-',
    v5voc: '無瑕穢',
    PS: '3.9',
  },
  {
    tag: '3.40',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '-',
    v5voc: '口所言',
    PS: '3.9',
  },
  {
    tag: '3.41',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '-',
    v5voc: '心所念',
    PS: '3.9',
  },
  {
    tag: '3.42',
    v1voc: 'ལུས་ཀྱི་ལས',
    v2voc: '身業',
    v3voc: '身業',
    v4voc: '-',
    v5voc: '身所行',
    PS: '3.10',
  },
  {
    tag: '3.43',
    v1voc: 'ཡེ་ཤེས་སྔོན་དུ་འགྲོ་བ',
    v2voc: '智爲先導',
    v3voc: '隨智慧',
    v4voc: '-',
    v5voc: '智慧在上頭',
    PS: '3.10',
  },
  {
    tag: '3.44',
    v1voc: 'ངག་གི་ལས',
    v2voc: '語業',
    v3voc: '口業',
    v4voc: '-',
    v5voc: '口所言',
    PS: '3.10',
  },
  {
    tag: '3.45',
    v1voc: 'ཡིད་ཀྱི་ལས',
    v2voc: '意業',
    v3voc: '意業',
    v4voc: '-',
    v5voc: '心所念',
    PS: '3.10',
  },
  {
    tag: '4.1',
    v1voc: 'རིགས',
    v2voc: '生處',
    v3voc: '生處',
    v4voc: '出生',
    v5voc: '生時',
    PS: '4.1',
  },
  {
    tag: '4.2',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '端正',
    v5voc: '端正',
    PS: '4.1',
  },
  {
    tag: '4.3',
    v1voc: 'རུས',
    v2voc: '種族',
    v3voc: '姓',
    v4voc: '族姓',
    v5voc: '生時種類',
    PS: '4.2',
  },
  {
    tag: '4.4',
    v1voc: 'རྒྱུད',
    v2voc: '家',
    v3voc: '家',
    v4voc: '-',
    v5voc: '家',
    PS: '4.3',
  },
  {
    tag: '4.5',
    v1voc: 'གཟུགས',
    v2voc: '色',
    v3voc: '色',
    v4voc: '色',
    v5voc: '面色',
    PS: '4.4',
  },
  {
    tag: '4.6',
    v1voc: 'མཚན',
    v2voc: '相',
    v3voc: '相',
    v4voc: '相',
    v5voc: '相',
    PS: '4.5',
  },
  {
    tag: '4.7',
    v1voc: 'དྲན་པ',
    v2voc: '念',
    v3voc: '念',
    v4voc: '-',
    v5voc: '意所念',
    PS: '4.6',
  },
  {
    tag: '4.8',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '',
    v5voc: '智慧',
    PS: '4.7',
  },
  {
    tag: '4.9',
    v1voc: 'རྟོགས་པ',
    v2voc: '行',
    v3voc: '趣',
    v4voc: '行',
    v5voc: '-',
    PS: '4.8',
  },
  {
    tag: '4.10',
    v1voc: 'དགའ་བ',
    v2voc: '無畏',
    v3voc: '無畏',
    v4voc: '-',
    v5voc: '-',
    PS: '4.9',
  },
  {
    tag: '4.11',
    v1voc: 'བློ',
    v2voc: '覺悟',
    v3voc: '覺悟',
    v4voc: '-',
    v5voc: '-',
    PS: '4.10',
  },
  {
    tag: '4.12',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '(尊貴)',
    v5voc: '(好)',
    PS: '4.2',
  },
  {
    tag: '4.13',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '知重佛法',
    v5voc: '尊貴(家)',
    PS: '4.3',
  },
  {
    tag: '4.14',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '無比',
    v5voc: '好',
    PS: '4.4',
  },
  {
    tag: '4.15',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '(成就)',
    v4voc: '無比',
    v5voc: '(與眾異)',
    PS: '4.5',
  },
  {
    tag: '4.16',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '(自守志强)',
    v5voc: '(皆强.......)',
    PS: '4.6',
  },
  {
    tag: '4.17',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '-',
    v5voc: '-',
    PS: '4.7',
  },
  {
    tag: '4.18',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '-',
    v5voc: '-',
    PS: '4.8',
  },
  {
    tag: '4.19',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '-',
    v5voc: '-',
    PS: '4.9',
  },
  {
    tag: '4.20',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '-',
    v5voc: '-',
    PS: '4.10',
  },
  {
    tag: '5.1',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.1',
  },
  {
    tag: '5.2',
    v1voc: 'མཆོག་ཏུ་གྱུར་པ',
    v2voc: '勝',
    v3voc: '勝',
    v4voc: '-',
    v5voc: '(猛中勇)',
    PS: '5.1',
  },
  {
    tag: '5.3',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.2',
  },
  {
    tag: '5.4',
    v1voc: 'དམ་པར་གྱུར་པ',
    v2voc: '第一',
    v3voc: '第一',
    v4voc: '-',
    v5voc: '(猛中尊)',
    PS: '5.2',
  },
  {
    tag: '5.5',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.3',
  },
  {
    tag: '5.6',
    v1voc: 'རབ་ཏུ་གྱུར་པ',
    v2voc: '最上',
    v3voc: '最上',
    v4voc: '-',
    v5voc: '(猛中貴)',
    PS: '5.3',
  },
  {
    tag: '5.7',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.4',
  },
  {
    tag: '5.8',
    v1voc: 'ཚད་མེད་པ',
    v2voc: '無量',
    v3voc: '不可量',
    v4voc: '-',
    v5voc: '-',
    PS: '5.4',
  },
  {
    tag: '5.9',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.5',
  },
  {
    tag: '5.10',
    v1voc: 'གྲངས་མེད་པ',
    v2voc: '無數',
    v3voc: '不可數',
    v4voc: '-',
    v5voc: '無有央數',
    PS: '5.5',
  },
  {
    tag: '5.11',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '5.6',
  },
  {
    tag: '5.12',
    v1voc: 'བསམ་གྱིས་མི་ཁྱབ་པ',
    v2voc: '不思議',
    v3voc: '不可思議',
    v4voc: '-',
    v5voc: '-',
    PS: '5.6',
  },
  {
    tag: '5.13',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.7',
  },
  {
    tag: '5.14',
    v1voc: 'མཚུངས་པ་མེད་པ',
    v2voc: '無與等',
    v3voc: '-',
    v4voc: '-',
    v5voc: '無有能勝',
    PS: '5.7',
  },
  {
    tag: '5.15',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.9',
  },
  {
    tag: '5.16',
    v1voc: 'གཞལ་དུ་མེད་པ',
    v2voc: '不可量',
    v3voc: '不可稱',
    v4voc: '-',
    v5voc: '不可計',
    PS: '5.9',
  },
  {
    tag: '5.17',
    v1voc: 'བློ་གྲོས',
    v2voc: '慧',
    v3voc: '智慧',
    v4voc: '-',
    v5voc: '-',
    PS: '5.8',
  },
  {
    tag: '5.18',
    v1voc: 'བརྗོད་དུ་མེད་པ',
    v2voc: '不可說',
    v3voc: '不可說',
    v4voc: '-',
    v5voc: '-',
    PS: '5.8',
  },
  {
    tag: '6.1',
    v1voc: 'རྒྱུ',
    v2voc: '因',
    v3voc: '因',
    v4voc: '-',
    v5voc: '-',
    PS: '6.1',
  },
  {
    tag: '6.2',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.1',
  },
  {
    tag: '6.3',
    v1voc: 'བསམ་པ',
    v2voc: '欲',
    v3voc: '意',
    v4voc: '-',
    v5voc: '-',
    PS: '6.2',
  },
  {
    tag: '6.4',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.2',
  },
  {
    tag: '6.5',
    v1voc: 'སྦྱོར་བ',
    v2voc: '方便',
    v3voc: '方便',
    v4voc: '-',
    v5voc: '-',
    PS: '6.3',
  },
  {
    tag: '6.6',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.3',
  },
  {
    tag: '6.7',
    v1voc: 'རྐྱེན',
    v2voc: '緣',
    v3voc: '緣',
    v4voc: '-',
    v5voc: '-',
    PS: '6.4',
  },
  {
    tag: '6.8',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.4',
  },
  {
    tag: '6.9',
    v1voc: 'དམིགས་པ',
    v2voc: '所緣',
    v3voc: '境界',
    v4voc: '-',
    v5voc: '-',
    PS: '6.5',
  },
  {
    tag: '6.10',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.5',
  },
  {
    tag: '6.11',
    v1voc: 'དབང་པོ',
    v2voc: '根',
    v3voc: '根',
    v4voc: '-',
    v5voc: '-',
    PS: '6.6',
  },
  {
    tag: '6.12',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.6',
  },
  {
    tag: '6.13',
    v1voc: 'རྣམ་པར་ལྟ་བ',
    v2voc: '觀察',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '6.7',
  },
  {
    tag: '6.14',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '6.7',
  },
  {
    tag: '6.15',
    v1voc: 'ཞི་གནས',
    v2voc: '奢摩他',
    v3voc: '止',
    v4voc: '降心正意',
    v5voc: '一心降意',
    PS: '6.8',
  },
  {
    tag: '6.16',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.8',
  },
  {
    tag: '6.17',
    v1voc: 'ལྷག་མཐོང',
    v2voc: '毘鉢舍那',
    v3voc: '觀',
    v4voc: '攝念入禪',
    v5voc: '佪念入禪',
    PS: '6.9',
  },
  {
    tag: '6.18',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '(力)',
    v4voc: '-',
    v5voc: '-',
    PS: '6.9',
  },
  {
    tag: '6.19',
    v1voc: 'ངེས་པར་རྟོགས་པ',
    v2voc: '思惟',
    v3voc: '定',
    v4voc: '-',
    v5voc: '思惟明曉',
    PS: '6.10',
  },
  {
    tag: '6.20',
    v1voc: 'སྟོབས',
    v2voc: '力',
    v3voc: '力',
    v4voc: '-',
    v5voc: '-',
    PS: '6.10',
  },
  {
    tag: '7.1',
    v1voc: 'ཕུང་པོ',
    v2voc: '蘊',
    v3voc: '陰',
    v4voc: '五陰',
    v5voc: '五音',
    PS: '7.1',
  },
  {
    tag: '7.2',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '善知',
    v4voc: '(出入)',
    v5voc: '(出入)',
    PS: '7.1',
  },
  {
    tag: '7.3',
    v1voc: 'ཁམས',
    v2voc: '界',
    v3voc: '界',
    v4voc: '四大',
    v5voc: '四事',
    PS: '7.2',
  },
  {
    tag: '7.4',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '善知',
    v4voc: '(出入)',
    v5voc: '(出入)',
    PS: '7.2',
  },
  {
    tag: '7.5',
    v1voc: 'སྐྱེ་མཆེད',
    v2voc: '處',
    v3voc: '入',
    v4voc: '六入',
    v5voc: '-',
    PS: '7.3',
  },
  {
    tag: '7.6',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '(善知)',
    v4voc: '(出入)',
    v5voc: '-',
    PS: '7.3',
  },
  {
    tag: '7.7',
    v1voc: 'རྟེན་ཅིང་འབྲེལ་པར་འབྱུང་བ',
    v2voc: '緣起',
    v3voc: '緣起法',
    v4voc: '十二緣起',
    v5voc: '十二事',
    PS: '7.4',
  },
  {
    tag: '7.8',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '善知',
    v4voc: '(出入)',
    v5voc: '入',
    PS: '7.4',
  },
  {
    tag: '7.9',
    v1voc: 'གཟུགས་ཀྱི་ཁམས',
    v2voc: '色界',
    v3voc: '色(界)',
    v4voc: '-',
    v5voc: '-',
    PS: '7.6',
  },
  {
    tag: '7.10',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '善知',
    v4voc: '-',
    v5voc: '-',
    PS: '7.6',
  },
  {
    tag: '7.11',
    v1voc: 'གཟུགས་མེད་པའི་ཁམས',
    v2voc: '無色界',
    v3voc: '無色界',
    v4voc: '-',
    v5voc: '-',
    PS: '7.7',
  },
  {
    tag: '7.12',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '(善知)',
    v4voc: '-',
    v5voc: '-',
    PS: '7.7',
  },
  {
    tag: '7.13',
    v1voc: 'འདས་པ',
    v2voc: '過去',
    v3voc: '過去',
    v4voc: '-',
    v5voc: '過去',
    PS: '7.8',
  },
  {
    tag: '7.14',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '(善知)',
    v4voc: '-',
    v5voc: '-',
    PS: '7.8',
  },
  {
    tag: '7.15',
    v1voc: 'མ་འོངས་པ',
    v2voc: '未來',
    v3voc: '未來',
    v4voc: '-',
    v5voc: '當來',
    PS: '7.9',
  },
  {
    tag: '7.16',
    v1voc: 'མཁས་པ',
    v2voc: '善巧',
    v3voc: '(善知)',
    v4voc: '-',
    v5voc: '-',
    PS: '7.9',
  },
  {
    tag: '7.17',
    v1voc: 'ད་ལྟར་བྱུང་བ',
    v2voc: '現在',
    v3voc: '現在',
    v4voc: '-',
    v5voc: '今現在所出生',
    PS: '7.10',
  },
  {
    tag: '7.19',
    v1voc: '-',
    v2voc: '欲界',
    v3voc: '欲(界)',
    v4voc: '-',
    v5voc: '-',
    PS: '7.5',
  },
  {
    tag: '7.20',
    v1voc: '-',
    v2voc: '善巧',
    v3voc: '(善知)',
    v4voc: '-',
    v5voc: '-',
    PS: '7.10',
  },
  {
    tag: '8.1',
    v1voc: 'དྲན་པ་',
    v2voc: '念',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.1',
  },
  {
    tag: '8.2',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '(七)覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.1',
  },
  {
    tag: '8.3',
    v1voc: 'མཁས་པ་ཡིན / ཡོངས་སུ་བསྒོམས་པ',
    v2voc: '善修習',
    v3voc: '修',
    v4voc: '不閡',
    v5voc: '入',
    PS: '8.1',
  },
  {
    tag: '8.4',
    v1voc: 'ཆོས་རྣམ་པར་འབྱེད་པ',
    v2voc: '擇法(覺分)',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.2',
  },
  {
    tag: '8.5',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '(七)覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.2',
  },
  {
    tag: '8.6',
    v1voc: 'བརྩོན་འགྲུས',
    v2voc: '精進',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.3',
  },
  {
    tag: '8.7',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '(七)覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.3',
  },
  {
    tag: '8.8',
    v1voc: 'དགའ་བ',
    v2voc: '喜',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.4',
  },
  {
    tag: '8.9',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.4',
  },
  {
    tag: '8.10',
    v1voc: 'རབ་ཏུ་བྱང་བ་',
    v2voc: '猗',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.5',
  },
  {
    tag: '8.11',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '(七)覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.5',
  },
  {
    tag: '8.12',
    v1voc: 'ཏིང་ངེ་འཛིན',
    v2voc: '定',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.6',
  },
  {
    tag: '8.13',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '(七)覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.6',
  },
  {
    tag: '8.14',
    v1voc: 'བཏང་སྙོམས',
    v2voc: '捨',
    v3voc: '(七覺)',
    v4voc: '(七覺)',
    v5voc: '(七覺)',
    PS: '8.7',
  },
  {
    tag: '8.15',
    v1voc: 'ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག',
    v2voc: '覺分',
    v3voc: '(七)覺意',
    v4voc: '七覺',
    v5voc: '七覺意',
    PS: '8.7',
  },
  {
    tag: '8.16',
    v1voc: 'སྟོང་པ་ཉིད',
    v2voc: '空',
    v3voc: '空',
    v4voc: '空',
    v5voc: '虛空',
    PS: '8.8',
  },
  {
    tag: '8.17',
    v1voc: ' ཡོངས་སུ་བསྒོམས་པ',
    v2voc: '善修習',
    v3voc: '修',
    v4voc: '不閡',
    v5voc: '入',
    PS: '8.8',
  },
  {
    tag: '8.18',
    v1voc: 'མཚན་མ་མེད་པ',
    v2voc: '無相',
    v3voc: '無相',
    v4voc: '無想(之法)',
    v5voc: '（無常）',
    PS: '8.9',
  },
  {
    tag: '8.19',
    v1voc: 'སྨོན་པ་མེད་པ',
    v2voc: '無願',
    v3voc: '無作',
    v4voc: '不願之法',
    v5voc: '（無所罣礙）',
    PS: '8.10',
  },
  {
    tag: '9.1',
    v1voc: 'སྦྱིན་པ',
    v2voc: '檀',
    v3voc: '檀',
    v4voc: '(習衆德本)',
    v5voc: '(六波羅蜜經)',
    PS: '9.1',
  },
  {
    tag: '9.2',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '波羅蜜',
    v3voc: '波羅蜜',
    v4voc: '度無極',
    v5voc: '波羅蜜經',
    PS: '9.1',
  },
  {
    tag: '9.3',
    v1voc: 'ཚུལ་ཁྲིམས',
    v2voc: '尸',
    v3voc: '尸',
    v4voc: '(習衆德本)',
    v5voc: '(六波羅蜜經)',
    PS: '9.2',
  },
  {
    tag: '9.4',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '波羅蜜',
    v3voc: '波羅蜜',
    v4voc: '度無極',
    v5voc: '波羅蜜經',
    PS: '9.2',
  },
  {
    tag: '9.5',
    v1voc: 'བཟོད་པ',
    v2voc: '羼提',
    v3voc: '羼提',
    v4voc: '(習衆德本)',
    v5voc: '(六波羅蜜經)',
    PS: '9.3',
  },
  {
    tag: '9.6',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '波羅蜜',
    v3voc: '波羅蜜',
    v4voc: '度無極',
    v5voc: '波羅蜜經',
    PS: '9.3',
  },
  {
    tag: '9.7',
    v1voc: 'བརྩོན་འགྲུས',
    v2voc: '毘梨耶',
    v3voc: '毘梨耶',
    v4voc: '(習衆德本)',
    v5voc: '(六波羅蜜經)',
    PS: '9.4',
  },
  {
    tag: '9.8',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '波羅蜜',
    v3voc: '波羅蜜',
    v4voc: '度無極',
    v5voc: '波羅蜜經',
    PS: '9.4',
  },
  {
    tag: '9.9',
    v1voc: 'བསམ་གཏན',
    v2voc: '禪那',
    v3voc: '禪',
    v4voc: '(習衆德本)',
    v5voc: '(六波羅蜜經)',
    PS: '9.5',
  },
  {
    tag: '9.10',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '波羅蜜',
    v3voc: '波羅蜜',
    v4voc: '度無極',
    v5voc: '波羅蜜經',
    PS: '9.5',
  },
  {
    tag: '9.11',
    v1voc: 'ཤེས་རབ',
    v2voc: '般若',
    v3voc: '般若',
    v4voc: '(習衆德本)',
    v5voc: '(六波羅蜜經)',
    PS: '9.6',
  },
  {
    tag: '9.12',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '波羅蜜',
    v3voc: '波羅蜜',
    v4voc: '度無極',
    v5voc: '波羅蜜經',
    PS: '9.6',
  },
  {
    tag: '9.13',
    v1voc: 'བྱམས་པ',
    v2voc: '慈',
    v3voc: '慈',
    v4voc: '(所爲無量)',
    v5voc: '慈愛',
    PS: '9.7',
  },
  {
    tag: '9.14',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '(圓滿)',
    v3voc: '-',
    v4voc: '-',
    v5voc: '悉具足',
    PS: '9.7',
  },
  {
    tag: '9.15',
    v1voc: 'སྙིང་རྗེ',
    v2voc: '悲',
    v3voc: '悲',
    v4voc: '(所爲無量)',
    v5voc: '愍傷',
    PS: '9.8',
  },
  {
    tag: '9.16',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '(圓滿)',
    v3voc: '-',
    v4voc: '-',
    v5voc: '悉具足',
    PS: '9.8',
  },
  {
    tag: '9.17',
    v1voc: 'དགའ་བ',
    v2voc: '喜',
    v3voc: '喜',
    v4voc: '(所爲無量)',
    v5voc: '念善',
    PS: '9.9',
  },
  {
    tag: '9.18',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '(圓滿)',
    v3voc: '-',
    v4voc: '度無極',
    v5voc: '悉具足',
    PS: '9.9',
  },
  {
    tag: '9.19',
    v1voc: 'བཏང་སྙོམས',
    v2voc: '捨',
    v3voc: '捨',
    v4voc: '(所爲無量)',
    v5voc: '無所憎愛',
    PS: '9.10',
  },
  {
    tag: '9.20',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན / ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '(圓滿)',
    v3voc: '-',
    v4voc: '度無極',
    v5voc: '悉具足',
    PS: '9.10',
  },
  {
    tag: '10.1',
    v1voc: 'གནས་',
    v2voc: '處',
    v3voc: '是處',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.2',
    v1voc: 'གནས་མ་ཡིན་པ',
    v2voc: '非處',
    v3voc: '非處',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.3',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '10',
  },
  {
    tag: '10.4',
    v1voc: 'འདས་པ།',
    v2voc: '過',
    v3voc: '過去',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.5',
    v1voc: 'མ་འོངས་པ།',
    v2voc: '未',
    v3voc: '未來',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.6',
    v1voc: 'ད་ལྟར།',
    v2voc: '現在',
    v3voc: '現在',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.7',
    v1voc: 'ལས་ཀྱི་རྣམ་པར་སྨིན་པ',
    v2voc: '業報',
    v3voc: '業報',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.8',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '10',
  },
  {
    tag: '10.9',
    v1voc: 'དབང་པོ་',
    v2voc: '根',
    v3voc: '根',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.10',
    v1voc: 'བརྩོན་འགྲུས།',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.11',
    v1voc: 'ཐ་དད་པ།',
    v2voc: '(根)勝劣',
    v3voc: '種種(諸根)',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.12',
    v1voc: 'ཡོངས་སུ་རྫོགས་པར་བྱ་བ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.13',
    v1voc: 'གཅིག་ནས་གཅིག་ཏུ་བརྒྱུད་པ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.14',
    v1voc: 'ཁོང་དུ་ཆུད་པ་',
    v2voc: '得(....智力)',
    v3voc: '得(....智力)',
    v4voc: '通(十力智)',
    v5voc: '入於(十種力慧中)',
    PS: '10',
  },
  {
    tag: '10.15',
    v1voc: 'ཁམས',
    v2voc: '界',
    v3voc: '性',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.16',
    v1voc: 'སྣ་ཚོགས/དུ་མ',
    v2voc: '種種',
    v3voc: '種種',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.17',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '10',
  },
  {
    tag: '10.18',
    v1voc: 'མོས་པ་སྣ་ཚོགས',
    v2voc: '種種解',
    v3voc: '種種欲',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.19',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '10',
  },
  {
    tag: '10.20',
    v1voc: 'ཀུན་ཏུ་འགྲོ་བའི་ལམ',
    v2voc: '一切至處道',
    v3voc: '一切至處道',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.21',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '10',
  },
  {
    tag: '10.22',
    v1voc: 'བསམ་གཏན',
    v2voc: '禪',
    v3voc: '禪定',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.23',
    v1voc: 'རྣམ་པར་ཐར་པ',
    v2voc: '解脫',
    v3voc: '解脫',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.24',
    v1voc: 'ཏིང་ངེ་འཛིན་དང་སྙོམས་པར་འཇུག་པ',
    v2voc: '三昧',
    v3voc: '三昧',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.25',
    v1voc: 'ཀུན་ནས་ཉོན་མོངས་པ',
    v2voc: '染',
    v3voc: '垢',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.26',
    v1voc: 'རྣམ་པར་བྱང་བ',
    v2voc: '淨',
    v3voc: '淨',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.27',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '1',
  },
  {
    tag: '10.28',
    v1voc: 'བསྒྲིབས་པ་མེད་པའི་རྗེས་སུ་དྲན་པ་',
    v2voc: '宿住念',
    v3voc: '宿命無礙',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.29',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '1',
  },
  {
    tag: '10.30',
    v1voc: 'ལྷའི་མིག',
    v2voc: '天眼',
    v3voc: '天眼',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.31',
    v1voc: 'ཆགས་པ་མེད / ཆགས་པ་མེད་པ',
    v2voc: '無障礙',
    v3voc: '無礙',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.32',
    v1voc: 'ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ',
    v2voc: '(得)智力',
    v3voc: '(得)智力',
    v4voc: '(通)十力智',
    v5voc: '入於十種力慧中',
    PS: '10',
  },
  {
    tag: '10.33',
    v1voc: 'བག་ཆགས་ཀྱི་མཚམས་སྦྱོར་བ་',
    v2voc: '諸習',
    v3voc: '一切煩惱習氣',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '10.34',
    v1voc: 'ཡང་དག་པར་གཅད་པ',
    v2voc: '斷',
    v3voc: '斷',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.1',
    v1voc: 'ལྷ་ཡི་དབང་པོ',
    v2voc: '天王',
    v3voc: '天王',
    v4voc: '-',
    v5voc: '諸天',
    PS: null,
  },
  {
    tag: '11.2',
    v1voc: 'ཡོངས་སུ་བཟུང་བ',
    v2voc: '守護',
    v3voc: '守護',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.3',
    v1voc: 'ཀླུའི་དབང་པོ',
    v2voc: '龍王',
    v3voc: '龍王',
    v4voc: '-',
    v5voc: '龍',
    PS: null,
  },
  {
    tag: '11.4',
    v1voc: 'གནོད་སྦྱིན་གྱི་དབང་པོ',
    v2voc: '夜叉王',
    v3voc: '鬼神王',
    v4voc: '-',
    v5voc: '鬼神',
    PS: null,
  },
  {
    tag: '11.5',
    v1voc: 'དྲི་ཟའི་དབང་པོ',
    v2voc: '乾闥婆王',
    v3voc: '乾闥婆王',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.6',
    v1voc: 'ལྷ་མ་ཡིན་གྱི་དབང་པོ',
    v2voc: '阿脩羅王',
    v3voc: '阿脩羅王',
    v4voc: '-',
    v5voc: '阿須輪',
    PS: null,
  },
  {
    tag: '11.7',
    v1voc: 'ནམ་མཁའ་ལྡིང་གི་དབང་པོ',
    v2voc: '迦樓羅王',
    v3voc: '迦樓羅王',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.8',
    v1voc: 'མི་འམ་ཅིའི་དབང་པོ',
    v2voc: '緊那羅王',
    v3voc: '緊那羅王',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.9',
    v1voc: 'ལྟོ་འཕྱེ་ཆེན་པོའི་དབང་པོ',
    v2voc: '摩睺羅伽王',
    v3voc: '摩睺羅伽王',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.10',
    v1voc: 'མིའི་དབང་པོ',
    v2voc: '人王',
    v3voc: '人王',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '11.11',
    v1voc: 'ཚངས་པའི་དབང་པོ',
    v2voc: '梵王',
    v3voc: '梵天王',
    v4voc: '釋梵',
    v5voc: '梵釋',
    PS: null,
  },
  {
    tag: '11.12',
    v1voc: 'བཀུར་བ',
    v2voc: '恭敬供養',
    v3voc: '恭敬供養',
    v4voc: '敬',
    v5voc: '供養',
    PS: null,
  },
  {
    tag: '12.1',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད',
    v2voc: '一切衆生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方人',
    PS: null,
  },
  {
    tag: '12.2',
    v1voc: 'གནས་སུ་གྱུར་པ',
    v2voc: '爲依',
    v3voc: '爲(眾生)舍',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '12.3',
    v1voc: 'སྐྱབས་སུ་གྱུར་པ',
    v2voc: '爲救',
    v3voc: '爲救',
    v4voc: '-',
    v5voc: '諸有驚怖者，皆歸仰得解',
    PS: null,
  },
  {
    tag: '12.4',
    v1voc: 'དཔུང་གཉེན་དུ་གྱུར་པ',
    v2voc: '爲歸',
    v3voc: '爲歸',
    v4voc: '-',
    v5voc: '諸有恐懼急緣者，無不得安隱者',
    PS: null,
  },
  {
    tag: '12.5',
    v1voc: 'མགོན་དུ་གྱུར་པ',
    v2voc: '（爲趣）',
    v3voc: '（爲趣）',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '12.6',
    v1voc: 'སྒྲོན་མར་གྱུར་པ',
    v2voc: '爲炬',
    v3voc: '爲炬',
    v4voc: '-',
    v5voc: '明於十方，如炬火',
    PS: null,
  },
  {
    tag: '12.7',
    v1voc: 'སྣང་བར་གྱུར་པ',
    v2voc: '爲明',
    v3voc: '爲明',
    v4voc: '明天下，如日月',
    v5voc: '明於十方，如日月',
    PS: null,
  },
  {
    tag: '12.8',
    v1voc: 'འོད་དུ་གྱུར་པ',
    v2voc: '爲照',
    v3voc: '爲燈',
    v4voc: '除闇冥，如燭火',
    v5voc: '明於十方，如燈火',
    PS: null,
  },
  {
    tag: '12.9',
    v1voc: 'འདྲེན་པར་གྱུར་པ',
    v2voc: '爲導',
    v3voc: '爲導',
    v4voc: '度衆人，如船師',
    v5voc: '過度諸世間人，如船佐',
    PS: null,
  },
  {
    tag: '12.10',
    v1voc: 'རྣམ་པར་འདྲེན་པར་གྱུར་པ',
    v2voc: '爲勝導',
    v3voc: '爲無上導',
    v4voc: '',
    v5voc: '過度諸世間人，如船中人有尊師',
    PS: null,
  },
  {
    tag: '12.11',
    v1voc: 'ཡོངས་སུ་འདྲེན་པར་གྱུར་པ',
    v2voc: '爲普導',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '13.1',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད',
    v2voc: '一切衆生',
    v3voc: '一切衆生',
    v4voc: '-',
    v5voc: '諸天、世間人民、蜎飛蠕動之類',
    PS: null,
  },
  {
    tag: '13.2',
    v1voc: 'མཆོག་ཏུ་གྱུར་པ་',
    v2voc: '為第一',
    v3voc: '為第一',
    v4voc: '-',
    v5voc: '極善',
    PS: null,
  },
  {
    tag: '13.3',
    v1voc: 'གཙོ་བོར་གྱུར་པ',
    v2voc: '爲大',
    v3voc: '爲大',
    v4voc: '-',
    v5voc: '於……極豪',
    PS: null,
  },
  {
    tag: '13.4',
    v1voc: 'ཐུ་བོར་གྱུར་པ',
    v2voc: '爲勝',
    v3voc: '爲勝',
    v4voc: '-',
    v5voc: '於大衆中最獨尊',
    PS: null,
  },
  {
    tag: '13.5',
    v1voc: 'རབ་ཏུ་གྱུར་པ་',
    v2voc: '為最勝',
    v3voc: '-',
    v4voc: '-',
    v5voc: '雄中復重雄',
    PS: null,
  },
  {
    tag: '13.6',
    v1voc: 'དམ་པར་གྱུར་པ་',
    v2voc: '為妙',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '13.7',
    v1voc: 'ཕུལ་དུ་གྱུར་པ',
    v2voc: '爲極妙',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '13.8',
    v1voc: 'བླ་ན་མེད་པར་གྱུར་པ',
    v2voc: '無上',
    v3voc: '無上',
    v4voc: '',
    v5voc: '極上無有與等者',
    PS: null,
  },
  {
    tag: '14.2',
    v1voc: 'ཇི་ལྟར་ན',
    v2voc: '云何',
    v3voc: '云何',
    v4voc: '何',
    v5voc: '當何…',
    PS: null,
  },
  {
    tag: '14.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ',
    v2voc: '-',
    v3voc: '菩薩',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '14.4',
    v1voc: 'མཉམ་པ་མེད་པ',
    v2voc: '無等',
    v3voc: '無等',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '15.1',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ་འཇམ་དཔལ་',
    v2voc: '文殊師利菩薩',
    v3voc: '文殊師利',
    v4voc: '敬首',
    v5voc: '文殊師利菩薩',
    PS: null,
  },
  {
    tag: '15.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ་ཡེ་ཤེས་དཔལ',
    v2voc: '智首菩薩',
    v3voc: '智首菩薩',
    v4voc: '-',
    v5voc: '若那師利菩薩',
    PS: null,
  },
  {
    tag: '15.3',
    v1voc: 'འདི་སྐད་ཅེས་སྨྲས་སོ',
    v2voc: '告……言',
    v3voc: '答……曰',
    v4voc: '答曰',
    v5voc: '謂……言',
    PS: null,
  },
  {
    tag: '16.1',
    v1voc: 'ཀྱེ་རྒྱལ་བའི་སྲས་',
    v2voc: '佛子',
    v3voc: '佛子',
    v4voc: '佛子',
    v5voc: '佛子',
    PS: null,
  },
  {
    tag: '16.2',
    v1voc: 'ཁྱོད',
    v2voc: '汝',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '16.3',
    v1voc: 'མང་པོ་ལ་ཕན་པ་',
    v2voc: '多所饒益',
    v3voc: '多所饒益',
    v4voc: '-',
    v5voc: '多所度脫',
    PS: null,
  },
  {
    tag: '16.4',
    v1voc: 'མང་པོ་ལ་བདེ་བ་',
    v2voc: '多所安隱',
    v3voc: '多所安隱',
    v4voc: '極大慈哀',
    v5voc: '極大慈愛',
    PS: null,
  },
  {
    tag: '16.5',
    v1voc: 'འཇིག་རྟེན་',
    v2voc: '世間',
    v3voc: '世間',
    v4voc: '十方',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '16.6',
    v1voc: 'སྙིང་བརྩེ་བ་',
    v2voc: '哀愍',
    v3voc: '哀愍',
    v4voc: '愍傷',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '16.7',
    v1voc: 'ལྷ་དང་མི་རྣམས་',
    v2voc: '天人',
    v3voc: '天人',
    v4voc: '-',
    v5voc: '-',
    PS: '16',
  },
  {
    tag: '16.8',
    v1voc: 'ཕན་པ་',
    v2voc: '利',
    v3voc: '惠利',
    v4voc: '-',
    v5voc: '-',
    PS: '16',
  },
  {
    tag: '16.9',
    v1voc: 'བདེ་བ',
    v2voc: '樂',
    v3voc: '安樂',
    v4voc: '-',
    v5voc: '-',
    PS: '16',
  },
  {
    tag: '16.10',
    v1voc: 'རྣམ་པར་གཟུད་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '16',
  },
  {
    tag: '16.11',
    v1voc: 'འདི་ལྟ་བུ',
    v2voc: '如是',
    v3voc: '如是',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '16.12',
    v1voc: 'ཡོངས་སུ་འདྲི་བ',
    v2voc: '問',
    v3voc: '問',
    v4voc: '-',
    v5voc: '問',
    PS: null,
  },
  {
    tag: '16.14',
    v1voc: 'ལེགས་སོ',
    v2voc: '善哉！',
    v3voc: '善哉！',
    v4voc: '善哉！',
    v5voc: '善哉！',
    PS: null,
  },
  {
    tag: '17.1',
    v1voc: 'རྒྱལ་བའི་སྲས་',
    v2voc: '佛子',
    v3voc: '佛子',
    v4voc: '-',
    v5voc: '佛子',
    PS: null,
  },
  {
    tag: '17.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ',
    v2voc: '菩薩',
    v3voc: '菩薩',
    v4voc: '族姓子、族姓女/菩薩',
    v5voc: '菩薩/行於大道者',
    PS: null,
  },
  {
    tag: '17.3',
    v1voc: 'སེམས་ཀྱི་ལས',
    v2voc: '心',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心所念',
    PS: '17.1',
  },
  {
    tag: '17.4',
    v1voc: 'ཡིད་ལ་བྱེད་པའི་སྦྱོར་བ་',
    v2voc: '善用',
    v3voc: '成就身、口、意業',
    v4voc: '言念相應',
    v5voc: '意所念道',
    PS: '17.1',
  },
  {
    tag: '17.6',
    v1voc: 'ཡོན་ཏན་གྱི་ཁྱད་པ',
    v2voc: '勝妙功德',
    v3voc: '勝妙功德',
    v4voc: '-',
    v5voc: '諸所施行功德',
    PS: '17.2',
  },
  {
    tag: '17.7',
    v1voc: 'འདི་དག་ཐམས་ཅད',
    v2voc: '一切',
    v3voc: '一切',
    v4voc: '悉',
    v5voc: '悉',
    PS: '17.2',
  },
  {
    tag: '17.8',
    v1voc: 'འཐོབ་པ',
    v2voc: '獲',
    v3voc: '能得',
    v4voc: '得',
    v5voc: '得',
    PS: '17.2',
  },
  {
    tag: '17.9',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས་ཐམས་ཅད',
    v2voc: '諸佛法',
    v3voc: '佛正法',
    v4voc: '-',
    v5voc: '諸所說經',
    PS: '17.3',
  },
  {
    tag: '17.10',
    v1voc: 'ཐོགས་པ་མེད་པའི་ལུས་སུ་འགྱུར་བ་',
    v2voc: '無所礙',
    v3voc: '無罣礙',
    v4voc: '(無得增減)',
    v5voc: '(悉諦受)',
    PS: '17.3',
  },
  {
    tag: '17.11',
    v1voc: 'སངས་རྒྱས་བཅོམ་ལྡན་འདས',
    v2voc: '諸佛',
    v3voc: '佛',
    v4voc: '-',
    v5voc: '佛',
    PS: '17.4',
  },
  {
    tag: '17.12',
    v1voc: 'འདས་པ་',
    v2voc: '去',
    v3voc: '去',
    v4voc: '-',
    v5voc: '過去',
    PS: '17.4',
  },
  {
    tag: '17.13',
    v1voc: 'མ་བྱོན་པ་<',
    v2voc: '來',
    v3voc: '來',
    v4voc: '-',
    v5voc: '當來',
    PS: '17.4',
  },
  {
    tag: '17.14',
    v1voc: 'ད་ལྟར་བྱུང་བ',
    v2voc: '今',
    v3voc: '今',
    v4voc: '-',
    v5voc: '今現在',
    PS: '17.4',
  },
  {
    tag: '17.15',
    v1voc: 'ལམ་དུ་འཇུག་པ',
    v2voc: '住.....道',
    v3voc: '….隨順轉',
    v4voc: '',
    v5voc: '受得之',
    PS: '17.4',
  },
  {
    tag: '17.17',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '世間',
    v5voc: '(世間人民)',
    PS: '17.5',
  },
  {
    tag: '17.18',
    v1voc: 'ཡོངས་སུ་མི་གཏོང་པ',
    v2voc: '恒不捨離',
    v3voc: '不捨',
    v4voc: '(念安)',
    v5voc: '使….悉安隱',
    PS: '17.5',
  },
  {
    tag: '17.19',
    v1voc: 'ཉེ་བར་གནས་པ',
    v2voc: '隨….住',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '17.5',
  },
  {
    tag: '17.21',
    v1voc: 'ཆོས་ཐམས་ཅད',
    v2voc: '諸法相',
    v3voc: '-',
    v4voc: '佛法教',
    v5voc: '諸所說經',
    PS: '17.6',
  },
  {
    tag: '17.22',
    v1voc: 'ཇི་ལྟ་བ་བཞིན་དུ',
    v2voc: '如',
    v3voc: '-',
    v4voc: '如',
    v5voc: '-',
    PS: '17.6',
  },
  {
    tag: '17.23',
    v1voc: 'རྣམ་པར་ལྟ་བ',
    v2voc: '通達',
    v3voc: '明達',
    v4voc: '必諦受學',
    v5voc: '悉諦受',
    PS: '17.6',
  },
  {
    tag: '17.24',
    v1voc: 'མི་དགེ་བའི་ཆོས་ཐམས་ཅད',
    v2voc: '一切惡',
    v3voc: '一切惡',
    v4voc: '-',
    v5voc: '諸所有宿命惡',
    PS: '17.7',
  },
  {
    tag: '17.25',
    v1voc: 'སྤངས / སྤངས་པ',
    v2voc: '斷',
    v3voc: '斷',
    v4voc: '-',
    v5voc: '悉消盡',
    PS: '17.7',
  },
  {
    tag: '17.26',
    v1voc: 'དགེ་བའི་ཆོས་ཐམས་ཅད',
    v2voc: '眾善',
    v3voc: '眾善',
    v4voc: '-',
    v5voc: '-',
    PS: '17.8',
  },
  {
    tag: '17.27',
    v1voc: 'ལྡན་པ',
    v2voc: '具足',
    v3voc: '具足',
    v4voc: '-',
    v5voc: '-',
    PS: '17.8',
  },
  {
    tag: '17.28',
    v1voc: 'ཀུན་ཏུ་བཟང/ ཀུན་ཏུ་བཟང་པོ',
    v2voc: '普賢',
    v3voc: '普賢',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.29',
    v1voc: 'ཞིང',
    v2voc: '如',
    v3voc: '悉如',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.30',
    v1voc: 'ཀུན་ཏུ་མཛེས་པ',
    v2voc: '色像第一',
    v3voc: '色像第一',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.31',
    v1voc: 'རྣམ་པའི་མཆོག་ཐམས་ཅད་དང་ལྡན་པ',
    v2voc: '一切行願，皆得具足',
    v3voc: '成就如來一切種智',
    v4voc: '-',
    v5voc: '諸經，悉受得之',
    PS: null,
  },
  {
    tag: '17.32',
    v1voc: 'ལྡན་པ',
    v2voc: '具足',
    v3voc: '成就',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.33',
    v1voc: 'ཆོས་ཐམས་ཅད་',
    v2voc: '一切法',
    v3voc: '一切法',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.34',
    v1voc: 'དབང་བསྒྱུར',
    v2voc: '(無不)自在',
    v3voc: '(悉得)自在',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.35',
    v1voc: 'སྲོག་ཆགས་ཐམས་ཅད',
    v2voc: '眾',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.36',
    v1voc: 'སྟོན་པ་གཉིས་པ',
    v2voc: '第二導師',
    v3voc: '第二尊導',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '17.38',
    v1voc: 'ཉེ་བར་གནས་པ',
    v2voc: '(悉能通達)',
    v3voc: '(明達)',
    v4voc: '(無得增減)',
    v5voc: '(悉諦受)',
    PS: '17.6',
  },
  {
    tag: '18.1',
    v1voc: 'ཀྱེ་རྒྱལ་བའི་སྲས་',
    v2voc: '佛子',
    v3voc: '佛子',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '18.2',
    v1voc: 'སེམས་ཀྱི་ལས་ཡིད་ལ་བྱེད་པའི་སྦྱོར་བ་གང་དང་ལྡན་པ',
    v2voc: '用心',
    v3voc: '（身、口、意業）',
    v4voc: '（正身，言、念相應，口習經典，心思可行，改往修來，不釋道意，積德累善，施恩不惓）',
    v5voc: '（持是身所行，有口所言，有心所念，有意所念道）',
    PS: null,
  },
  {
    tag: '18.3',
    v1voc: 'ཡོན་ཏན་ཀྱི་ཁྱད་པར་འདི་དག་ཐམས་ཅད་ཐོབ་པར་འགྱུར་བ',
    v2voc: '能獲一切勝妙功德',
    v3voc: '能得一切勝妙功德',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '18.5',
    v1voc: 'གང་ཞེ་ན',
    v2voc: '云何',
    v3voc: '何等',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '19.1',
    v1voc: 'ཀྱེ་རྒྱལ་བའི་སྲས་',
    v2voc: '佛子',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '19.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ་',
    v2voc: '菩薩',
    v3voc: '菩薩',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '19.3',
    v1voc: 'ཁྱིམ་གྱི་ནང་དུ་འདུག་པ',
    v2voc: '在家',
    v3voc: '在家',
    v4voc: '居家(奉戒)',
    v5voc: '居家法',
    PS: null,
  },
  {
    tag: '19.4',
    v1voc: 'འདུག་པ',
    v2voc: '在',
    v3voc: '在',
    v4voc: '居',
    v5voc: '居',
    PS: null,
  },
  {
    tag: '19.5',
    v1voc: 'རང་བཞིན',
    v2voc: '性',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '19',
  },
  {
    tag: '19.6',
    v1voc: 'ཤེས་པ',
    v2voc: '知',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '19',
  },
  {
    tag: '19.7',
    v1voc: 'ཁྱིམ་གྱི་ཐིབས་པོ་ཟིལ་གྱིས་མི་ནོན་པ',
    v2voc: '免其逼迫',
    v3voc: '捨離家難',
    v4voc: '貪欲意解',
    v5voc: '莫為愛欲所拘繫',
    PS: '19',
  },
  {
    tag: '19.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '19.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '19.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '19.11',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '19.12',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '20.1',
    v1voc: 'ཕ་མ',
    v2voc: '父母',
    v3voc: '父母',
    v4voc: '父母',
    v5voc: '父母',
    PS: null,
  },
  {
    tag: '20.2',
    v1voc: 'འགྲོགས་པ',
    v2voc: '孝事',
    v3voc: '孝事',
    v4voc: '孝事',
    v5voc: '孝順供養',
    PS: null,
  },
  {
    tag: '20.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '20.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '20.5',
    v1voc: 'སྐྱེ་བོ་ཐམས་ཅད',
    v2voc: '一切',
    v3voc: '一切',
    v4voc: '一切',
    v5voc: '十方天下人',
    PS: '20',
  },
  {
    tag: '20.6',
    v1voc: 'ཡོངས་སུ་བསྐྱབ་པ',
    v2voc: '護養',
    v3voc: '護養',
    v4voc: '護視',
    v5voc: '以當度脫',
    PS: '20',
  },
  {
    tag: '20.7',
    v1voc: 'སངས་རྒྱས',
    v2voc: '佛',
    v3voc: '-',
    v4voc: '佛(道)',
    v5voc: '佛(道)',
    PS: '20',
  },
  {
    tag: '20.8',
    v1voc: 'འགྲོགས་པ',
    v2voc: '善事',
    v3voc: '永得大安',
    v4voc: '使得佛道',
    v5voc: '(早得佛道)',
    PS: '20',
  },
  {
    tag: '20.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '20.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '20.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '20.12',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '21.1',
    v1voc: 'བུ་དང་བུ་མོ',
    v2voc: '妻子',
    v3voc: '妻子',
    v4voc: '妻子',
    v5voc: '妻子',
    PS: null,
  },
  {
    tag: '21.2',
    v1voc: 'འགྲོགས་པ',
    v2voc: '集會',
    v3voc: '集會',
    v4voc: '順教',
    v5voc: '共居',
    PS: null,
  },
  {
    tag: '21.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '21.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '21.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '21.6',
    v1voc: 'སྲེད་པ་',
    v2voc: '貪',
    v3voc: '愛獄',
    v4voc: '愛獄',
    v5voc: '愛欲',
    PS: '21',
  },
  {
    tag: '21.7',
    v1voc: 'ཤིན་ཏུ་བྲལ་བ',
    v2voc: '永離',
    v3voc: '出',
    v4voc: '令出…無',
    v5voc: '消去',
    PS: '21',
  },
  {
    tag: '21.8',
    v1voc: 'དགའ་བ་',
    v2voc: '親',
    v3voc: '戀慕心',
    v4voc: '戀慕心',
    v5voc: '',
    PS: '21',
  },
  {
    tag: '21.9',
    v1voc: 'མི་དགའ་བ་',
    v2voc: '怨',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '21',
  },
  {
    tag: '21.10',
    v1voc: 'རྣམ་པར་བྲལ་བ',
    v2voc: '(平等)',
    v3voc: '(無)',
    v4voc: '',
    v5voc: '-',
    PS: '21',
  },
  {
    tag: '21.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '21.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '21.13',
    v1voc: 'སེམས་བསྐྱེད',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '22.1',
    v1voc: 'འདོད་པའི་ཡོན་ཏན',
    v2voc: '五欲',
    v3voc: '五欲',
    v4voc: '五欲',
    v5voc: '所思',
    PS: null,
  },
  {
    tag: '22.2',
    v1voc: 'འགྲོགས་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '得',
    v5voc: '有',
    PS: null,
  },
  {
    tag: '22.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '22.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '22.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '22.6',
    v1voc: 'ཡོན་ཏན',
    v2voc: '(安隱)',
    v3voc: '功德',
    v4voc: '-',
    v5voc: '-',
    PS: '22',
  },
  {
    tag: '22.7',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '究竟',
    v3voc: '具足',
    v4voc: '(皆入清淨)',
    v5voc: '道極過度',
    PS: '22',
  },
  {
    tag: '22.8',
    v1voc: 'འདོད་པའི་གསལ་ཤིང',
    v2voc: '欲箭',
    v3voc: '貪惑',
    v4voc: '-',
    v5voc: '愛欲',
    PS: '22',
  },
  {
    tag: '22.9',
    v1voc: 'རྣམ་པར་སེལ་བ',
    v2voc: '拔除',
    v3voc: '捨離',
    v4voc: '無所著',
    v5voc: '脫於……中',
    PS: '22',
  },
  {
    tag: '22.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '22.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '22.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '23.1',
    v1voc: 'གླུ་དང་གར་དང་རོལ་མོ་དང་སིལ་སྙན',
    v2voc: '妓樂',
    v3voc: '妓樂',
    v4voc: '伎樂',
    v5voc: '相娛樂、作音樂',
    PS: '23',
  },
  {
    tag: '23.2',
    v1voc: 'འགྲོགས་པ',
    v2voc: '聚會',
    v3voc: '在',
    v4voc: '聚會',
    v5voc: '相…作',
    PS: null,
  },
  {
    tag: '23.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '23.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '23.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '23.6',
    v1voc: 'གར་མཁན',
    v2voc: '妓',
    v3voc: '法',
    v4voc: '歡喜',
    v5voc: '作音樂',
    PS: null,
  },
  {
    tag: '23.7',
    v1voc: 'ཚོན',
    v2voc: '非實',
    v3voc: '幻',
    v4voc: '',
    v5voc: '',
    PS: null,
  },
  {
    tag: '23.8',
    v1voc: 'ལྟ་བུ',
    v2voc: '-',
    v3voc: '如',
    v4voc: '-',
    v5voc: '如是',
    PS: null,
  },
  {
    tag: '23.9',
    v1voc: 'མཐོང/ མཐོང་བ',
    v2voc: '了',
    v3voc: '見',
    v4voc: '-',
    v5voc: '得聞',
    PS: null,
  },
  {
    tag: '23.12',
    v1voc: 'ཆོས་ཡང་དག་པར་འགྲོ་བའི་བརྗོད་པ་',
    v2voc: '以法自娛',
    v3voc: '(悉得)法樂',
    v4voc: '(悉得)法樂',
    v5voc: '聽受諸經，悉聞得，如是作音樂時欲聽聞',
    PS: '23',
  },
  {
    tag: '23.13',
    v1voc: 'རབ་ཏུ་ཐོབ / རབ་ཏུ་ཐོབ་པ',
    v2voc: '-',
    v3voc: '悉得',
    v4voc: '深入',
    v5voc: '得',
    PS: '23',
  },
  {
    tag: '23.14',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '23.15',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '23.16',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '24.1',
    v1voc: 'ཆུང་མའི་འཁོར་གྱི་ནང་ན་',
    v2voc: '宮室',
    v3voc: '房室',
    v4voc: '房室',
    v5voc: '妻子',
    PS: '24.1',
  },
  {
    tag: '24.2',
    v1voc: 'འདུག་པ',
    v2voc: '在',
    v3voc: '在',
    v4voc: '身在',
    v5voc: '恩愛',
    PS: '24.1',
  },
  {
    tag: '24.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '24.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '24.5',
    v1voc: 'འདོད་པའི་གསལ་ཤིང་',
    v2voc: '穢欲',
    v3voc: '欲穢',
    v4voc: '惡露',
    v5voc: '婬泆惡露',
    PS: '24.2',
  },
  {
    tag: '24.6',
    v1voc: 'དང་བྲལ་ཞིང་',
    v2voc: '永除',
    v3voc: '永離',
    v4voc: '(無有更樂)',
    v5voc: '棄捐',
    PS: '24.2',
  },
  {
    tag: '24.7',
    v1voc: 'འཕགས་པའི་ས',
    v2voc: '聖地',
    v3voc: '賢聖地',
    v4voc: '-',
    v5voc: '覺知入虛空中',
    PS: '24.2',
  },
  {
    tag: '24.8',
    v1voc: 'ཆུད་པ',
    v2voc: '入',
    v3voc: '入',
    v4voc: '-',
    v5voc: '(入)',
    PS: null,
  },
  {
    tag: '24.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '24.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '24.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '24.12',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '25.1',
    v1voc: 'རྒྱན',
    v2voc: '瓔珞',
    v3voc: '寶瓔珞',
    v4voc: '寶瓔珞',
    v5voc: '七寶',
    PS: null,
  },
  {
    tag: '25.2',
    v1voc: 'བརྒྱན་པ',
    v2voc: '著',
    v3voc: '著',
    v4voc: '著',
    v5voc: '著',
    PS: null,
  },
  {
    tag: '25.3',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '25.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '25.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '25.6',
    v1voc: 'སྲིད་པར་འབྱུང་བ་འཇིག་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '到真實處',
    v3voc: '度有無岸',
    v4voc: '無綺可意',
    v5voc: '得止休息',
    PS: '25',
  },
  {
    tag: '25.8',
    v1voc: 'ཁུར་བོར་བ',
    v2voc: '捨諸僞飾',
    v3voc: '捨離重擔',
    v4voc: '解去重擔',
    v5voc: '脫於重擔去',
    PS: '25',
  },
  {
    tag: '25.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '25.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '25.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '26.1',
    v1voc: 'ཁང་ཐོག',
    v2voc: '樓閣',
    v3voc: '樓閣',
    v4voc: '樓閣',
    v5voc: '樓上',
    PS: null,
  },
  {
    tag: '26.2',
    v1voc: 'ཕྱིན་པ',
    v2voc: '上昇',
    v3voc: '上',
    v4voc: '上',
    v5voc: '在',
    PS: null,
  },
  {
    tag: '26.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '26.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '26.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '26.6',
    v1voc: 'ཆོས་ཐམས་ཅད',
    v2voc: '一切',
    v3voc: '法',
    v4voc: '佛諸經',
    v5voc: '諸經',
    PS: '26',
  },
  {
    tag: '26.7',
    v1voc: 'ཁྱད་པ',
    v2voc: '徹',
    v3voc: '微妙',
    v4voc: '-',
    v5voc: '悉',
    PS: '26',
  },
  {
    tag: '26.8',
    v1voc: 'ཁོང་དུ་ཆུད/ ཁོང་དུ་ཆུད་པ',
    v2voc: '見',
    v3voc: '得',
    v4voc: '-',
    v5voc: '受',
    PS: '26',
  },
  {
    tag: '26.9',
    v1voc: 'ཆོས་ཀྱི་ཁང་སྟེང',
    v2voc: '正法樓',
    v3voc: '佛法堂',
    v4voc: '法堂',
    v5voc: '佛經講堂',
    PS: '26',
  },
  {
    tag: '26.10',
    v1voc: 'ཕྱིན་པ',
    v2voc: '昇',
    v3voc: '昇',
    v4voc: '昇',
    v5voc: '上',
    PS: null,
  },
  {
    tag: '26.10',
    v1voc: 'ཕྱིན་པ',
    v2voc: '能捨',
    v3voc: '昇',
    v4voc: '昇',
    v5voc: '上',
    PS: null,
  },
  {
    tag: '26.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '26.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '26.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念 ',
    PS: null,
  },
  {
    tag: '27.1',
    v1voc: 'སྦྱིན་པ་གཏོང་བ',
    v2voc: '有所施',
    v3voc: '布施所珍',
    v4voc: '布施所有',
    v5voc: '布施',
    PS: null,
  },
  {
    tag: '27.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '27.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '27.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '27.5',
    v1voc: 'བདག་གིར་བྱ་བ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '27',
  },
  {
    tag: '27.6',
    v1voc: 'ཡོངས་སུ་འཛིན་པ',
    v2voc: '愛著',
    v3voc: '貪著',
    v4voc: '慳貪',
    v5voc: '貪愛',
    PS: '27',
  },
  {
    tag: '27.7',
    v1voc: 'སེམས',
    v2voc: '心',
    v3voc: '心',
    v4voc: '-',
    v5voc: '-',
    PS: '27',
  },
  {
    tag: '27.8',
    v1voc: 'མེད',
    v2voc: '無',
    v3voc: '無',
    v4voc: '莫墮',
    v5voc: '無有',
    PS: '27',
  },
  {
    tag: '27.9',
    v1voc: 'བདག་གི་ཐམས་ཅད་',
    v2voc: '一切',
    v3voc: '一切',
    v4voc: '-',
    v5voc: '諸所有',
    PS: '27',
  },
  {
    tag: '27.10',
    v1voc: 'ཡོངས་སུ་གཏོང་བ',
    v2voc: '能捨',
    v3voc: '悉捨',
    v4voc: '-',
    v5voc: '欲施',
    PS: '27',
  },
  {
    tag: '27.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '27.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '27.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '28.1',
    v1voc: 'མ་བྲལ་ཞིང་འགྲོགས་པ',
    v2voc: '衆會聚集',
    v3voc: '在聚會',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '28.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '28.3',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '28.4',
    v1voc: 'ཐམས་ཅད་མཁྱེན་པ་ཉིད',
    v2voc: '一切智',
    v3voc: '如來處',
    v4voc: '-',
    v5voc: '-',
    PS: '28',
  },
  {
    tag: '28.5',
    v1voc: 'འཐར་ཕྱིན',
    v2voc: '成',
    v3voc: '到',
    v4voc: '-',
    v5voc: '-',
    PS: '28',
  },
  {
    tag: '28.6',
    v1voc: 'འདུ་བ',
    v2voc: '衆聚法',
    v3voc: '解脫',
    v4voc: '-',
    v5voc: '-',
    PS: '28',
  },
  {
    tag: '28.7',
    v1voc: 'ཤིན་ཏུ་བྲལ་བ',
    v2voc: '捨',
    v3voc: '究竟',
    v4voc: '-',
    v5voc: '-',
    PS: '28',
  },
  {
    tag: '28.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '28.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '28.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '28.11',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.1',
    v1voc: 'བཙོན་ར་ལ་ཁ་ན་མ་ཐོ་བ་མཐོང་བ',
    v2voc: '在厄難',
    v3voc: '在危難',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.3',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.4',
    v1voc: 'གནས་མེད་པ་ལ་སྤྱོད',
    v2voc: '所行無礙',
    v3voc: '無所罣礙',
    v4voc: '-',
    v5voc: '-',
    PS: '29',
  },
  {
    tag: '29.6',
    v1voc: 'གང་དུ་དགའ་བར་འདོང་བ',
    v2voc: '隨意自在',
    v3voc: '隨意自在',
    v4voc: '-',
    v5voc: '-',
    PS: '29',
  },
  {
    tag: '29.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '29.11',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '30.1',
    v1voc: 'ཁྱིམ',
    v2voc: '家',
    v3voc: '(家)',
    v4voc: '家',
    v5voc: '家中',
    PS: null,
  },
  {
    tag: '30.2',
    v1voc: 'ཁྱིམ་ནས་ཁྱིམ་མེད་པར་འབྱུང་བ',
    v2voc: '捨(居家)',
    v3voc: '以信捨家',
    v4voc: '患厭(家)',
    v5voc: '患厭(家)',
    PS: null,
  },
  {
    tag: '30.4',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '30.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '30.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '30.7',
    v1voc: 'སེམས',
    v2voc: '心',
    v3voc: '心',
    v4voc: '-',
    v5voc: '心',
    PS: '30',
  },
  {
    tag: '30.8',
    v1voc: 'བཅིངས་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '拘綴',
    v5voc: '拘',
    PS: '30',
  },
  {
    tag: '30.9',
    v1voc: 'གྲོལ་བ',
    v2voc: '解脫',
    v3voc: '-',
    v4voc: '解脫',
    v5voc: '脫解',
    PS: '30',
  },
  {
    tag: '30.10',
    v1voc: 'ཆགས་པ་མེད / ཆགས་པ་མེད་པ',
    v2voc: '無礙',
    v3voc: '(心)無所著',
    v4voc: '無所(拘綴)',
    v5voc: '無所復拘著',
    PS: null,
  },
  {
    tag: '30.11',
    v1voc: 'མི་དགོས་པ་དང་བྲལ་བ',
    v2voc: '出家',
    v3voc: '棄捨世業',
    v4voc: '疾得解脫',
    v5voc: '早得脫解',
    PS: null,
  },
  {
    tag: '30.13',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '30.14',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '30.15',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '31.1',
    v1voc: 'དགེ་འདུན་གྱི་ར་བའི་མཚམས',
    v2voc: '僧伽藍',
    v3voc: '僧坊',
    v4voc: '佛宗廟',
    v5voc: '佛寺',
    PS: null,
  },
  {
    tag: '31.2',
    v1voc: 'འདའ་བ',
    v2voc: '入',
    v3voc: '入',
    v4voc: '入',
    v5voc: '到',
    PS: null,
  },
  {
    tag: '31.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '31.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '31.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '31.6',
    v1voc: 'འགལ་བ་མེད་པ',
    v2voc: '無乖諍',
    v3voc: '無限礙',
    v4voc: '無復罣礙',
    v5voc: '無所復罣礙',
    PS: '31',
  },
  {
    tag: '31.7',
    v1voc: 'ཆོས',
    v2voc: '(善)法',
    v3voc: '（心）',
    v4voc: '法',
    v5voc: '諸經',
    PS: '31',
  },
  {
    tag: '31.8',
    v1voc: 'མཐུན་པར་འགྲོ་བ',
    v2voc: '演說',
    v3voc: '和合',
    v4voc: '近佛行',
    v5voc: '但念佛，悉入',
    PS: '31',
  },
  {
    tag: '31.9',
    v1voc: '(མཐུན་པར་འགྲོ་བ་)མང་པོ་དང་ལྡན་པ',
    v2voc: '種種',
    v3voc: '一切',
    v4voc: '-',
    v5voc: '-',
    PS: '31',
  },
  {
    tag: '31.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '31.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '31.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '32.1',
    v1voc: 'མཁན་པོ་དང་སློབ་དཔོན',
    v2voc: '大小師',
    v3voc: '大小師',
    v4voc: '師友',
    v5voc: '師和上',
    PS: null,
  },
  {
    tag: '32.2',
    v1voc: 'དྲུང་དུ་འགྲོ་བ',
    v2voc: '詣',
    v3voc: '詣',
    v4voc: '詣',
    v5voc: '至',
    PS: null,
  },
  {
    tag: '32.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '32.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '32.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '32.6',
    v1voc: 'ཆོས',
    v2voc: '善法',
    v3voc: '法要',
    v4voc: '',
    v5voc: '正經',
    PS: '32',
  },
  {
    tag: '32.7',
    v1voc: 'རྩོམ',
    v2voc: '習行',
    v3voc: '深入',
    v4voc: '入',
    v5voc: '入',
    PS: '32',
  },
  {
    tag: '32.8',
    v1voc: 'ཆོ་ག་ལ་མཁས་པ',
    v2voc: '巧事師長',
    v3voc: '開方便門',
    v4voc: '',
    v5voc: '-',
    PS: '32',
  },
  {
    tag: '32.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '32.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '32.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '33.1',
    v1voc: 'རབ་ཏུ་བྱང་བ',
    v2voc: '出家',
    v3voc: '出家',
    v4voc: '捨罪',
    v5voc: '作沙門',
    PS: null,
  },
  {
    tag: '33.2',
    v1voc: 'གསོལ་བ',
    v2voc: '求請',
    v3voc: '求',
    v4voc: '請求',
    v5voc: '索',
    PS: null,
  },
  {
    tag: '33.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '33.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '33.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '33.6',
    v1voc: 'བར་ཆད་མེད་',
    v2voc: '無障礙',
    v3voc: '無障礙',
    v4voc: '得成就志',
    v5voc: '所至到，悉令得成就',
    PS: '33',
  },
  {
    tag: '33.8',
    v1voc: 'མི་ལྡོག་པའི་ཆོས་ཅན',
    v2voc: '得不退法',
    v3voc: '得不退轉',
    v4voc: '學不中悔',
    v5voc: '莫復中悔止',
    PS: '33',
  },
  {
    tag: '33.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '33.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '33.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '34.1',
    v1voc: 'གོས་དཀར་པོ',
    v2voc: '俗服',
    v3voc: '俗服',
    v4voc: '白衣',
    v5voc: '白衣',
    PS: null,
  },
  {
    tag: '34.2',
    v1voc: '-',
    v2voc: '脫去',
    v3voc: '脫去',
    v4voc: '脫去',
    v5voc: '去',
    PS: null,
  },
  {
    tag: '34.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '34.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '34.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '34.6',
    v1voc: 'སྡིག་པ',
    v2voc: '罪軛',
    v3voc: '懈怠',
    v4voc: '懈怠',
    v5voc: '懈怠',
    PS: '34',
  },
  {
    tag: '34.7',
    v1voc: 'བརྩོན་པ་སྤངས་',
    v2voc: '捨',
    v3voc: '無復',
    v4voc: '無有',
    v5voc: '莫令有',
    PS: '34',
  },
  {
    tag: '34.9',
    v1voc: 'དགེ་བའི་རྩ་བ',
    v2voc: '善根',
    v3voc: '德',
    v4voc: '(解道修)德',
    v5voc: '功德',
    PS: '34',
  },
  {
    tag: '34.10',
    v1voc: 'ཤིན་ཏུ་སྦྱངས་པ',
    v2voc: '勤修',
    v3voc: '修',
    v4voc: '修',
    v5voc: '極照明於',
    PS: '34',
  },
  {
    tag: '34.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '34.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '34.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '35.1',
    v1voc: 'སྐྲ་དང་ཁ་སྤུ',
    v2voc: '鬚髮',
    v3voc: '鬚髮',
    v4voc: '鬚髮',
    v5voc: '頭髮',
    PS: null,
  },
  {
    tag: '35.2',
    v1voc: 'འབྲེག་པ',
    v2voc: '剃除',
    v3voc: '剃除',
    v4voc: '除剔',
    v5voc: '剃',
    PS: null,
  },
  {
    tag: '35.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '35.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '35.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '35.6',
    v1voc: 'ཤིན་ཏུ་མཉམ་པར་བཞག་',
    v2voc: '究竟寂滅',
    v3voc: '究竟寂滅',
    v4voc: '除捐飾好',
    v5voc: '莫復與共會',
    PS: '35',
  },
  {
    tag: '35.7',
    v1voc: 'ཉོན་མོངས་པ་མེད་པ',
    v2voc: '永離煩惱',
    v3voc: '斷除煩惱',
    v4voc: '無有衆勞',
    v5voc: '垢濁，悉除去',
    PS: '35',
  },
  {
    tag: '35.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '35.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '35.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '36.2',
    v1voc: 'གོས་ངུར་སྨྲིག',
    v2voc: '袈裟衣',
    v3voc: '袈裟',
    v4voc: '袈裟',
    v5voc: '袈裟',
    PS: null,
  },
  {
    tag: '36.3',
    v1voc: 'གྱོན་པ',
    v2voc: '著',
    v3voc: '受著',
    v4voc: '受著',
    v5voc: '受',
    PS: null,
  },
  {
    tag: '36.4',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '36.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '36.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '36.7',
    v1voc: 'དྲང་སྲོང་ཆེན་པོའི་སེམས་',
    v2voc: '大仙道',
    v3voc: '心得歡喜',
    v4voc: '被法服行',
    v5voc: '心如佛',
    PS: '36',
  },
  {
    tag: '36.8',
    v1voc: 'དང་ལྡན་ཞིང',
    v2voc: '具',
    v3voc: '得',
    v4voc: '-',
    v5voc: '持',
    PS: '36',
  },
  {
    tag: '36.9',
    v1voc: 'རྙོག་པ',
    v2voc: '染',
    v3voc: '三毒',
    v4voc: '沾汙',
    v5voc: '沾汙',
    PS: '36',
  },
  {
    tag: '36.10',
    v1voc: 'མེད་པ',
    v2voc: '無',
    v3voc: '捨離',
    v4voc: '無',
    v5voc: '無所',
    PS: '36',
  },
  {
    tag: '36.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '36.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '36.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '37.1',
    v1voc: 'རབ་ཏུ་འབྱུང་བ',
    v2voc: '正出家',
    v3voc: '受出家法',
    v4voc: '作沙門',
    v5voc: '作沙門',
    PS: null,
  },
  {
    tag: '37.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '37.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '37.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '37.5',
    v1voc: 'སྐྱེ་བོ་ཐམས་ཅད',
    v2voc: '一切',
    v3voc: '一切',
    v4voc: '天下',
    v5voc: '十方天下人',
    PS: '37',
  },
  {
    tag: '37.6',
    v1voc: 'ཡོངས་སུ་སྐྱོང་བ',
    v2voc: '救護',
    v3voc: '開導',
    v4voc: '開導',
    v5voc: '悉度',
    PS: '37',
  },
  {
    tag: '37.7',
    v1voc: 'དེ་བཞིན་གཤེགས་པ',
    v2voc: '佛',
    v3voc: '佛',
    v4voc: '(佛)',
    v5voc: '佛',
    PS: '37',
  },
  {
    tag: '37.8',
    v1voc: 'རབ་ཏུ་འབྱུང་བ',
    v2voc: '出家',
    v3voc: '出家',
    v4voc: '受行佛意',
    v5voc: '作沙門',
    PS: '37',
  },
  {
    tag: '37.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '37.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '37.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '38.1',
    v1voc: 'སངས་རྒྱས',
    v2voc: '佛',
    v3voc: '佛',
    v4voc: '佛',
    v5voc: '佛',
    PS: null,
  },
  {
    tag: '38.2',
    v1voc: 'སྐྱབས་སུ་འགྲོ་བ',
    v2voc: '歸',
    v3voc: '歸',
    v4voc: '歸',
    v5voc: '歸',
    PS: null,
  },
  {
    tag: '38.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '38.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '38.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '38.6',
    v1voc: 'དགེ་བ་ལ་མོས་པ',
    v2voc: '無上意',
    v3voc: '無上意',
    v4voc: '無上意',
    v5voc: '(悉生)極好處',
    PS: '38',
  },
  {
    tag: '38.7',
    v1voc: 'མངོན་པར་སྐྱེས་པ',
    v2voc: '發',
    v3voc: '發',
    v4voc: '發',
    v5voc: '悉生',
    PS: '38',
  },
  {
    tag: '38.8',
    v1voc: 'སངས་རྒྱས་ཀྱི་གདུང',
    v2voc: '佛種',
    v3voc: '大道',
    v4voc: '大道',
    v5voc: '佛法',
    PS: '38',
  },
  {
    tag: '38.9',
    v1voc: 'མི་འཆད་པའི་དོན་དུབརྩོན་པ',
    v2voc: '紹隆',
    v3voc: '體解',
    v4voc: '體解',
    v5voc: '歡樂於(佛法)',
    PS: '38',
  },
  {
    tag: '38.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '38.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '38.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '39.1',
    v1voc: 'ཆོས་',
    v2voc: '法',
    v3voc: '法',
    v4voc: '法',
    v5voc: '經',
    PS: null,
  },
  {
    tag: '39.2',
    v1voc: 'སྐྱབས་སུ་འགྲོ་བ',
    v2voc: '歸',
    v3voc: '歸',
    v4voc: '歸',
    v5voc: '歸',
    PS: null,
  },
  {
    tag: '39.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '39.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '39.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '39.6',
    v1voc: 'ཆོས་ཀྱི་གཏེར',
    v2voc: '經藏',
    v3voc: '經藏',
    v4voc: '經藏',
    v5voc: '經藏',
    PS: '39',
  },
  {
    tag: '39.7',
    v1voc: 'རབ་ཏུ་ཐོབ / རབ་ཏུ་ཐོབ་པ',
    v2voc: '深入',
    v3voc: '深入',
    v4voc: '深入',
    v5voc: '得深',
    PS: '39',
  },
  {
    tag: '39.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '39.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '39.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '39.11',
    v1voc: '-',
    v2voc: '智慧如海',
    v3voc: '智慧如海',
    v4voc: '智慧如海',
    v5voc: '所得智慧如大海',
    PS: null,
  },
  {
    tag: '40.1',
    v1voc: 'དགེ་འདུན',
    v2voc: '僧',
    v3voc: '僧',
    v4voc: '僧',
    v5voc: '僧',
    PS: null,
  },
  {
    tag: '40.2',
    v1voc: 'སྐྱབས་སུ་འགྲོ་བ',
    v2voc: '歸',
    v3voc: '歸',
    v4voc: '歸',
    v5voc: '歸',
    PS: null,
  },
  {
    tag: '40.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '40.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '40.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '40.6',
    v1voc: 'ཆགས་པའི་གནས',
    v2voc: '礙',
    v3voc: '礙',
    v4voc: '-',
    v5voc: '-',
    PS: '40',
  },
  {
    tag: '40.7',
    v1voc: 'བྲལ/ བྲལ་བ',
    v2voc: '無',
    v3voc: '無',
    v4voc: '-',
    v5voc: '-',
    PS: '40',
  },
  {
    tag: '40.8',
    v1voc: 'དགེ་འདུན',
    v2voc: '大衆',
    v3voc: '大衆',
    v4voc: '聖眾',
    v5voc: '比丘僧',
    PS: '40',
  },
  {
    tag: '40.9',
    v1voc: 'ཡོངས་སུ་སྡུད་པ',
    v2voc: '統理',
    v3voc: '統理',
    v4voc: '依附',
    v5voc: '依度',
    PS: '40',
  },
  {
    tag: '40.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '40.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '40.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '41.1',
    v1voc: 'བསླབ་པའི་ཚིག',
    v2voc: '戒',
    v3voc: '戒',
    v4voc: '道禁',
    v5voc: '戒',
    PS: null,
  },
  {
    tag: '41.2',
    v1voc: 'ཡང་དག་པར་ལེན་པ',
    v2voc: '受學',
    v3voc: '受持',
    v4voc: '守護',
    v5voc: '持',
    PS: null,
  },
  {
    tag: '41.3',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '41.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '41.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '41.6',
    v1voc: 'ཚུལ་བཟང་པོ་ལ་ཡང་དག་པར་སྤྱོད་ཅིང་',
    v2voc: '不作衆惡',
    v3voc: '具足修習',
    v4voc: '不犯法教',
    v5voc: '莫令犯如法',
    PS: '41',
  },
  {
    tag: '41.8',
    v1voc: 'བསླབ་པ་ཐམས་ཅད་',
    v2voc: '戒',
    v3voc: '一切戒',
    v4voc: '法律',
    v5voc: '禁戒',
    PS: '41',
  },
  {
    tag: '41.9',
    v1voc: 'ཤིན་ཏུ་སློབ་པ',
    v2voc: '善學',
    v3voc: '學',
    v4voc: '皆奉',
    v5voc: '護持',
    PS: '41',
  },
  {
    tag: '41.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '41.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '41.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '42.1',
    v1voc: 'སློབ་དཔོན',
    v2voc: '闍梨',
    v3voc: '道禁',
    v4voc: '大小師',
    v5voc: '師',
    PS: null,
  },
  {
    tag: '42.2',
    v1voc: 'བསྟན་པ',
    v2voc: '受……教',
    v3voc: '受行',
    v4voc: '受',
    v5voc: '受',
    PS: null,
  },
  {
    tag: '42.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '42.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '42.5',
    v1voc: 'ལོག་པ་མ་ཡིན་པའི་ལས་ལ་སྤྱོད',
    v2voc: '(所行)真實',
    v3voc: '(修)如實業',
    v4voc: '(所受)不忘',
    v5voc: '(所作)悉為狎習',
    PS: '42',
  },
  {
    tag: '42.6',
    v1voc: 'སྤྱོད',
    v2voc: '所行',
    v3voc: '修',
    v4voc: '所受',
    v5voc: '所作',
    PS: '42',
  },
  {
    tag: '42.7',
    v1voc: 'ཚུལ་དང་སྤྱོད་ཡུལ',
    v2voc: '威儀',
    v3voc: '道戒',
    v4voc: '佛聖教',
    v5voc: '如所教法',
    PS: '42',
  },
  {
    tag: '42.8',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '具足',
    v3voc: '具足',
    v4voc: '承',
    v5voc: '持不失',
    PS: '42',
  },
  {
    tag: '42.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '42.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '42.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '42.12',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '43.1',
    v1voc: 'མཁན་པོ',
    v2voc: '和上',
    v3voc: '和上',
    v4voc: '和上',
    v5voc: '和上',
    PS: null,
  },
  {
    tag: '43.2',
    v1voc: 'བསྟན་པ',
    v2voc: '受….教',
    v3voc: '請',
    v4voc: '受',
    v5voc: '受',
    PS: null,
  },
  {
    tag: '43.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '43.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人 ',
    PS: null,
  },
  {
    tag: '43.5',
    v1voc: 'གནས་མེད་པ་',
    v2voc: '無依處',
    v3voc: '-',
    v4voc: '解脫',
    v5voc: '無所一罣礙',
    PS: '43',
  },
  {
    tag: '43.6',
    v1voc: 'ཡང་དག་པར་གཞོལ་',
    v2voc: '到',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '43',
  },
  {
    tag: '43.7',
    v1voc: 'མི་སྐྱེ་བའི་ཡེ་ཤེས་',
    v2voc: '無生智',
    v3voc: '無生智',
    v4voc: '禪意',
    v5voc: '念所知禪',
    PS: '43',
  },
  {
    tag: '43.8',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '入',
    v3voc: '到於彼岸',
    v4voc: '-',
    v5voc: '極過度',
    PS: '43',
  },
  {
    tag: '43.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '43.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '43.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '43.12',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '44.1',
    v1voc: 'བསྙེན་པར་རྫོགས་པ',
    v2voc: '受具足戒',
    v3voc: '受具足戒',
    v4voc: '受成就戒',
    v5voc: '作大沙門',
    PS: null,
  },
  {
    tag: '44.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '44.3',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '44.4',
    v1voc: 'ཆོས་ཐམས་ཅད་',
    v2voc: '勝法',
    v3voc: '法',
    v4voc: '道',
    v5voc: '經',
    PS: '44',
  },
  {
    tag: '44.5',
    v1voc: 'ཁྱད་པ',
    v2voc: '最(勝)',
    v3voc: '勝妙',
    v4voc: '方便',
    v5voc: '-',
    PS: '44',
  },
  {
    tag: '44.6',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་',
    v2voc: '得',
    v3voc: '得',
    v4voc: '得',
    v5voc: '-',
    PS: '44',
  },
  {
    tag: '44.7',
    v1voc: 'ཐབས་མཁས་པ',
    v2voc: '方便',
    v3voc: '方便',
    v4voc: '-',
    v5voc: '漚和拘舍羅',
    PS: '44',
  },
  {
    tag: '44.8',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '具諸',
    v3voc: '成就',
    v4voc: '慧度無極',
    v5voc: '波羅蜜',
    PS: null,
  },
  {
    tag: '44.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '44.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '44.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '44.12',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '45.1',
    v1voc: 'གཙུག་ལག་ཁང',
    v2voc: '堂宇',
    v3voc: '房舍',
    v4voc: '室',
    v5voc: '室中',
    PS: null,
  },
  {
    tag: '45.2',
    v1voc: 'འགྲོ /འགྲོ་བ',
    v2voc: '入',
    v3voc: '入',
    v4voc: '入',
    v5voc: '入',
    PS: null,
  },
  {
    tag: '45.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '45.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '45.5',
    v1voc: 'མི་འཕྲོགས་པའི་ཆོས་ཅན་དུ་གྱུར་ཏེ་',
    v2voc: '安住不動',
    v3voc: '得不退法',
    v4voc: '得止觀意',
    v5voc: '佛所止處',
    PS: '45',
  },
  {
    tag: '45.7',
    v1voc: 'བླ་ན་མེད་པའི་གནས',
    v2voc: '無上堂',
    v3voc: '無上堂',
    v4voc: '-',
    v5voc: '所居止處',
    PS: '45',
  },
  {
    tag: '45.8',
    v1voc: 'རྣམ་པར་སྤྱོད་པ',
    v2voc: '昇',
    v3voc: '昇',
    v4voc: '-',
    v5voc: '-',
    PS: '45',
  },
  {
    tag: '45.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '45.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '45.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '45.12',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '46.1',
    v1voc: 'སྟན',
    v2voc: '牀座',
    v3voc: '牀座',
    v4voc: '床',
    v5voc: '床',
    PS: null,
  },
  {
    tag: '46.2',
    v1voc: 'གདིང་བ',
    v2voc: '敷',
    v3voc: '敷',
    v4voc: '敷',
    v5voc: '敷',
    PS: null,
  },
  {
    tag: '46.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '46.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '46.5',
    v1voc: 'ཆོས་ཇི་ལྟ་བ་བཞིན་དུ་མཐོང',
    v2voc: '(見)真實相',
    v3voc: '(見)真實相',
    v4voc: '天下',
    v5voc: '(悉視)十方人虛空',
    PS: '46',
  },
  {
    tag: '46.6',
    v1voc: 'མཐོང/ མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '視',
    PS: '46',
  },
  {
    tag: '46.7',
    v1voc: 'ལེགས་པར་བཀོད་པ',
    v2voc: '開敷',
    v3voc: '敷',
    v4voc: '入',
    v5voc: '早入至',
    PS: '46',
  },
  {
    tag: '46.9',
    v1voc: 'ཆོས་ཅན',
    v2voc: '善法',
    v3voc: '善法',
    v4voc: '大乘道',
    v5voc: '深經中',
    PS: '46',
  },
  {
    tag: '46.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '46.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '46.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '46.13',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '47.1',
    v1voc: 'འདུག་པ',
    v2voc: '正身端坐',
    v3voc: '正身端坐',
    v4voc: '宴坐',
    v5voc: '坐',
    PS: null,
  },
  {
    tag: '47.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '47.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '47.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '47.5',
    v1voc: 'མི་གནས་པའི་སེམས',
    v2voc: '心無所著',
    v3voc: '心無所倚',
    v4voc: '心無所猗',
    v5voc: '莫令心有所著',
    PS: '47',
  },
  {
    tag: '47.6',
    v1voc: 'སྙིང་པོ་བྱང་ཆུབ',
    v2voc: '菩提座',
    v3voc: '佛道樹',
    v4voc: '佛道樹',
    v5voc: '師子座',
    PS: '47',
  },
  {
    tag: '47.7',
    v1voc: 'འདུག་པ',
    v2voc: '坐',
    v3voc: '坐',
    v4voc: '坐',
    v5voc: '坐於',
    PS: '47',
  },
  {
    tag: '47.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '47.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '47.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '48.1',
    v1voc: 'སྐྱིལ་མོ་ཀྲུང',
    v2voc: '跏趺坐',
    v3voc: '跏趺坐',
    v4voc: '-',
    v5voc: '正坐',
    PS: null,
  },
  {
    tag: '48.2',
    v1voc: 'འཆའ་བ',
    v2voc: '結',
    v3voc: '結',
    v4voc: '-',
    v5voc: '',
    PS: null,
  },
  {
    tag: '48.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '48.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '48.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '48.6',
    v1voc: 'མི་གཡོ་བའི་ས',
    v2voc: '不動地',
    v3voc: '不動地',
    v4voc: '-',
    v5voc: '無令有狐疑，增減佛經中',
    PS: '48',
  },
  {
    tag: '48.7',
    v1voc: 'དགེ་བའི་རྩ་བ',
    v2voc: '善根',
    v3voc: '善根',
    v4voc: '-',
    v5voc: '正功德',
    PS: '48',
  },
  {
    tag: '48.8',
    v1voc: 'ཤིན་ཏུ་བརྟན / ཤིན་ཏུ་བརྟན་པ',
    v2voc: '堅固',
    v3voc: '堅固',
    v4voc: '-',
    v5voc: '-',
    PS: '48',
  },
  {
    tag: '48.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '48.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '48.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '49.1',
    v1voc: 'ཞི་གནས',
    v2voc: '定',
    v3voc: '三昧',
    v4voc: '數息',
    v5voc: '喘息',
    PS: null,
  },
  {
    tag: '49.2',
    v1voc: 'ཡོངས་སུ་སྦྱོང་བར་བྱེད་པ',
    v2voc: '修行',
    v3voc: '正受',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '49.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '49.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '49.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '49.6',
    v1voc: 'མ་ལུས་པ',
    v2voc: '無餘',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '49',
  },
  {
    tag: '49.7',
    v1voc: 'མཐར་ཐུག་པ',
    v2voc: '究竟',
    v3voc: '究竟',
    v4voc: '-',
    v5voc: '-',
    PS: '49',
  },
  {
    tag: '49.8',
    v1voc: 'ཞི་བ',
    v2voc: '以定',
    v3voc: '定',
    v4voc: '-',
    v5voc: '喘息定/止足',
    PS: '49',
  },
  {
    tag: '49.9',
    v1voc: 'དུལ/ དུལ་བ',
    v2voc: '伏心',
    v3voc: '向三昧門',
    v4voc: '得捨家中，無世間念',
    v5voc: '-',
    PS: '49',
  },
  {
    tag: '49.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '49.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '49.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '50.1',
    v1voc: 'ལྷག་མཐོང',
    v2voc: '觀',
    v3voc: '觀察',
    v4voc: '-',
    v5voc: '觀',
    PS: null,
  },
  {
    tag: '50.2',
    v1voc: 'ཡོངས་སུ་སྦྱོང་བ་བྱེད་པ',
    v2voc: '修',
    v3voc: '諸法',
    v4voc: '-',
    v5voc: '佪念',
    PS: null,
  },
  {
    tag: '50.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '50.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '50.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '50.6',
    v1voc: 'ཉོན་མོངས་པ་མེད་པ',
    v2voc: '無乖諍',
    v3voc: '無所罣礙',
    v4voc: '-',
    v5voc: '當作是念',
    PS: '50',
  },
  {
    tag: '50.7',
    v1voc: 'ཆོས་',
    v2voc: '理',
    v3voc: '法',
    v4voc: '-',
    v5voc: '無常法',
    PS: '50',
  },
  {
    tag: '50.8',
    v1voc: 'ཡང་དག་པ་ཇི་ལྟ་བ་བཞིན་དུ་',
    v2voc: '如實',
    v3voc: '真實',
    v4voc: '-',
    v5voc: '-',
    PS: '50',
  },
  {
    tag: '50.9',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '50.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '50.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '50.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '51.1',
    v1voc: 'སྐྱིལ་མོ་ཀྲུང་',
    v2voc: '跏趺坐',
    v3voc: '跏趺坐',
    v4voc: '-',
    v5voc: '坐',
    PS: null,
  },
  {
    tag: '51.2',
    v1voc: 'འཇིག་པ',
    v2voc: '捨',
    v3voc: '捨',
    v4voc: '-',
    v5voc: '起',
    PS: null,
  },
  {
    tag: '51.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '51.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '51.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '51.6',
    v1voc: 'འདུ་བྱེད་ཐམས་ཅད',
    v2voc: '諸行法',
    v3voc: '諸行',
    v4voc: '-',
    v5voc: '虛空法',
    PS: '51',
  },
  {
    tag: '51.7',
    v1voc: 'རང་བཞིན',
    v2voc: '-',
    v3voc: '性',
    v4voc: '-',
    v5voc: '-',
    PS: '51',
  },
  {
    tag: '51.8',
    v1voc: 'འཇིག་པ',
    v2voc: '散滅',
    v3voc: '散滅',
    v4voc: '-',
    v5voc: '-',
    PS: '51',
  },
  {
    tag: '51.9',
    v1voc: 'རྣམ་པར་མཐོང་བ',
    v2voc: '觀',
    v3voc: '知',
    v4voc: '-',
    v5voc: '無有不了知者',
    PS: '51',
  },
  {
    tag: '51.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '51.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '51.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '52.1',
    v1voc: 'རྐང་མཐིལ',
    v2voc: '足',
    v3voc: '足',
    v4voc: '',
    v5voc: '足',
    PS: null,
  },
  {
    tag: '52.2',
    v1voc: 'གཞོག་པ',
    v2voc: '下',
    v3voc: '下',
    v4voc: '下床',
    v5voc: '蹈地',
    PS: null,
  },
  {
    tag: '52.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '52.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '52.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '52.6',
    v1voc: 'སེམས',
    v2voc: '心意',
    v3voc: '-',
    v4voc: '心',
    v5voc: '心',
    PS: '52',
  },
  {
    tag: '52.7',
    v1voc: 'རྣམ་པར་གྲོལ་བ',
    v2voc: '解脫',
    v3voc: '解脫',
    v4voc: '-',
    v5voc: '住安隱',
    PS: '52',
  },
  {
    tag: '52.8',
    v1voc: 'མི་འཁྲུགས་པ',
    v2voc: '不動',
    v3voc: '不動',
    v4voc: '不動搖',
    v5voc: '不復動搖',
    PS: '52',
  },
  {
    tag: '52.9',
    v1voc: 'རབ་ཏུ་གནས་པ',
    v2voc: '安住',
    v3voc: '履踐聖跡',
    v4voc: '履踐佛跡',
    v5voc: '(住安隱)',
    PS: '52',
  },
  {
    tag: '52.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '52.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '52.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '53.1',
    v1voc: 'རྐང་མཐིལ་',
    v2voc: '足',
    v3voc: '足',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.2',
    v1voc: 'འདེགས་པ',
    v2voc: '擧',
    v3voc: '擧',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '時',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.6',
    v1voc: 'ཁ་ན་མ་ཐོ་བ་མེད་པ་',
    v2voc: '眾善法',
    v3voc: '善法',
    v4voc: '-',
    v5voc: '-',
    PS: '53',
  },
  {
    tag: '53.7',
    v1voc: 'དང་ལྡན་པ་ཐོབ་',
    v2voc: '具',
    v3voc: '滿足',
    v4voc: '-',
    v5voc: '-',
    PS: '53',
  },
  {
    tag: '53.8',
    v1voc: 'འཁོར་བའི་རྒྱ་མཚོར',
    v2voc: '生死海',
    v3voc: '生死',
    v4voc: '-',
    v5voc: '-',
    PS: '53',
  },
  {
    tag: '53.9',
    v1voc: 'འཐོན་པ',
    v2voc: '出',
    v3voc: '越度',
    v4voc: '-',
    v5voc: '-',
    PS: '53',
  },
  {
    tag: '53.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '53.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '54.1',
    v1voc: 'སྨད་གཡོགས',
    v2voc: '下裙',
    v3voc: '裳',
    v4voc: '裳',
    v5voc: '泥洹僧',
    PS: null,
  },
  {
    tag: '54.2',
    v1voc: 'གྱོན་པ',
    v2voc: '著',
    v3voc: '著',
    v4voc: '著',
    v5voc: '著',
    PS: null,
  },
  {
    tag: '54.3',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '54.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '54.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '54.6',
    v1voc: 'ངོ་ཚ',
    v2voc: '慚',
    v3voc: '慚',
    v4voc: '慚',
    v5voc: '-',
    PS: '54',
  },
  {
    tag: '54.7',
    v1voc: 'ཤེས',
    v2voc: '具足',
    v3voc: '常知',
    v4voc: '常知',
    v5voc: '-',
    PS: '54',
  },
  {
    tag: '54.8',
    v1voc: 'ཁྲེལ་ཡོད་པ',
    v2voc: '愧',
    v3voc: '愧',
    v4voc: '愧',
    v5voc: '愧',
    PS: '54',
  },
  {
    tag: '54.9',
    v1voc: 'དགེ་བའི་རྩ་བ་',
    v2voc: '善根',
    v3voc: '道',
    v4voc: '道',
    v5voc: '功德',
    PS: '54',
  },
  {
    tag: '54.10',
    v1voc: 'ཤིན་ཏུ་བརྟན / ཤིན་ཏུ་བརྟན་པ',
    v2voc: '服',
    v3voc: '守',
    v4voc: '守',
    v5voc: '撿持',
    PS: null,
  },
  {
    tag: '54.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '54.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '54.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '55.1',
    v1voc: 'སྐ་རགས',
    v2voc: '帶',
    v3voc: '帶',
    v4voc: '帶',
    v5voc: '帶',
    PS: null,
  },
  {
    tag: '55.2',
    v1voc: 'འཆིངས་པ',
    v2voc: '束',
    v3voc: '結',
    v4voc: '結',
    v5voc: '繫',
    PS: null,
  },
  {
    tag: '55.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '55.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '55.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '55.6',
    v1voc: 'མི་འཁྲུགས་པའི་ཆོས་ཅན་དུ་གྱུར',
    v2voc: '不令散失',
    v3voc: '不壞善法',
    v4voc: '志無解已',
    v5voc: '悉令堅',
    PS: '55',
  },
  {
    tag: '55.8',
    v1voc: 'དགེ་བའི་རྩ་བ་',
    v2voc: '善根',
    v3voc: '修道',
    v4voc: '善',
    v5voc: '諸功德',
    PS: '55',
  },
  {
    tag: '55.9',
    v1voc: 'ཤིན་ཏུ་འབྲེལ་པ',
    v2voc: '檢束',
    v3voc: '自檢',
    v4voc: '束帶',
    v5voc: '結',
    PS: '55',
  },
  {
    tag: '55.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '55.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '55.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '56.1',
    v1voc: 'བླ་གོས',
    v2voc: '上衣',
    v3voc: '上衣',
    v4voc: '中衣',
    v5voc: '安和',
    PS: null,
  },
  {
    tag: '56.2',
    v1voc: 'གྱོན་པ',
    v2voc: '著',
    v3voc: '著',
    v4voc: '著',
    v5voc: '被',
    PS: null,
  },
  {
    tag: '56.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '56.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '56.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '56.6',
    v1voc: 'ཆོས་ཐམས་ཅད་ཀྱི་ཁྱད་པ',
    v2voc: '(至)法',
    v3voc: '勝法',
    v4voc: '(恭敬畏慎，無有慢墮)',
    v5voc: '悉入諸經中',
    PS: '56',
  },
  {
    tag: '56.7',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '彼岸',
    v3voc: '究竟',
    v4voc: '-',
    v5voc: '極過度去',
    PS: '56',
  },
  {
    tag: '56.8',
    v1voc: 'གོང་ནས་གོང་དུ',
    v2voc: '勝',
    v3voc: '上',
    v4voc: '-',
    v5voc: '重益',
    PS: '56',
  },
  {
    tag: '56.9',
    v1voc: 'དགེ་བའི་རྩ་བ་',
    v2voc: '善根',
    v3voc: '善根',
    v4voc: '-',
    v5voc: '諸功德',
    PS: '56',
  },
  {
    tag: '56.10',
    v1voc: 'ཐོབ་པ',
    v2voc: '獲',
    v3voc: '得',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '56.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '56.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '56.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '57.1',
    v1voc: 'སྣམ་སྦྱར',
    v2voc: '僧伽梨',
    v3voc: '僧伽梨',
    v4voc: '法服',
    v5voc: '震越',
    PS: null,
  },
  {
    tag: '57.2',
    v1voc: 'གྱོན་པ',
    v2voc: '著',
    v3voc: '著',
    v4voc: '被上',
    v5voc: '被',
    PS: null,
  },
  {
    tag: '57.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '57.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '57.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '57.6',
    v1voc: 'མི་འཁྲུགས་པའི་ཆོས་ཅན',
    v2voc: '不動法',
    v3voc: '不動法',
    v4voc: '-',
    v5voc: '-',
    PS: '57',
  },
  {
    tag: '57.8',
    v1voc: 'ཐབས་དམ་པ',
    v2voc: '第一位',
    v3voc: '大慈',
    v4voc: '聖表式',
    v5voc: '-',
    PS: '57',
  },
  {
    tag: '57.9',
    v1voc: 'མངོན་པར་བཀབ་པ',
    v2voc: '入',
    v3voc: '覆護',
    v4voc: '服',
    v5voc: '未曾有離時',
    PS: '57',
  },
  {
    tag: '57.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '57.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '57.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '58.1',
    v1voc: 'སོ་ཤིང',
    v2voc: '楊枝',
    v3voc: '楊枝',
    v4voc: '楊枝',
    v5voc: '楊枝',
    PS: null,
  },
  {
    tag: '58.2',
    v1voc: 'ལེན་པ',
    v2voc: '執',
    v3voc: '執',
    v4voc: '執',
    v5voc: '持',
    PS: null,
  },
  {
    tag: '58.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '58.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '58.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '58.6',
    v1voc: 'ཡོངས་སུ་དག་པ',
    v2voc: '(究竟淸淨)',
    v3voc: '(自然淸淨)',
    v4voc: '(摘去諸垢)',
    v5voc: '(淨潔)',
    PS: '58',
  },
  {
    tag: '58.7',
    v1voc: 'དམ་པའི་ཆོས',
    v2voc: '妙法',
    v3voc: '正法',
    v4voc: '法句',
    v5voc: '諸經',
    PS: '58',
  },
  {
    tag: '58.8',
    v1voc: 'རྣམ་པར་དག་པ',
    v2voc: '究竟淸淨',
    v3voc: '自然淸淨',
    v4voc: '摘去諸垢',
    v5voc: '淨潔',
    PS: '58',
  },
  {
    tag: '58.9',
    v1voc: 'ཐོབ་པ',
    v2voc: '皆得',
    v3voc: '得',
    v4voc: '學以',
    v5voc: '學',
    PS: '58',
  },
  {
    tag: '58.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '58.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '58.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '58.13',
    v1voc: 'དངོས་པོ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '58',
  },
  {
    tag: '58.14',
    v1voc: 'འཐོབ་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '58',
  },
  {
    tag: '59.1',
    v1voc: 'སོ་ཤིང་ཟ་བ',
    v2voc: '嚼楊枝',
    v3voc: '嚼楊枝',
    v4voc: '澡漱口齒',
    v5voc: '漱齒洗口',
    PS: null,
  },
  {
    tag: '59.3',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '59.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '59.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '59.6',
    v1voc: 'ཉོན་མོངས་པ',
    v2voc: '煩惱',
    v3voc: '煩惱',
    v4voc: '情性',
    v5voc: '諸垢濁',
    PS: '59',
  },
  {
    tag: '59.7',
    v1voc: 'ཤིན་ཏུ་བཅོམ',
    v2voc: '噬',
    v3voc: '噬',
    v4voc: '蕩滌',
    v5voc: '悉淨潔',
    PS: '59',
  },
  {
    tag: '59.8',
    v1voc: 'སེམས་',
    v2voc: '心',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '59',
  },
  {
    tag: '59.9',
    v1voc: 'དུལ/ དུལ་བ',
    v2voc: '調',
    v3voc: '調伏',
    v4voc: '',
    v5voc: '-',
    PS: '59',
  },
  {
    tag: '59.10',
    v1voc: 'རྣམ་པར་དག་པ',
    v2voc: '淨',
    v3voc: '-',
    v4voc: '清淨住',
    v5voc: '清淨住',
    PS: '59',
  },
  {
    tag: '59.12',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '59.13',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '59.14',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '60.1',
    v1voc: 'དབེན་པར་འགྲོ་བ',
    v2voc: '大小便',
    v3voc: '左右便利',
    v4voc: '左右便利',
    v5voc: '左右',
    PS: null,
  },
  {
    tag: '60.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '60.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '60.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '60.5',
    v1voc: 'འདོད་ཆགས',
    v2voc: '貪',
    v3voc: '婬',
    v4voc: '婬',
    v5voc: '婬泆',
    PS: '60',
  },
  {
    tag: '60.6',
    v1voc: 'ཞེ་སྡང',
    v2voc: '瞋',
    v3voc: '怒',
    v4voc: '怒',
    v5voc: '瞋恚',
    PS: '60',
  },
  {
    tag: '60.7',
    v1voc: 'གཏི་མུག',
    v2voc: '癡',
    v3voc: '癡',
    v4voc: '癡',
    v5voc: '愚癡',
    PS: '60',
  },
  {
    tag: '60.8',
    v1voc: 'སྤངས་',
    v2voc: '棄',
    v3voc: '無',
    v4voc: '無',
    v5voc: '斷絕',
    PS: null,
  },
  {
    tag: '60.9',
    v1voc: 'སྡིག་པའི་ཆོས',
    v2voc: '罪法',
    v3voc: '汙穢',
    v4voc: '污穢',
    v5voc: '衆惡',
    PS: '60',
  },
  {
    tag: '60.10',
    v1voc: 'སྤངས་པ',
    v2voc: '蠲除',
    v3voc: '蠲除',
    v4voc: '蠲除',
    v5voc: '棄',
    PS: null,
  },
  {
    tag: '60.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '60.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '60.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '61.1',
    v1voc: 'ཆུ་ངོགས་སུ་འགྲོ་བ',
    v2voc: '水',
    v3voc: '水',
    v4voc: '',
    v5voc: '水',
    PS: null,
  },
  {
    tag: '61.2',
    v1voc: 'འགྲོ /འགྲོ་བ',
    v2voc: '就',
    v3voc: '就',
    v4voc: '-',
    v5voc: '行至',
    PS: null,
  },
  {
    tag: '61.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '61.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '61.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '61.6',
    v1voc: 'འཇིག་རྟེན་ལས་འདས་པའི་ཆོས',
    v2voc: '出世法',
    v3voc: '出世法',
    v4voc: '-',
    v5voc: '上佛經',
    PS: '61',
  },
  {
    tag: '61.7',
    v1voc: 'ཤིན་ཏུ་འབྱུང་བ',
    v2voc: '速疾而往',
    v3voc: '向無上道',
    v4voc: '-',
    v5voc: '悉淨潔',
    PS: '61',
  },
  {
    tag: '61.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '61.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '61.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '62.1',
    v1voc: 'གཙང་སྦྲའི་ལས་བྱེད་པ',
    v2voc: '洗滌形穢',
    v3voc: '以水滌穢',
    v4voc: '已而就水',
    v5voc: '持水行',
    PS: null,
  },
  {
    tag: '62.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '62.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '62.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '62.5',
    v1voc: 'ཤིན་ཏུ་དག་པའི་དངོས་པོ',
    v2voc: '畢竟無垢',
    v3voc: '畢竟無垢',
    v4voc: '-',
    v5voc: '-',
    PS: '62',
  },
  {
    tag: '62.6',
    v1voc: 'གཙང',
    v2voc: '淸淨',
    v3voc: '淨',
    v4voc: '淸淨',
    v5voc: '淨潔',
    PS: '62',
  },
  {
    tag: '62.7',
    v1voc: 'དེས་པ',
    v2voc: '柔',
    v3voc: '（忍）',
    v4voc: '柔和軟弱',
    v5voc: '軟好',
    PS: '62',
  },
  {
    tag: '62.8',
    v1voc: 'ལྡན་པ',
    v2voc: '調',
    v3voc: '具足',
    v4voc: '-',
    v5voc: '-',
    PS: '62',
  },
  {
    tag: '62.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '62.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '62.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '63.1',
    v1voc: 'ལག་པ',
    v2voc: '掌',
    v3voc: '掌',
    v4voc: '手',
    v5voc: '手',
    PS: null,
  },
  {
    tag: '63.2',
    v1voc: 'འཁྲུ་བ',
    v2voc: '盥',
    v3voc: '盥',
    v4voc: '盥',
    v5voc: '澡',
    PS: null,
  },
  {
    tag: '63.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '63.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '63.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '63.6',
    v1voc: 'གཟུང་ཞིང་བཅང་པ',
    v2voc: '受持(佛法)',
    v3voc: '受持(佛法)',
    v4voc: '執受(經道)',
    v5voc: '取(諸經道法)',
    PS: '63',
  },
  {
    tag: '63.7',
    v1voc: 'བཀྲ་ཤིས་ཀྱི་ལག་པ',
    v2voc: '清淨手',
    v3voc: '上妙手',
    v4voc: '軟淨掌',
    v5voc: '軟好手 ',
    PS: '63',
  },
  {
    tag: '63.8',
    v1voc: 'ལྡན་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '-',
    v5voc: '-',
    PS: '63',
  },
  {
    tag: '63.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '63.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '63.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '64.1',
    v1voc: 'ངོ',
    v2voc: '面',
    v3voc: '口齒',
    v4voc: '面',
    v5voc: '面',
    PS: null,
  },
  {
    tag: '64.2',
    v1voc: 'འཁྲུ་བ',
    v2voc: '以水洗',
    v3voc: '澡漱',
    v4voc: '澡',
    v5voc: '洗',
    PS: null,
  },
  {
    tag: '64.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '64.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '64.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '64.6',
    v1voc: 'ཉོན་མོངས་པ་དང་བྲལ་',
    v2voc: '永無垢染',
    v3voc: '究竟解脫',
    v4voc: '心無瑕疵',
    v5voc: '莫令有瑕穢',
    PS: '64',
  },
  {
    tag: '64.8',
    v1voc: 'ཆོས་ཐམས་ཅད་ཀྱི་སྒོ',
    v2voc: '法門',
    v3voc: '法門',
    v4voc: '-',
    v5voc: '佛經道面門',
    PS: '64',
  },
  {
    tag: '64.9',
    v1voc: 'རྣམ་པར་དག་པ་',
    v2voc: '淨',
    v3voc: '淨',
    v4voc: '淸淨',
    v5voc: '-',
    PS: '64',
  },
  {
    tag: '64.10',
    v1voc: 'ཐོབ་པར་',
    v2voc: '得',
    v3voc: '向',
    v4voc: '常向',
    v5voc: '入',
    PS: '64',
  },
  {
    tag: '64.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '64.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '64.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '65.1',
    v1voc: 'འཁར་བ',
    v2voc: '錫杖',
    v3voc: '錫杖',
    v4voc: '錫杖',
    v5voc: '錫杖',
    PS: null,
  },
  {
    tag: '65.2',
    v1voc: 'ལེན་པ',
    v2voc: '手執',
    v3voc: '手執',
    v4voc: '行持',
    v5voc: '見持',
    PS: null,
  },
  {
    tag: '65.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '65.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '65.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '65.6',
    v1voc: 'མཆོད་སྦྱིན་བྱས',
    v2voc: '設大施會',
    v3voc: '設淨施會',
    v4voc: '-',
    v5voc: '常作善，爲人所仰，常欲施與人',
    PS: '65',
  },
  {
    tag: '65.7',
    v1voc: 'ལམ་སྟོན་པ',
    v2voc: '示如實道',
    v3voc: '見道如實',
    v4voc: '依仗於法  分流德化',
    v5voc: '教人爲善法',
    PS: '65',
  },
  {
    tag: '65.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '65.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '65.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '66.1',
    v1voc: 'ལྷུང་བཟེད',
    v2voc: '應器',
    v3voc: '應器',
    v4voc: '應器',
    v5voc: '鉢',
    PS: null,
  },
  {
    tag: '66.2',
    v1voc: 'ལེན་པ',
    v2voc: '執持',
    v3voc: '擎持',
    v4voc: '挾持',
    v5voc: '持',
    PS: null,
  },
  {
    tag: '66.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '66.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '66.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '66.6',
    v1voc: 'འགྲོ་བ་ཐམས་ཅད',
    v2voc: '天人',
    v3voc: '天人',
    v4voc: '-',
    v5voc: '-',
    PS: '66',
  },
  {
    tag: '66.7',
    v1voc: 'མཆོད་པར་འོས',
    v2voc: '受……供',
    v3voc: '受……供',
    v4voc: '受而知施',
    v5voc: '受所供養',
    PS: '66',
  },
  {
    tag: '66.8',
    v1voc: 'འོས་ཤིང་སྣོད་དུ་',
    v2voc: '成就法器',
    v3voc: '成就法器',
    v4voc: '-',
    v5voc: '入於無底功德中',
    PS: '66',
  },
  {
    tag: '66.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '66.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '66.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '67.1',
    v1voc: 'སྤྱོད་ཡུལ',
    v2voc: '向道',
    v3voc: '向道',
    v4voc: '道',
    v5voc: '道',
    PS: null,
  },
  {
    tag: '67.2',
    v1voc: 'མངོན་པར་ཞུགས་པ',
    v2voc: '發趾',
    v3voc: '發趾',
    v4voc: '向',
    v5voc: '向',
    PS: null,
  },
  {
    tag: '67.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '67.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '67.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '67.6',
    v1voc: 'གནས་མེད་པར་གཞོལ',
    v2voc: '入無依處',
    v3voc: '究竟解脫',
    v4voc: '向無上道',
    v5voc: '得佛',
    PS: '67',
  },
  {
    tag: '67.7',
    v1voc: 'སངས་རྒྱས་ཀྱི་སྤྱོད་ཡུལ',
    v2voc: '佛',
    v3voc: '佛菩提',
    v4voc: '-',
    v5voc: '-',
    PS: '67',
  },
  {
    tag: '67.8',
    v1voc: 'མངོན་དུ་ཕྱོགས་པ',
    v2voc: '趣',
    v3voc: '趣',
    v4voc: '',
    v5voc: '-',
    PS: '67',
  },
  {
    tag: '67.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '67.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '67.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '68.1',
    v1voc: 'ལམ་དུ་ཞུགས་པ',
    v2voc: '在於道',
    v3voc: '已在道',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '68.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '68.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '68.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '68.5',
    v1voc: 'ཕྱི་ན་མ་ལུས་པར་འགྲོ',
    v2voc: '向無餘法',
    v3voc: '無餘所行',
    v4voc: '-',
    v5voc: '-',
    PS: '68',
  },
  {
    tag: '68.6',
    v1voc: 'འགྲོ /འགྲོ་བ',
    v2voc: '向',
    v3voc: '行',
    v4voc: '-',
    v5voc: '-',
    PS: '68',
  },
  {
    tag: '68.7',
    v1voc: 'སངས་རྒྱས་ཀྱི་ལམ',
    v2voc: '佛道',
    v3voc: '佛道',
    v4voc: '-',
    v5voc: '-',
    PS: '68',
  },
  {
    tag: '68.8',
    v1voc: 'ཞུགས་པ',
    v2voc: '能行',
    v3voc: '成就',
    v4voc: '-',
    v5voc: '-',
    PS: '68',
  },
  {
    tag: '68.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '68.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '68.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '69.1',
    v1voc: 'འགྲོ་བ',
    v2voc: '涉路而去',
    v3voc: '涉路而行',
    v4voc: '行道',
    v5voc: '行道',
    PS: null,
  },
  {
    tag: '69.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '69.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '69.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '69.5',
    v1voc: 'ཤིན་ཏུ་རྣམ་པར་དག་པ',
    v2voc: '履淨',
    v3voc: '履淨',
    v4voc: '-',
    v5voc: '淨潔',
    PS: '69',
  },
  {
    tag: '69.6',
    v1voc: 'ཆོས',
    v2voc: '心',
    v3voc: '心',
    v4voc: '-',
    v5voc: '-',
    PS: '69',
  },
  {
    tag: '69.7',
    v1voc: 'བསྒྲིབས་པ་མེད་པ་གྲུབ་པ',
    v2voc: '無障礙',
    v3voc: '無障礙',
    v4voc: '(不中休息)',
    v5voc: '無所罣礙',
    PS: '69',
  },
  {
    tag: '69.8',
    v1voc: 'ཆོས་ཀྱི་དབྱིངས',
    v2voc: '法界',
    v3voc: '法界',
    v4voc: '-',
    v5voc: '經',
    PS: '69',
  },
  {
    tag: '69.9',
    v1voc: 'མཐའ་དང་དབུས་མེད་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '無際',
    v5voc: '無底',
    PS: null,
  },
  {
    tag: '69.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '69.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '69.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '70.1',
    v1voc: 'ལམ་མཐོ་བ',
    v2voc: '昇高路',
    v3voc: '趣高路',
    v4voc: '上坂',
    v5voc: '上坂',
    PS: null,
  },
  {
    tag: '70.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '',
    v5voc: '行道',
    PS: null,
  },
  {
    tag: '70.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '70.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '70.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '70.6',
    v1voc: 'ཞུམ་པ་མེད་',
    v2voc: '心無怯弱',
    v3voc: '(昇無上道)',
    v4voc: '無所疑難',
    v5voc: '無有厭極',
    PS: '70',
  },
  {
    tag: '70.8',
    v1voc: 'ཁམས་གསུམ',
    v2voc: '三界',
    v3voc: '三界',
    v4voc: '上道',
    v5voc: '-',
    PS: '70',
  },
  {
    tag: '70.9',
    v1voc: 'གྱེན་དུ་འཕགས་པ',
    v2voc: '永出',
    v3voc: '超出',
    v4voc: '樂昇',
    v5voc: '-',
    PS: '70',
  },
  {
    tag: '70.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '70.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '70.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '71.1',
    v1voc: 'ལམ་དམའ་བ',
    v2voc: '趣下路',
    v3voc: '趣下路',
    v4voc: '下坂',
    v5voc: '下坂',
    PS: null,
  },
  {
    tag: '71.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '行道',
    PS: null,
  },
  {
    tag: '71.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '71.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '71.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '一切眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '71.6',
    v1voc: 'དགེ་བའི་རྩ་བ་',
    v2voc: '善根',
    v3voc: '深法',
    v4voc: '廣博，微妙法',
    v5voc: '佛大道',
    PS: '71',
  },
  {
    tag: '71.7',
    v1voc: 'ཤིན་ཏུ་བརྟན / ཤིན་ཏུ་བརྟན་པ',
    v2voc: '長',
    v3voc: '入',
    v4voc: '深入',
    v5voc: '入/悉貫',
    PS: '71',
  },
  {
    tag: '71.8',
    v1voc: 'སངས་རྒྱས་ཐམས་ཅད',
    v2voc: '佛',
    v3voc: '佛',
    v4voc: '佛',
    v5voc: '智慧',
    PS: '71',
  },
  {
    tag: '71.9',
    v1voc: 'ཤིན་ཏུ་འདུད་པ',
    v2voc: '謙下',
    v3voc: '謙下柔軟',
    v4voc: '-',
    v5voc: '',
    PS: '71',
  },
  {
    tag: '71.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '71.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '71.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '72.1',
    v1voc: 'ལམ་ཉམ་ང་བ',
    v2voc: '斜曲路',
    v3voc: '險路',
    v4voc: '曲路',
    v5voc: '曲道',
    PS: null,
  },
  {
    tag: '72.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '行',
    v5voc: '行',
    PS: null,
  },
  {
    tag: '72.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '72.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '72.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '72.6',
    v1voc: 'ལྟ་བ་ཡོ་ཞིང་མི་དྲང་བ',
    v2voc: '惡見',
    v3voc: '邪見',
    v4voc: '邪曲意',
    v5voc: '邪念',
    PS: '72',
  },
  {
    tag: '72.7',
    v1voc: 'བྲལ/ བྲལ་བ',
    v2voc: '永除',
    v3voc: '滅除',
    v4voc: '棄',
    v5voc: '莫有',
    PS: '72',
  },
  {
    tag: '72.8',
    v1voc: 'ལམ་ཉམ་ང་བ',
    v2voc: '不正道',
    v3voc: '惡道',
    v4voc: '行..忮忮',
    v5voc: '惡口',
    PS: '72',
  },
  {
    tag: '72.9',
    v1voc: 'ཡོངས་སུ་སྤངས་པ',
    v2voc: '捨',
    v3voc: '棄捐',
    v4voc: '不',
    v5voc: '無令有',
    PS: '72',
  },
  {
    tag: '72.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '72.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '72.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '73.1',
    v1voc: 'ལམ་དྲང་པོ',
    v2voc: '直路',
    v3voc: '直路',
    v4voc: '直路',
    v5voc: '直道',
    PS: null,
  },
  {
    tag: '73.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '行',
    v5voc: '行',
    PS: null,
  },
  {
    tag: '73.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '73.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '73.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '73.6',
    v1voc: 'གཡོ་མེད་ཅིང་སྒྱུ་མེད',
    v2voc: '無諂無誑',
    v3voc: '身口無曲',
    v4voc: '言無諛諂',
    v5voc: '無令有諛諂',
    PS: '73',
  },
  {
    tag: '73.8',
    v1voc: 'སེམས་',
    v2voc: '心',
    v3voc: '意',
    v4voc: '意',
    v5voc: '心念',
    PS: '73',
  },
  {
    tag: '73.9',
    v1voc: 'དྲང་པོ',
    v2voc: '正直',
    v3voc: '中正',
    v4voc: '中正',
    v5voc: '正道',
    PS: '73',
  },
  {
    tag: '73.10',
    v1voc: 'ལྡན་པ',
    v2voc: '其',
    v3voc: '得',
    v4voc: '得',
    v5voc: '-',
    PS: '73',
  },
  {
    tag: '73.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '73.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '73.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '74.1',
    v1voc: 'ལམ་རྡུལ་ཆེན་པོ',
    v2voc: '路多塵',
    v3voc: '道揚塵',
    v4voc: '風揚塵',
    v5voc: '揚塵滿道',
    PS: null,
  },
  {
    tag: '74.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '74.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '74.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '74.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '74.6',
    v1voc: 'ཤིན་ཏུ་རྡུལ་མེད་པའི་ཆོས་ཡང་དག་པར་ཐོབ',
    v2voc: '遠離塵坌',
    v3voc: '永離塵穢',
    v4voc: '心不紛亂',
    v5voc: '諸欲去',
    PS: '74',
  },
  {
    tag: '74.7',
    v1voc: 'འདོད་ཆགས་པར་འགྱུར་བའི་ཆོས་ལས་རྣམ་པར་གྲོལ་བ',
    v2voc: '獲淸淨法',
    v3voc: '畢竟淸淨',
    v4voc: '經明行修',
    v5voc: '常得明經',
    PS: '74',
  },
  {
    tag: '74.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '74.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '74.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '75.1',
    v1voc: 'རྡུལ་མེད་པའི་ལམ',
    v2voc: '路無塵',
    v3voc: '道無塵',
    v4voc: '雨淹塵',
    v5voc: '淹塵滿道',
    PS: null,
  },
  {
    tag: '75.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '75.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '75.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '75.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '75.6',
    v1voc: 'སྙིང་རྗེ་ཆེན་པོ',
    v2voc: '大悲',
    v3voc: '大悲',
    v4voc: '大慈',
    v5voc: '慈哀',
    PS: '75',
  },
  {
    tag: '75.7',
    v1voc: 'ཡོངས་སུ་བསྒོམས་པ',
    v2voc: '常行',
    v3voc: '熏',
    v4voc: '伏意',
    v5voc: '悉得',
    PS: '75',
  },
  {
    tag: '75.8',
    v1voc: 'སེམས',
    v2voc: '心',
    v3voc: '心意',
    v4voc: '-',
    v5voc: '心',
    PS: '75',
  },
  {
    tag: '75.9',
    v1voc: 'འཇམ་པ',
    v2voc: '潤澤',
    v3voc: '柔潤',
    v4voc: '-',
    v5voc: '柔軟',
    PS: '75',
  },
  {
    tag: '75.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '75.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '75.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '76.1',
    v1voc: 'གཡང་ས',
    v2voc: '險道',
    v3voc: '深阬㵎',
    v4voc: '涼息樹',
    v5voc: '陰涼樹',
    PS: null,
  },
  {
    tag: '76.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '76.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '76.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '76.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '76.6',
    v1voc: 'སྒྲིབ་པ་མེད་པ་རྟོགས་པར་ཁོང་དུ་ཆུད',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '(通利入佛經中，悉覺知)',
    PS: '76',
  },
  {
    tag: '76.7',
    v1voc: 'སྡིག་པའི་ཆོས་ཐམས་ཅད་བསལ',
    v2voc: '離諸罪難',
    v3voc: '滅除諸難',
    v4voc: '伏心在道',
    v5voc: '諸所惡法，悉除去',
    PS: '76',
  },
  {
    tag: '76.8',
    v1voc: 'དགེ་བའི་ཆོས་ལ་རབ་ཏུ་གཞོལ་བ',
    v2voc: '住正法界',
    v3voc: '向正法界',
    v4voc: '經意不疲',
    v5voc: '通利入佛經中，悉覺知',
    PS: '76',
  },
  {
    tag: '76.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '76.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '76.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '77.1',
    v1voc: 'འཁོར',
    v2voc: '衆會',
    v3voc: '聽訟堂',
    v4voc: '-',
    v5voc: '講堂精舍',
    PS: null,
  },
  {
    tag: '77.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '77.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '77.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '77.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '77.6',
    v1voc: 'དུས་གསུམ་དུ་གཏོགས་པའི་ཆོས་',
    v2voc: '法',
    v3voc: '法',
    v4voc: '-',
    v5voc: '諸經',
    PS: '77',
  },
  {
    tag: '77.7',
    v1voc: 'ཟབ་མོ',
    v2voc: '甚深',
    v3voc: '甚深',
    v4voc: '-',
    v5voc: '-',
    PS: '77',
  },
  {
    tag: '77.8',
    v1voc: 'བསྟན་པ',
    v2voc: '說',
    v3voc: '說',
    v4voc: '-',
    v5voc: '-',
    PS: '77',
  },
  {
    tag: '77.9',
    v1voc: 'མཐུན་པ',
    v2voc: '一切和合',
    v3voc: '一切和合',
    v4voc: '-',
    v5voc: '悉入中',
    PS: '77',
  },
  {
    tag: '77.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '77.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '77.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '78.1',
    v1voc: 'ཀ་བ',
    v2voc: '大柱',
    v3voc: '大樹',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.6',
    v1voc: 'ཁྲོ་ཞིང་མཁོན་དུ་འཛིན་པ',
    v2voc: '忿恨',
    v3voc: '忿恨',
    v4voc: '-',
    v5voc: '-',
    PS: '78',
  },
  {
    tag: '78.7',
    v1voc: 'བྲལ/ བྲལ་བ',
    v2voc: '無有',
    v3voc: '無有',
    v4voc: '-',
    v5voc: '-',
    PS: '78',
  },
  {
    tag: '78.9',
    v1voc: 'ཁེངས་པ་དང་འཁྲུགས་པ',
    v2voc: '我諍心',
    v3voc: '我諍心',
    v4voc: '-',
    v5voc: '-',
    PS: '78',
  },
  {
    tag: '78.10',
    v1voc: 'རྣམ་པར་བྲལ་བ',
    v2voc: '離',
    v3voc: '離',
    v4voc: '-',
    v5voc: '-',
    PS: '78',
  },
  {
    tag: '78.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '78.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '79.1',
    v1voc: 'ནགས་ཚལ',
    v2voc: '叢林',
    v3voc: '叢林',
    v4voc: '林澤',
    v5voc: '林大樹',
    PS: null,
  },
  {
    tag: '79.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '入',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '79.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '79.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '79.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '79.6',
    v1voc: 'ལྷ་དང་འཇིག་རྟེན་དུ་བཅས་པ',
    v2voc: '天及人',
    v3voc: '天、人',
    v4voc: '儒林',
    v5voc: '天上、世間',
    PS: '79',
  },
  {
    tag: '79.7',
    v1voc: 'ཕྱག་བྱ་བ',
    v2voc: '敬禮',
    v3voc: '敬禮',
    v4voc: '養徒以德',
    v5voc: '歸仰供養',
    PS: '79',
  },
  {
    tag: '79.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '79.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '79.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '80.1',
    v1voc: 'རི',
    v2voc: '高山',
    v3voc: '高山',
    v4voc: '高山',
    v5voc: '山',
    PS: null,
  },
  {
    tag: '80.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '行見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '80.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '80.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '80.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '80.6',
    v1voc: 'ཐོབ་པར་དཀའ་བ་དང་ཐིབས་པོ་མེད་པ་རབ་ཏུ་ཐོབ',
    v2voc: '無能至頂',
    v3voc: '莫能見頂',
    v4voc: '志仰高大',
    v5voc: '心念高才',
    PS: '80',
  },
  {
    tag: '80.7',
    v1voc: 'དགེ་བའི་རྩ་བ་',
    v2voc: '善根',
    v3voc: '善',
    v4voc: '德',
    v5voc: '功德',
    PS: '80',
  },
  {
    tag: '80.8',
    v1voc: 'མངོན་པར་འཕགས་པ',
    v2voc: '超出',
    v3voc: '無上',
    v4voc: '無厭',
    v5voc: '無有能勝者',
    PS: '80',
  },
  {
    tag: '80.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '80.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '80.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '81.1',
    v1voc: 'ཤིང་ཚེར་མ་ཅན',
    v2voc: '棘刺樹',
    v3voc: '刺棘',
    v4voc: '刺棘',
    v5voc: '棘樹',
    PS: null,
  },
  {
    tag: '81.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '行見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '81.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '81.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '81.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '81.6',
    v1voc: 'འདོད་ཆགས་དང་ཞེ་སྡང་དང་གཏི་མུག',
    v2voc: '三毒',
    v3voc: '三毒',
    v4voc: '三毒',
    v5voc: '婬泆、瞋恚、愚癡',
    PS: '81',
  },
  {
    tag: '81.7',
    v1voc: 'ཚེར་མ་དང་བྲལ་བ',
    v2voc: '疾得翦除',
    v3voc: '拔…刺',
    v4voc: '消滅',
    v5voc: '疾遠離於',
    PS: '81',
  },
  {
    tag: '81.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '81.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '81.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '82.1',
    v1voc: 'ཤིང་ལོ་མ་ཅན',
    v2voc: '樹茂葉',
    v3voc: '樹茂葉',
    v4voc: '好葉樹',
    v5voc: '葉樹',
    PS: null,
  },
  {
    tag: '82.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '得',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '82.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '82.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '82.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '82.6',
    v1voc: 'བསམ་གཏན་',
    v2voc: '定解脫',
    v3voc: '禪三昧',
    v4voc: '禪三昧',
    v5voc: '禪',
    PS: '82',
  },
  {
    tag: '82.7',
    v1voc: 'རྣམ་པར་ཐར་པ་',
    v2voc: '定解脫',
    v3voc: '禪三昧',
    v4voc: '禪三昧',
    v5voc: '三昧',
    PS: '82',
  },
  {
    tag: '82.8',
    v1voc: 'ཏིང་ངེ་འཛིན',
    v2voc: '定解脫',
    v3voc: '禪三昧',
    v4voc: '禪三昧',
    v5voc: '三昧',
    PS: '82',
  },
  {
    tag: '82.9',
    v1voc: 'སྙོམས་པར་འཇུག་པ',
    v2voc: '定解脫',
    v3voc: '禪三昧',
    v4voc: '禪三昧',
    v5voc: '三昧',
    PS: '82',
  },
  {
    tag: '82.10',
    v1voc: 'རབ་ཏུ་གཡོགས་པ',
    v2voc: '自蔭',
    v3voc: '',
    v4voc: '自蔭',
    v5voc: '覆蓋',
    PS: null,
  },
  {
    tag: '82.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '82.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '82.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '83.1',
    v1voc: 'མེ་ཏོག',
    v2voc: '華開',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.6',
    v1voc: 'ཆོས་ཐམས་ཅད་',
    v2voc: '等法',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '83',
  },
  {
    tag: '83.7',
    v1voc: 'མངོན་པར་ཤེས་པ',
    v2voc: '神通',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '83',
  },
  {
    tag: '83.8',
    v1voc: 'མེ་ཏོག་རྒྱས་པས',
    v2voc: '開敷',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '83',
  },
  {
    tag: '83.9',
    v1voc: 'མེ་ཏོག་ལྟ་བུ',
    v2voc: '如華',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '83',
  },
  {
    tag: '83.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '83.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '84.1',
    v1voc: 'མེ་ཏོག་གི་ཤིང',
    v2voc: '樹華',
    v3voc: '樹好華',
    v4voc: '樹華',
    v5voc: '華樹',
    PS: null,
  },
  {
    tag: '84.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '84.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '84.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '84.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '84.6',
    v1voc: 'སྐྱེས་བུ་ཆེན་པོའི་མཚན་སུམ་ཅུ་རྩ་གཉིས',
    v2voc: '具三十二',
    v3voc: '相好滿具',
    v4voc: '三十二相',
    v5voc: '三十二相',
    PS: '84',
  },
  {
    tag: '84.7',
    v1voc: 'མེ་ཏོག་ཤིན་ཏུ་རྒྱས་པར་',
    v2voc: '眾相如華',
    v3voc: '開淨如華',
    v4voc: '諸好滿具',
    v5voc: '莊身',
    PS: '84',
  },
  {
    tag: '84.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '84.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '84.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '84.11',
    v1voc: 'སྐྱེས་བུ་ཆེན་པོ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '84',
  },
  {
    tag: '85.1',
    v1voc: 'ཤིང་ཏོག',
    v2voc: '果實',
    v3voc: '果蓏',
    v4voc: '果蓏',
    v5voc: '實樹',
    PS: null,
  },
  {
    tag: '85.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '-',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '85.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '85.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '85.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '85.6',
    v1voc: 'སྙིང་པོ་བྱང་ཆུབ',
    v2voc: '菩提道',
    v3voc: '道樹行',
    v4voc: '道樹行',
    v5voc: '-',
    PS: '85',
  },
  {
    tag: '85.7',
    v1voc: 'གཞོལ',
    v2voc: '證',
    v3voc: '起',
    v4voc: '起',
    v5voc: '得',
    PS: '85',
  },
  {
    tag: '85.8',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས',
    v2voc: '最勝法',
    v3voc: '-',
    v4voc: '-',
    v5voc: '佛經',
    PS: '85',
  },
  {
    tag: '85.9',
    v1voc: 'འབྲས་བུའི་དམ་པ',
    v2voc: '-',
    v3voc: '無上果',
    v4voc: '無上果',
    v5voc: '華實',
    PS: '85',
  },
  {
    tag: '85.10',
    v1voc: 'རབ་ཏུ་ཐོབ / རབ་ཏུ་ཐོབ་པ',
    v2voc: '獲',
    v3voc: '成',
    v4voc: '成',
    v5voc: '得',
    PS: '85',
  },
  {
    tag: '85.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '85.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '85.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '85.14',
    v1voc: 'བཙལ་བ',
    v2voc: '獲',
    v3voc: '-',
    v4voc: '-',
    v5voc: '悉具足於',
    PS: null,
  },
  {
    tag: '86.1',
    v1voc: 'ཆོས་ཀྱི་རྒྱུད',
    v2voc: '大河',
    v3voc: '諸流水',
    v4voc: '諸流水',
    v5voc: '流水',
    PS: null,
  },
  {
    tag: '86.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '覩',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '86.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '86.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '86.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '86.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཡེ་ཤེས་',
    v2voc: '佛智海',
    v3voc: '佛智海',
    v4voc: '佛智海',
    v5voc: '佛智',
    PS: '86',
  },
  {
    tag: '86.7',
    v1voc: 'ཉམས་སུ་མྱོང་',
    v2voc: '入',
    v3voc: '入',
    v4voc: '入',
    v5voc: '入',
    PS: '86',
  },
  {
    tag: '86.8',
    v1voc: 'ཆོས་ཀྱི་རྒྱུད་',
    v2voc: '法流',
    v3voc: '法流',
    v4voc: '正法流',
    v5voc: '佛經流淵',
    PS: '86',
  },
  {
    tag: '86.9',
    v1voc: 'མཉམ་པར་བཞག་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '得',
    v5voc: '入',
    PS: '86',
  },
  {
    tag: '86.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '86.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '86.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '87.1',
    v1voc: 'ལུ་མ',
    v2voc: '陂澤',
    v3voc: '陂水',
    v4voc: '井',
    v5voc: '井',
    PS: null,
  },
  {
    tag: '87.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '87.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '87.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '87.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '87.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས',
    v2voc: '法',
    v3voc: '正法',
    v4voc: '法',
    v5voc: '經門',
    PS: '87',
  },
  {
    tag: '87.7',
    v1voc: 'རོ་གཅིག་པ',
    v2voc: '一味',
    v3voc: '不壞',
    v4voc: '一味道',
    v5voc: '一味',
    PS: '87',
  },
  {
    tag: '87.8',
    v1voc: 'སེ་གོལ་གཏོགས་པ་ཙམ',
    v2voc: '疾',
    v3voc: '悉',
    v4voc: '-',
    v5voc: '早',
    PS: '87',
  },
  {
    tag: '87.9',
    v1voc: 'ཁོང་དུ་ཆུད/ ཁོང་དུ་ཆུད་པ',
    v2voc: '悟',
    v3voc: '得',
    v4voc: '得',
    v5voc: '開',
    PS: '87',
  },
  {
    tag: '87.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '87.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '87.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '88.1',
    v1voc: 'རྫིང་བུ',
    v2voc: '池沼',
    v3voc: '浴池',
    v4voc: '泉水',
    v5voc: '泉水',
    PS: null,
  },
  {
    tag: '88.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '88.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '88.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '88.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '88.6',
    v1voc: 'ཤིན་ཏུ་བསྟན་པ་ལ་མཁས',
    v2voc: '巧能演說',
    v3voc: '問答無窮',
    v4voc: '所問無窮',
    v5voc: '所問慧者多所解',
    PS: '88',
  },
  {
    tag: '88.7',
    v1voc: 'རྒྱས་པའི་ཚིག་གི་ལས་',
    v2voc: '語業',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '88',
  },
  {
    tag: '88.8',
    v1voc: 'ལྡན་པ',
    v2voc: '滿足',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '88',
  },
  {
    tag: '88.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '88.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '88.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '88.12',
    v1voc: 'ཆོས་ཐམས་ཅད་ཀྱི་ཚིག་',
    v2voc: '-',
    v3voc: '佛海智',
    v4voc: '佛淵智',
    v5voc: '佛經道',
    PS: '88',
  },
  {
    tag: '89.1',
    v1voc: 'ཁྲོན་པ',
    v2voc: '井',
    v3voc: '井',
    v4voc: '',
    v5voc: '汲水',
    PS: null,
  },
  {
    tag: '89.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '89.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '89.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '89.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '89.6',
    v1voc: 'ཆོས་ཐམས་ཅད་',
    v2voc: '一切法',
    v3voc: '(不可窮盡)',
    v4voc: '-',
    v5voc: '功德法',
    PS: '89',
  },
  {
    tag: '89.7',
    v1voc: 'འབྱོར་པ',
    v2voc: '演',
    v3voc: '-',
    v4voc: '-',
    v5voc: '開入',
    PS: '89',
  },
  {
    tag: '89.8',
    v1voc: 'ལྡན',
    v2voc: '具足',
    v3voc: '得',
    v4voc: '-',
    v5voc: '具足',
    PS: '89',
  },
  {
    tag: '89.9',
    v1voc: 'སྤོབས་པ',
    v2voc: '辯才',
    v3voc: '辯',
    v4voc: '-',
    v5voc: '所道智',
    PS: '89',
  },
  {
    tag: '89.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '89.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '89.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '90.1',
    v1voc: 'མཚོ',
    v2voc: '涌泉',
    v3voc: '泉水',
    v4voc: '江海',
    v5voc: '大水',
    PS: null,
  },
  {
    tag: '90.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '遙望',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '90.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '90.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '90.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '90.6',
    v1voc: 'གོང་ནས་གོང་དུ',
    v2voc: '增長',
    v3voc: '無上',
    v4voc: '入深(佛藏)',
    v5voc: '無有能過',
    PS: '90',
  },
  {
    tag: '90.7',
    v1voc: 'དམིགས་པ་ལ་རབ་ཏུ་བརྩོན',
    v2voc: '方便',
    v3voc: '境界',
    v4voc: '-',
    v5voc: '-',
    PS: '90',
  },
  {
    tag: '90.9',
    v1voc: 'དགེ་བའི་རྩ་བ་',
    v2voc: '善根',
    v3voc: '善根',
    v4voc: '(法)',
    v5voc: '諸功德法',
    PS: '90',
  },
  {
    tag: '90.10',
    v1voc: 'མི་ཟད་པ',
    v2voc: '無盡',
    v3voc: '無盡',
    v4voc: '無盡',
    v5voc: '無有盡賜',
    PS: '90',
  },
  {
    tag: '90.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '90.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '90.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '91.1',
    v1voc: 'ཟམ་པ',
    v2voc: '橋道',
    v3voc: '橋梁',
    v4voc: '橋梁',
    v5voc: '橋梁',
    PS: null,
  },
  {
    tag: '91.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '過度',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '91.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '91.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '91.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '91.6',
    v1voc: 'སྐྱེ་བོ་ཐམས་ཅད་',
    v2voc: '一切',
    v3voc: '人',
    v4voc: '人',
    v5voc: '人',
    PS: '91',
  },
  {
    tag: '91.7',
    v1voc: 'ཡོངས་སུ་བསྒྲལ་བ',
    v2voc: '廣度',
    v3voc: '度',
    v4voc: '度',
    v5voc: '極過度',
    PS: '91',
  },
  {
    tag: '91.8',
    v1voc: 'ཟམ་པར་རེད་པ',
    v2voc: '橋梁',
    v3voc: '興造法橋',
    v4voc: '興造法橋',
    v5voc: '人如橋梁',
    PS: '91',
  },
  {
    tag: '91.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: '91',
  },
  {
    tag: '91.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '91.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '92.1',
    v1voc: 'ཡུར་བ',
    v2voc: '流水',
    v3voc: '山㵎水',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.6',
    v1voc: 'འགྲོ་བ་ཀུན་གྱི་སེམས་དང་བསམ་པ་',
    v2voc: '意欲',
    v3voc: '意解',
    v4voc: '-',
    v5voc: '-',
    PS: '92',
  },
  {
    tag: '92.7',
    v1voc: 'མཁས',
    v2voc: '得善',
    v3voc: '清淨',
    v4voc: '-',
    v5voc: '-',
    PS: '92',
  },
  {
    tag: '92.8',
    v1voc: 'བག་ལ་ཉལ་བ',
    v2voc: '惑垢',
    v3voc: '惑垢',
    v4voc: '-',
    v5voc: '-',
    PS: '92',
  },
  {
    tag: '92.9',
    v1voc: 'བག་ལ་ཉལ་བ་དང་ཀུན་ནས་འཁོར་བ་མེད་པ',
    v2voc: '洗除',
    v3voc: '洗濯',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '92.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '93.1',
    v1voc: 'ར་བ',
    v2voc: '園圃',
    v3voc: '園圃',
    v4voc: '園圃',
    v5voc: '園',
    PS: '93',
  },
  {
    tag: '93.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見修',
    v3voc: '見修',
    v4voc: '見修',
    v5voc: '見',
    PS: '93',
  },
  {
    tag: '93.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '93.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '93.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '93.6',
    v1voc: 'གཟུགས་དང་སྒྲ་དང་དྲི་དང་རོ་དང་རེག་བྱ',
    v2voc: '五欲',
    v3voc: '欲根',
    v4voc: '欲根',
    v5voc: '五音樂、五所思',
    PS: '93',
  },
  {
    tag: '93.7',
    v1voc: 'སྲེད་པ',
    v2voc: '愛草',
    v3voc: '穢惡',
    v4voc: '穢惡',
    v5voc: '拘著',
    PS: '93',
  },
  {
    tag: '93.8',
    v1voc: 'རབ་ཏུ་བྱང་བར་',
    v2voc: '耘除',
    v3voc: '芸除',
    v4voc: '耘除',
    v5voc: '無所',
    PS: '93',
  },
  {
    tag: '93.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '93.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '93.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '93.12',
    v1voc: '-',
    v2voc: '-',
    v3voc: '不生',
    v4voc: '不生',
    v5voc: '不樂於',
    PS: '93',
  },
  {
    tag: '94.1',
    v1voc: 'མྱ་ངན་མེད་པ',
    v2voc: '無憂',
    v3voc: '無憂',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '94.2',
    v1voc: 'ནགས་ཚལ',
    v2voc: '林',
    v3voc: '林',
    v4voc: '-',
    v5voc: '果園',
    PS: null,
  },
  {
    tag: '94.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '94.4',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '94.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '94.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: '94',
  },
  {
    tag: '94.7',
    v1voc: 'སྲེད་པ་ཤིན་ཏུ་མེད',
    v2voc: '永離貪愛',
    v3voc: '歡喜',
    v4voc: '-',
    v5voc: '(悉得)深智本根',
    PS: '94',
  },
  {
    tag: '94.8',
    v1voc: 'མྱ་ངན་མེད་པ་',
    v2voc: '不生憂怖',
    v3voc: '永除憂惱',
    v4voc: '-',
    v5voc: '無所愁憂',
    PS: '94',
  },
  {
    tag: '94.10',
    v1voc: 'རབ་ཏུ་ཐོབ་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '悉得',
    PS: '94',
  },
  {
    tag: '94.11',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '94.12',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '94.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '95.1',
    v1voc: 'བཟའ་ཤིང་གི་ར་བ',
    v2voc: '園苑',
    v3voc: '園池',
    v4voc: '園圃',
    v5voc: '戲園',
    PS: null,
  },
  {
    tag: '95.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '95.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '95.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '95.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '95.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ',
    v2voc: '佛菩提',
    v3voc: '菩提',
    v4voc: '道法',
    v5voc: '佛諸經',
    PS: '95',
  },
  {
    tag: '95.7',
    v1voc: 'ཡོངས་སུ་མི་གཏོང་བ་',
    v2voc: '諸行',
    v3voc: '具足',
    v4voc: '備具',
    v5voc: '莫令離於',
    PS: '95',
  },
  {
    tag: '95.8',
    v1voc: 'ཤིན་ཏུ་བརྩོན་པ',
    v2voc: '勤修',
    v3voc: '勤修',
    v4voc: '得周滿持',
    v5voc: '無不精進者',
    PS: '95',
  },
  {
    tag: '95.9',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '95.10',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '95.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '96.1',
    v1voc: 'སེམས་ཅན་རྒྱན་གྱིས་བརྒྱན་པ',
    v2voc: '嚴飾人',
    v3voc: '嚴飾人',
    v4voc: '-',
    v5voc: '莊嚴大衆',
    PS: null,
  },
  {
    tag: '96.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '96.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '96.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '96.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '96.6',
    v1voc: 'སྐྱེས་བུ་ཆེན་པོའི་མཚན་སུམ་ཅུ་རྩ་གཉིས་ཀྱི་མེ་ཏོག་ཤིན་ཏུ་རྒྱས་པ',
    v2voc: '三十二相',
    v3voc: '三十二相',
    v4voc: '-',
    v5voc: '三十二相',
    PS: '96',
  },
  {
    tag: '96.7',
    v1voc: 'བརྒྱན་པར་',
    v2voc: '嚴好',
    v3voc: '莊嚴',
    v4voc: '-',
    v5voc: '莊嚴',
    PS: '96',
  },
  {
    tag: '96.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '96.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '96.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '97.1',
    v1voc: 'རྒྱན་མེད་པའི་སེམས་ཅན',
    v2voc: '無嚴飾',
    v3voc: '素服人',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.6',
    v1voc: 'སྦྱངས་པ',
    v2voc: '頭陀行',
    v3voc: '頭陀',
    v4voc: '-',
    v5voc: '-',
    PS: '97',
  },
  {
    tag: '97.7',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ་',
    v2voc: '-',
    v3voc: '彼岸',
    v4voc: '',
    v5voc: '',
    PS: null,
  },
  {
    tag: '97.9',
    v1voc: 'རྒྱན་མེད་པ',
    v2voc: '捨諸飾好',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '97',
  },
  {
    tag: '97.10',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.11',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '97.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '98.1',
    v1voc: 'དགའ་བ་མང་བའི་སེམས་ཅན་',
    v2voc: '樂著人',
    v3voc: '志樂人',
    v4voc: '喜笑人',
    v5voc: '人樂',
    PS: null,
  },
  {
    tag: '98.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '98.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '98.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '98.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '98.6',
    v1voc: 'ཆོས་ལ་དགའ',
    v2voc: '以法自娛',
    v3voc: '以道自娛',
    v4voc: '五欲自娛',
    v5voc: '樂喜深經',
    PS: '98',
  },
  {
    tag: '98.7',
    v1voc: 'མོས་པ་དང་སྤྲོ་བས་དགའ་བ་མང་བ',
    v2voc: '歡愛不捨',
    v3voc: '淸淨法樂',
    v4voc: '捨非常樂',
    v5voc: '-',
    PS: '98',
  },
  {
    tag: '98.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '98.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '98.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '99.1',
    v1voc: 'མི་དགའ་བ་མང་བའི་སེམས་ཅན་',
    v2voc: '無樂著',
    v3voc: '愁憂人',
    v4voc: '憂愁人',
    v5voc: '人愁憂',
    PS: null,
  },
  {
    tag: '99.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '99.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '99.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '99.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '99.6',
    v1voc: 'འདུས་བྱས་ཀྱི་དངོས་པོ་ཐམས་ཅད',
    v2voc: '有爲事',
    v3voc: '有爲法',
    v4voc: '-',
    v5voc: '-',
    PS: '99',
  },
  {
    tag: '99.7',
    v1voc: 'མི་དགའ་བ་མང་བ',
    v2voc: '心無所樂',
    v3voc: '心生厭離',
    v4voc: '憂愁',
    v5voc: '愁憂',
    PS: '99',
  },
  {
    tag: '99.8',
    v1voc: 'གྱུར་ཅིག',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '99.9',
    v1voc: 'ཅེས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '99.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '99.11',
    v1voc: '-',
    v2voc: '-',
    v3voc: '-',
    v4voc: '離諸恐怖',
    v5voc: '-',
    PS: '99',
  },
  {
    tag: '100.1',
    v1voc: 'སེམས་ཅན་བདེ་བ',
    v2voc: '歡樂人',
    v3voc: '歡樂人',
    v4voc: '安樂人',
    v5voc: '人安隱',
    PS: null,
  },
  {
    tag: '100.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '100.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '100.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '100.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '100.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་བདེ་བའི་ཡོ་བྱད་ཐམས་ཅད་རབ་ཏུ་ཐོབ་པ',
    v2voc: '樂供養佛',
    v3voc: '憺怕無患',
    v4voc: '惔怕無患',
    v5voc: '逮得如佛安隱',
    PS: '100',
  },
  {
    tag: '100.7',
    v1voc: 'ཤིན་ཏུ་བདེ་བ',
    v2voc: '安樂',
    v3voc: '無上樂',
    v4voc: '安快如佛',
    v5voc: '安隱',
    PS: '100',
  },
  {
    tag: '100.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '100.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '100.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '101.1',
    v1voc: 'སེམས་ཅན་སྡུག་བསྔལ་བ',
    v2voc: '苦惱人',
    v3voc: '苦惱人',
    v4voc: '勤苦人',
    v5voc: '人勤苦',
    PS: null,
  },
  {
    tag: '101.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '101.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '101.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '101.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '101.6',
    v1voc: 'ཡེ་ཤེས་ཀྱི་རྩ་བ',
    v2voc: '根本智',
    v3voc: '佛智慧',
    v4voc: '泥洹道',
    v5voc: '正真道',
    PS: '101',
  },
  {
    tag: '101.7',
    v1voc: 'རབ་ཏུ་ཐོབ་པ',
    v2voc: '獲',
    v3voc: '得',
    v4voc: '得',
    v5voc: '悉見',
    PS: '101',
  },
  {
    tag: '101.8',
    v1voc: 'སྡུག་བསྔལ',
    v2voc: '眾苦',
    v3voc: '眾苦',
    v4voc: '諸厄',
    v5voc: '諸勤苦',
    PS: '101',
  },
  {
    tag: '101.9',
    v1voc: 'ཞི་བར་བྱེད་པ',
    v2voc: '滅除',
    v3voc: '滅除',
    v4voc: '免度',
    v5voc: '滅賜',
    PS: null,
  },
  {
    tag: '101.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '101.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '101.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '103.1',
    v1voc: 'ནད་མེད་པ་མ་ཡིན་པའི་སེམས་ཅན',
    v2voc: '疾病人',
    v3voc: '疾病人',
    v4voc: '疾病人',
    v5voc: '人病',
    PS: null,
  },
  {
    tag: '103.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '103.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '103.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '103.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '103.7',
    v1voc: 'ཤིན་ཏུ་མྱ་ངན་མེད་པའི་ཆོས་ཅན་དུ་གྱུར',
    v2voc: '離乖諍法',
    v3voc: '解脫衆苦',
    v4voc: '無苦痛意',
    v5voc: '-',
    PS: '3',
  },
  {
    tag: '103.8',
    v1voc: 'ཐ་དད་པ་མེད་པར་ཁོང་དུ་ཆུད་པ',
    v2voc: '知身空寂',
    v3voc: '知身空寂',
    v4voc: '知空非身',
    v5voc: '悉入虛空中',
    PS: '103',
  },
  {
    tag: '103.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '103.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '103.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '104.1',
    v1voc: 'སེམས་ཅན་སྡུ་གུ',
    v2voc: '端正人',
    v3voc: '端正人',
    v4voc: '端正人',
    v5voc: '端正人',
    PS: null,
  },
  {
    tag: '104.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '104.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '104.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '104.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '104.6',
    v1voc: 'སངས་རྒྱས་དང་བྱང་ཆུབ་སེམས་དཔའ་ཐམས་ཅད',
    v2voc: '佛菩薩',
    v3voc: '諸佛菩薩',
    v4voc: '道法',
    v5voc: '佛經',
    PS: '104',
  },
  {
    tag: '104.7',
    v1voc: 'མོས་པ',
    v2voc: '淨信',
    v3voc: '歡喜恭敬',
    v4voc: '愛好',
    v5voc: '愛樂於',
    PS: '104',
  },
  {
    tag: '104.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '104.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '104.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '105.1',
    v1voc: 'མི་སྡུག་པའི་སེམས་ཅན',
    v2voc: '醜陋人',
    v3voc: '醜陋人',
    v4voc: '醜陋人',
    v5voc: '醜人',
    PS: null,
  },
  {
    tag: '105.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '105.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '105.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '105.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '105.6',
    v1voc: 'མི་དགེ་བའི་བཤེས་གཉེན་གྱི་བྱ་བ',
    v2voc: '於不善事',
    v3voc: '鄙惡',
    v4voc: '醜惡行',
    v5voc: '醜惡中',
    PS: '105',
  },
  {
    tag: '105.7',
    v1voc: 'མོས་པ་ཆུང་བ',
    v2voc: '不生樂著',
    v3voc: '遠離',
    v4voc: '去(醜惡行)',
    v5voc: '莫墮',
    PS: '105',
  },
  {
    tag: '105.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '105.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '105.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '106.1',
    v1voc: 'དྲིན་གཟོ་བའི་སེམས་ཅན',
    v2voc: '報恩人',
    v3voc: '報恩人',
    v4voc: '報恩人',
    v5voc: '報恩',
    PS: null,
  },
  {
    tag: '106.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '106.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '106.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '106.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '106.6',
    v1voc: 'སངས་རྒྱས',
    v2voc: '佛',
    v3voc: '諸佛',
    v4voc: '佛',
    v5voc: '-',
    PS: '106',
  },
  {
    tag: '106.7',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ',
    v2voc: '菩薩',
    v3voc: '菩薩',
    v4voc: '菩薩',
    v5voc: '菩薩',
    PS: '106',
  },
  {
    tag: '106.8',
    v1voc: 'ཤེས་པ',
    v2voc: '知',
    v3voc: '念',
    v4voc: '念',
    v5voc: '-',
    PS: '106',
  },
  {
    tag: '106.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '106.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '106.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '107.1',
    v1voc: 'དྲིན་གཟོ་བ་མེད་པ',
    v2voc: '背恩',
    v3voc: '背恩',
    v4voc: '背恩',
    v5voc: '不報恩',
    PS: null,
  },
  {
    tag: '107.2',
    v1voc: 'སེམས་ཅན་',
    v2voc: '人',
    v3voc: '人',
    v4voc: '人',
    v5voc: '人',
    PS: null,
  },
  {
    tag: '107.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '107.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '107.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '107.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '107.7',
    v1voc: 'མི་དགེ་བ',
    v2voc: '惡',
    v3voc: '眾惡',
    v4voc: '諸惡',
    v5voc: '',
    PS: '107',
  },
  {
    tag: '107.8',
    v1voc: 'དྲིན་དུ་གཟོ་བ་མེད་པ',
    v2voc: '不加其報',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '107',
  },
  {
    tag: '107.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '107.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '107.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '108.1',
    v1voc: 'དགེ་སྦྱོང',
    v2voc: '沙門',
    v3voc: '沙門',
    v4voc: '沙門',
    v5voc: '沙門',
    PS: null,
  },
  {
    tag: '108.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '得見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '108.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '108.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '108.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '108.6',
    v1voc: 'མ་ལུས་པ',
    v2voc: '畢竟',
    v3voc: '究竟',
    v4voc: '-',
    v5voc: '悉究竟得',
    PS: '108.',
  },
  {
    tag: '108.7',
    v1voc: 'མཐར་ཐུག་པ་',
    v2voc: '第一',
    v3voc: '無餘',
    v4voc: '-',
    v5voc: '-',
    PS: '108.',
  },
  {
    tag: '108.8',
    v1voc: 'ཞི་བ་',
    v2voc: '寂靜',
    v3voc: '寂靜',
    v4voc: '-',
    v5voc: '-',
    PS: '108.',
  },
  {
    tag: '108.9',
    v1voc: 'དུལ་བ་ལ་གཞོལ་བ',
    v2voc: '調柔',
    v3voc: '調伏',
    v4voc: '多聞戒具',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '108.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '108.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '108.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '109.1',
    v1voc: 'བྲམ་ཟེ',
    v2voc: '婆羅門',
    v3voc: '婆羅門',
    v4voc: '異道人',
    v5voc: '異道人',
    PS: null,
  },
  {
    tag: '109.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '109.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '109.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '109.6',
    v1voc: 'ཚངས་པའི་དམ་པ',
    v2voc: '梵行',
    v3voc: '得真清淨',
    v4voc: '(入八正道)',
    v5voc: '(究竟諸經)',
    PS: '109',
  },
  {
    tag: '109.7',
    v1voc: 'སྡིག་པ',
    v2voc: '惡',
    v3voc: '惡',
    v4voc: '邪見',
    v5voc: '諸惡根本',
    PS: '109',
  },
  {
    tag: '109.8',
    v1voc: 'སྤོང་བ',
    v2voc: '離',
    v3voc: '離',
    v4voc: '遠去',
    v5voc: '悉消盡儩',
    PS: '109',
  },
  {
    tag: '109.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '109.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '109.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '110.1',
    v1voc: 'དཀའ་ཐུབ་ཅན',
    v2voc: '苦行人',
    v3voc: '仙人',
    v4voc: '仙人',
    v5voc: '仙人',
    PS: null,
  },
  {
    tag: '110.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '得見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '110.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '110.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '110.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '110.6',
    v1voc: 'མ་ལུས་པའི་མཐར་ཐུག་པ',
    v2voc: '至究竟處',
    v3voc: '究竟解脫',
    v4voc: '-',
    v5voc: '-',
    PS: '110',
  },
  {
    tag: '110.7',
    v1voc: 'དཀའ་ཐུབ་ལ་ཤིན་ཏུ་གཞོལ་བ',
    v2voc: '依於苦行',
    v3voc: '向正真道',
    v4voc: '意行具足',
    v5voc: '所作為皆成足',
    PS: '110',
  },
  {
    tag: '110.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '110.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '110.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '111.1',
    v1voc: 'བརྟུལ་ཞུགས་ལ་ཞུགས་པ་',
    v2voc: '操行人',
    v3voc: '苦行人',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ',
    v2voc: '佛道',
    v3voc: '佛道',
    v4voc: '-',
    v5voc: '-',
    PS: '111',
  },
  {
    tag: '111.7',
    v1voc: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ་ཡོངས་སུ་མི་གཏོང་བ',
    v2voc: '不捨',
    v3voc: '不退',
    v4voc: '-',
    v5voc: '-',
    PS: '111',
  },
  {
    tag: '111.8',
    v1voc: 'བརྟུལ་ཞུགས་དམ་པོར་གྱུར',
    v2voc: '堅持志行',
    v3voc: '堅固精勤',
    v4voc: '-',
    v5voc: '-',
    PS: '111',
  },
  {
    tag: '111.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '111.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '112.1',
    v1voc: 'གོ',
    v2voc: '甲冑',
    v3voc: '甲冑',
    v4voc: '鎧甲',
    v5voc: '鎧',
    PS: null,
  },
  {
    tag: '112.2',
    v1voc: 'གྱོན་པ',
    v2voc: '著',
    v3voc: '著',
    v4voc: '被',
    v5voc: '被',
    PS: null,
  },
  {
    tag: '112.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '112.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '112.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '112.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '112.7',
    v1voc: 'རང་འབྱུང་གི་ཆོས་',
    v2voc: '無師法',
    v3voc: '無師法',
    v4voc: '本願',
    v5voc: '佛經',
    PS: '112',
  },
  {
    tag: '112.8',
    v1voc: 'ཡོངས་སུ་བཙལ་བ',
    v2voc: '趣',
    v3voc: '得',
    v4voc: '不違',
    v5voc: '悉具足',
    PS: '112',
  },
  {
    tag: '112.9',
    v1voc: 'གོ་ཆ་བཟང་པོ་',
    v2voc: '善鎧',
    v3voc: '法鎧',
    v4voc: '法鎧',
    v5voc: '鎧',
    PS: '112',
  },
  {
    tag: '112.11',
    v1voc: 'ཤིན་ཏུ་བགོས་པ',
    v2voc: '服',
    v3voc: '服',
    v4voc: '-',
    v5voc: '-',
    PS: '112',
  },
  {
    tag: '112.12',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '112.13',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '112.14',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '113.1',
    v1voc: 'གོ་མ་གྱོན་པ',
    v2voc: '無鎧仗',
    v3voc: '無鎧仗',
    v4voc: '魯鈍',
    v5voc: '愚鈍',
    PS: null,
  },
  {
    tag: '113.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '113.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '113.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '113.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '113.6',
    v1voc: 'མི་དགེ་བའི་ལས',
    v2voc: '不善之業',
    v3voc: '衆惡',
    v4voc: '-',
    v5voc: '衆惡',
    PS: '113',
  },
  {
    tag: '113.7',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '113.8',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: '113',
  },
  {
    tag: '113.9',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: '113',
  },
  {
    tag: '113.10',
    v1voc: 'བྱ་བ་ཐམས་ཅད་',
    v2voc: '一切',
    v3voc: '(衆)',
    v4voc: '-',
    v5voc: '所作為',
    PS: '113',
  },
  {
    tag: '114.1',
    v1voc: 'རྒོལ་བའི་སེམས་ཅན',
    v2voc: '論議人',
    v3voc: '論議人',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '114.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '114.3',
    v1voc: 'ཚེ',
    v2voc: '',
    v3voc: '',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '114.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '',
    v3voc: '',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '114.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '114.6',
    v1voc: 'ཕས་ཀྱི་རྒོལ་བ',
    v2voc: '異論',
    v3voc: '外道',
    v4voc: '-',
    v5voc: '-',
    PS: '114',
  },
  {
    tag: '114.7',
    v1voc: 'ཤིན་ཏུ་ཚར་གཅོད་པ',
    v2voc: '摧伏',
    v3voc: '摧伏',
    v4voc: '-',
    v5voc: '-',
    PS: '114',
  },
  {
    tag: '114.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '',
    v4voc: '-',
    v5voc: '-',
    PS: '114',
  },
  {
    tag: '114.9',
    v1voc: 'ཅེས་',
    v2voc: '',
    v3voc: '',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '114.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '',
    v3voc: '',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.1',
    v1voc: 'འཚོ་བའི་སེམས་ཅན',
    v2voc: '正命人',
    v3voc: '正命人',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.6',
    v1voc: 'སྤྱོད་ལམ',
    v2voc: '威儀',
    v3voc: '威儀',
    v4voc: '-',
    v5voc: '-',
    PS: '115',
  },
  {
    tag: '115.7',
    v1voc: 'བཅོས་པ་མྱེད་',
    v2voc: '不矯',
    v3voc: '不異',
    v4voc: '-',
    v5voc: '-',
    PS: '115',
  },
  {
    tag: '115.8',
    v1voc: 'འཚོ་བ་དག་པ',
    v2voc: '淸淨命',
    v3voc: '淸淨命',
    v4voc: '-',
    v5voc: '-',
    PS: '115',
  },
  {
    tag: '115.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '115.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '116.1',
    v1voc: 'རྒྱལ་པོ',
    v2voc: '王',
    v3voc: '帝王',
    v4voc: '帝王',
    v5voc: '帝王',
    PS: null,
  },
  {
    tag: '116.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '116.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '116.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '116.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '116.6',
    v1voc: 'ཐོགས་པ་མེད་པའི་ཆོས་ཀྱི་འཁོར་ལོ་བསྐོར་བ',
    v2voc: '正法',
    v3voc: '無礙輪',
    v4voc: '如正道教',
    v5voc: '自然轉經(說道無有休絕時)',
    PS: '116',
  },
  {
    tag: '116.8',
    v1voc: 'བསྐོར་བ',
    v2voc: '恒轉(正法)',
    v3voc: '轉(無礙輪)',
    v4voc: '(如正道教）',
    v5voc: '轉(經)',
    PS: '116',
  },
  {
    tag: '116.9',
    v1voc: 'ཆོས་ཀྱི་རྒྱལ་པོ',
    v2voc: '法王',
    v3voc: '法王',
    v4voc: '(得奉聖化)',
    v5voc: '經中王',
    PS: '116',
  },
  {
    tag: '116.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '116.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '116.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '117.1',
    v1voc: 'རྒྱལ་པོའི་བུ',
    v2voc: '王子',
    v3voc: '帝王子',
    v4voc: '帝王子',
    v5voc: '太子',
    PS: null,
  },
  {
    tag: '117.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '117.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '117.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '117.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '117.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་སྲས',
    v2voc: '佛子',
    v3voc: '佛子',
    v4voc: '佛子',
    v5voc: '佛子',
    PS: '117',
  },
  {
    tag: '117.7',
    v1voc: 'ཆོས་ལས་སྐྱེས་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '117',
  },
  {
    tag: '117.9',
    v1voc: 'ཆོས་ཀྱི་སྤྲུལ་པ',
    v2voc: '從法化生 ',
    v3voc: '化生法中',
    v4voc: '化生法中',
    v5voc: '化生於經中',
    PS: '117',
  },
  {
    tag: '117.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '117.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '117.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '118.1',
    v1voc: 'ཁྱིམ་བདག',
    v2voc: '長者',
    v3voc: '長者',
    v4voc: '公卿',
    v5voc: '公卿',
    PS: null,
  },
  {
    tag: '118.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '118.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '118.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '118.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '118.6',
    v1voc: 'རྣམ་པར་གདོན་མི་ཟ་བའི་བློ་ཅན',
    v2voc: '善能明斷',
    v3voc: '深解佛法',
    v4voc: '明於道理',
    v5voc: '明於深經中',
    PS: '118',
  },
  {
    tag: '118.7',
    v1voc: 'གྲོང་གི་ཆོས',
    v2voc: '惡法',
    v3voc: '愛欲',
    v4voc: '-',
    v5voc: '-',
    PS: '118',
  },
  {
    tag: '118.8',
    v1voc: 'སྤངས / སྤངས་པ',
    v2voc: '離',
    v3voc: '永離',
    v4voc: '-',
    v5voc: '-',
    PS: '118',
  },
  {
    tag: '118.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '118.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '118.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '119.1',
    v1voc: 'བློན་པོ',
    v2voc: '大臣',
    v3voc: '大臣',
    v4voc: '諸臣吏',
    v5voc: '旁臣、長吏',
    PS: null,
  },
  {
    tag: '119.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '119.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '119.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '119.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '119.6',
    v1voc: 'མི་དགེ་བའི་ཆོས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '固賊心',
    v5voc: '惡',
    PS: '119',
  },
  {
    tag: '119.7',
    v1voc: 'སྤྱོད་པ',
    v2voc: '習行',
    v3voc: '修行',
    v4voc: '-',
    v5voc: '-',
    PS: '119',
  },
  {
    tag: '119.8',
    v1voc: 'བཟང་པོ',
    v2voc: '正',
    v3voc: '正',
    v4voc: '忠正順善',
    v5voc: '正',
    PS: '119',
  },
  {
    tag: '119.9',
    v1voc: 'ཡིད་ལ་བྱེད་པ',
    v2voc: '念',
    v3voc: '念',
    v4voc: '',
    v5voc: '念',
    PS: '119',
  },
  {
    tag: '119.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '119.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '119.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '120.1',
    v1voc: 'གྲོང་ཁྱེར',
    v2voc: '城郭',
    v3voc: '城郭',
    v4voc: '城郭',
    v5voc: '城',
    PS: null,
  },
  {
    tag: '120.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '行到',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '120.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '120.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '120.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '120.6',
    v1voc: 'གདུལ་དཀའ་བ',
    v2voc: '無所屈',
    v3voc: '不可沮',
    v4voc: '(無虧缺)',
    v5voc: '-',
    PS: '120',
  },
  {
    tag: '120.7',
    v1voc: 'སེམས',
    v2voc: '心',
    v3voc: '心',
    v4voc: '-',
    v5voc: '-',
    PS: '120',
  },
  {
    tag: '120.8',
    v1voc: 'མཐུ་བོ་ཆེའི་ལུས',
    v2voc: '堅固身',
    v3voc: '金剛身',
    v4voc: '-',
    v5voc: '身體無有與等者',
    PS: '120',
  },
  {
    tag: '120.9',
    v1voc: 'ལྡན་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '-',
    v5voc: '-',
    PS: '120',
  },
  {
    tag: '120.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '120.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '120.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '121.1',
    v1voc: 'རྒྱལ་པོའི་གནས',
    v2voc: '王都',
    v3voc: '王都',
    v4voc: '宮闕',
    v5voc: '宮闕',
    PS: null,
  },
  {
    tag: '121.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '望見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '121.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '121.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '121.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '121.6',
    v1voc: 'ཡོན་ཏན',
    v2voc: '功德',
    v3voc: '功德',
    v4voc: '諸善',
    v5voc: '善功德',
    PS: '121',
  },
  {
    tag: '121.7',
    v1voc: 'རྗེས་སུ་འབྲང་བར་མཐུན་པ',
    v2voc: '共聚',
    v3voc: '(自在)',
    v4voc: '(普立)',
    v5voc: '與……相値',
    PS: '121',
  },
  {
    tag: '121.8',
    v1voc: 'མོས་པའི་སེམས་དང་ལྡན་པ',
    v2voc: '心恒喜樂',
    v3voc: '明達遠照',
    v4voc: '聰明遠照',
    v5voc: '樂明於心',
    PS: null,
  },
  {
    tag: '121.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '121.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '121.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '122.1',
    v1voc: 'ནགས་ཚལ་གྱི་འདབ',
    v2voc: '林藪',
    v3voc: '(妙色)',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.6',
    v1voc: 'ལྷ་དང་བཅས་པའི་འཇིག་རྟེན',
    v2voc: '天人',
    v3voc: '天、人',
    v4voc: '-',
    v5voc: '-',
    PS: '122',
  },
  {
    tag: '122.7',
    v1voc: 'བསྔགས་པ',
    v2voc: '歎仰',
    v3voc: '讚歎',
    v4voc: '-',
    v5voc: '-',
    PS: '122',
  },
  {
    tag: '122.8',
    v1voc: 'འོས་པ',
    v2voc: '應爲',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '122',
  },
  {
    tag: '122.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '122.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '123.1',
    v1voc: 'སློང་དུ་འགྲོ་བ',
    v2voc: '入里乞食',
    v3voc: '入里乞食',
    v4voc: '入里分衛',
    v5voc: '行分越',
    PS: null,
  },
  {
    tag: '123.2',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '123.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '123.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '123.5',
    v1voc: 'བསྒྲིབས་པ་མེད་པ',
    v2voc: '無障礙',
    v3voc: '無障礙',
    v4voc: '無得疑妄',
    v5voc: '無有忘誤',
    PS: '123',
  },
  {
    tag: '123.6',
    v1voc: 'ཆོས་ཀྱི་དབྱིངས',
    v2voc: '法界',
    v3voc: '法界',
    v4voc: '-',
    v5voc: '佛法處',
    PS: '123',
  },
  {
    tag: '123.7',
    v1voc: 'ཆུད་པ',
    v2voc: '入',
    v3voc: '入',
    v4voc: '-',
    v5voc: '入',
    PS: '123',
  },
  {
    tag: '123.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '123.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '123.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '124.1',
    v1voc: 'སྒོར་ཕྱིན་པ',
    v2voc: '門戶',
    v3voc: '門戶',
    v4voc: '門戶',
    v5voc: '家門',
    PS: null,
  },
  {
    tag: '124.2',
    v1voc: 'ཕྱིན་པ',
    v2voc: '到',
    v3voc: '到',
    v4voc: '到',
    v5voc: '至',
    PS: null,
  },
  {
    tag: '124.3',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '124.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '124.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '124.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས',
    v2voc: '佛法',
    v3voc: '佛法',
    v4voc: '諸法',
    v5voc: '佛經',
    PS: '124',
  },
  {
    tag: '124.7',
    v1voc: 'སྒོ་',
    v2voc: '門',
    v3voc: '門',
    v4voc: '門',
    v5voc: '門',
    PS: '124',
  },
  {
    tag: '124.8',
    v1voc: 'ཕྱིན་པ',
    v2voc: '入',
    v3voc: '入',
    v4voc: '入',
    v5voc: '至',
    PS: '124',
  },
  {
    tag: '124.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '124.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '124.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '125.1',
    v1voc: 'ནང་དུ་ཕྱིན་པ',
    v2voc: '入其家已',
    v3voc: '入人堂室',
    v4voc: '入人堂室',
    v5voc: '入門內',
    PS: null,
  },
  {
    tag: '125.2',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '125.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '125.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '125.5',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཐེག་པ',
    v2voc: '佛乘',
    v3voc: '佛乘',
    v4voc: '佛聖堂',
    v5voc: '佛智慧',
    PS: '125',
  },
  {
    tag: '125.6',
    v1voc: 'དུས་གསུམ་དུ་མཉམ་པ་ཉིད',
    v2voc: '三世',
    v3voc: '三世',
    v4voc: '(深行微妙)',
    v5voc: '-',
    PS: '125',
  },
  {
    tag: '125.7',
    v1voc: 'མཉམ་པ་ཉིད',
    v2voc: '平等',
    v3voc: '明達',
    v4voc: '',
    v5voc: '',
    PS: '125',
  },
  {
    tag: '125.8',
    v1voc: 'ཕྱིན་པ',
    v2voc: '入',
    v3voc: '入',
    v4voc: '昇',
    v5voc: '入',
    PS: null,
  },
  {
    tag: '125.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '125.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '125.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '126.1',
    v1voc: 'མི་སྦྱིན་ནོ་ཞེས་མ་བྱས་པ',
    v2voc: '見不捨人',
    v3voc: '遇難持戒',
    v4voc: '人不與食',
    v5voc: '未受飯食',
    PS: null,
  },
  {
    tag: '126.2',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '126.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '126.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '126.5',
    v1voc: 'བསོད་ནམས',
    v2voc: '德法',
    v3voc: '衆善',
    v4voc: '-',
    v5voc: '-',
    PS: '126',
  },
  {
    tag: '126.6',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ་',
    v2voc: '勝功',
    v3voc: '度彼岸',
    v4voc: '般若意',
    v5voc: '般若波羅蜜',
    PS: '126',
  },
  {
    tag: '126.7',
    v1voc: 'སྤང་བ་མེད་པ',
    v2voc: '不捨離',
    v3voc: '不捨',
    v4voc: '無望無惜',
    v5voc: '無有逆難',
    PS: '126',
  },
  {
    tag: '126.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '126.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '126.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '127.1',
    v1voc: 'མི་སྦྱིན་ནོ་ཞེས་བྱས་པ',
    v2voc: '見能捨人',
    v3voc: '見捨戒人',
    v4voc: '主人未辦',
    v5voc: '未得飯',
    PS: null,
  },
  {
    tag: '127.2',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '127.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '127.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '127.5',
    v1voc: 'དམྱལ་བ/བྱོལ་སོང་/སྐྱེ་གནས/གཤིན་རྗེའི་འཇིག་རྟེན',
    v2voc: '三惡道苦',
    v3voc: '三惡道',
    v4voc: '三惡道',
    v5voc: '(泥犁、禽獸、薜荔、監樓、)惡道',
    PS: '127',
  },
  {
    tag: '127.6',
    v1voc: 'བྱོལ་སོང་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '禽獸',
    PS: '127',
  },
  {
    tag: '127.7',
    v1voc: 'སྐྱེ་གནས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '薜荔',
    PS: '127',
  },
  {
    tag: '127.8',
    v1voc: 'གཤིན་རྗེའི་འཇིག་རྟེན',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '監樓',
    PS: '127',
  },
  {
    tag: '127.9',
    v1voc: 'སྤངས / སྤངས་པ',
    v2voc: '捨離',
    v3voc: '(度)',
    v4voc: '離',
    v5voc: '莫復墮',
    PS: '127',
  },
  {
    tag: '127.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '127.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '127.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '128.1',
    v1voc: 'ལྷུང་བཟེད་',
    v2voc: '缽',
    v3voc: '缽',
    v4voc: '應器',
    v5voc: '鉢',
    PS: null,
  },
  {
    tag: '128.2',
    v1voc: 'སྟོང་པ / སྟོངས་པ',
    v2voc: '空',
    v3voc: '空',
    v4voc: '空',
    v5voc: '空',
    PS: null,
  },
  {
    tag: '128.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '授',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '128.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '128.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '128.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '128.7',
    v1voc: 'ཉོན་མོངས་པ',
    v2voc: '煩惱',
    v3voc: '煩惱',
    v4voc: '欲之性',
    v5voc: '愛欲',
    PS: '128',
  },
  {
    tag: '128.8',
    v1voc: 'སྟོངས་པ',
    v2voc: '空',
    v3voc: '空',
    v4voc: '空，無',
    v5voc: '空',
    PS: '128',
  },
  {
    tag: '128.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '128.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '128.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '129.1',
    v1voc: 'ལྷུང་བཟེད་',
    v2voc: '缽',
    v3voc: '缽',
    v4voc: '應器',
    v5voc: '鉢',
    PS: null,
  },
  {
    tag: '129.2',
    v1voc: 'གང་བ',
    v2voc: '滿',
    v3voc: '滿',
    v4voc: '滿',
    v5voc: '滿',
    PS: null,
  },
  {
    tag: '129.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '受',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '129.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '129.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '129.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '129.7',
    v1voc: 'ཆོས་དཀར་པོ',
    v2voc: '善法',
    v3voc: '善法',
    v4voc: '道品之法',
    v5voc: '功德',
    PS: '129',
  },
  {
    tag: '129.8',
    v1voc: 'ཡོངས་སུ་རྒྱས་པ',
    v2voc: '具足成滿',
    v3voc: '具足成滿',
    v4voc: '一切成滿',
    v5voc: '滿',
    PS: '129',
  },
  {
    tag: '129.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '129.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '129.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '130.1',
    v1voc: 'རིམ་གྲོར་བྱས་པ',
    v2voc: '得恭敬',
    v3voc: '得食',
    v4voc: '擎持鉢飯',
    v5voc: '見受飯鉢',
    PS: null,
  },
  {
    tag: '130.2',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '時',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '130.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '130.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '130.5',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས',
    v2voc: '佛法',
    v3voc: '佛道',
    v4voc: '大道',
    v5voc: '佛道事',
    PS: '130',
  },
  {
    tag: '130.6',
    v1voc: 'སྤྱོད་པ',
    v2voc: '修行',
    v3voc: '志在',
    v4voc: '志在',
    v5voc: '奉行',
    PS: '130',
  },
  {
    tag: '130.7',
    v1voc: 'རིམ་གྲོར་བྱེད་པ',
    v2voc: '恭敬',
    v3voc: '供養',
    v4voc: '供養',
    v5voc: '-',
    PS: '130',
  },
  {
    tag: '130.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '130.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '130.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '131.1',
    v1voc: 'རིམ་གྲོར་མ་བྱས་པ',
    v2voc: '不得恭敬',
    v3voc: '若不得食',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '131.2',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '131.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '131.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '131.5',
    v1voc: 'མི་དགེ་བའི་ཆོས',
    v2voc: '不善之法',
    v3voc: '不善行',
    v4voc: '-',
    v5voc: '-',
    PS: '131',
  },
  {
    tag: '131.6',
    v1voc: 'མཆོད་པ་ཐམས་ཅད་',
    v2voc: '一切',
    v3voc: '一切',
    v4voc: '-',
    v5voc: '-',
    PS: '131',
  },
  {
    tag: '131.7',
    v1voc: 'རག་མ་ལུས་པ',
    v2voc: '不行',
    v3voc: '遠離',
    v4voc: '-',
    v5voc: '-',
    PS: '131',
  },
  {
    tag: '131.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '131.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '131.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '132.1',
    v1voc: 'ཁྲེལ་ཡོད་པའི་སེམས་ཅན',
    v2voc: '慚恥人',
    v3voc: '慚愧人',
    v4voc: '廉人',
    v5voc: '慚愧人',
    PS: null,
  },
  {
    tag: '132.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '與…..坐',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '132.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '132.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '132.5',
    v1voc: 'དབང་པོ་',
    v2voc: '諸根',
    v3voc: '諸根',
    v4voc: '-',
    v5voc: '-',
    PS: '132',
  },
  {
    tag: '132.6',
    v1voc: 'སྤྱོད་པ་',
    v2voc: '藏護',
    v3voc: '調伏',
    v4voc: '所作',
    v5voc: '',
    PS: '132',
  },
  {
    tag: '132.7',
    v1voc: 'ཁྲེལ་ཡོད་པ',
    v2voc: '具慚恥行',
    v3voc: '慚愧正行',
    v4voc: '知恥',
    v5voc: '無不慚愧於',
    PS: '132',
  },
  {
    tag: '132.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '132.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '132.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '132.11',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '133.1',
    v1voc: 'ངོ་ཚ་མེད་པ',
    v2voc: '無慚恥',
    v3voc: '無慚愧',
    v4voc: '-',
    v5voc: '不慚愧',
    PS: null,
  },
  {
    tag: '133.2',
    v1voc: 'སེམས་ཅན་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '人',
    PS: null,
  },
  {
    tag: '133.3',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '133.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '133.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '133.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '133.7',
    v1voc: 'བྱམས་པ',
    v2voc: '大慈',
    v3voc: '大慈',
    v4voc: '-',
    v5voc: '慈哀',
    PS: '133',
  },
  {
    tag: '133.8',
    v1voc: 'གནས',
    v2voc: '住',
    v3voc: '行',
    v4voc: '-',
    v5voc: '-',
    PS: '133',
  },
  {
    tag: '133.9',
    v1voc: 'ངོ་ཚ་མེད་པ',
    v2voc: '無慚',
    v3voc: '無慚愧',
    v4voc: '-',
    v5voc: '心所念惡',
    PS: '133',
  },
  {
    tag: '133.10',
    v1voc: 'ཡོངས་སུ་སྤངས་པ',
    v2voc: '捨離',
    v3voc: '離',
    v4voc: '-',
    v5voc: '棄捐',
    PS: null,
  },
  {
    tag: '133.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '133.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '133.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '134.1',
    v1voc: 'ཁ་ཟས',
    v2voc: '食',
    v3voc: '食',
    v4voc: '食',
    v5voc: '食',
    PS: null,
  },
  {
    tag: '134.2',
    v1voc: 'བསོད་པ',
    v2voc: '美(食)',
    v3voc: '香美(食)',
    v4voc: '香美(食)',
    v5voc: '美(食)',
    PS: null,
  },
  {
    tag: '134.3',
    v1voc: 'ཐོབ་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '得',
    v5voc: '得',
    PS: null,
  },
  {
    tag: '134.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '134.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '134.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '134.7',
    v1voc: 'ཟང་ཟིང་མེད་པའི་སེམས་དང་ལྡན',
    v2voc: '心無羡欲',
    v3voc: '情無所著',
    v4voc: '情無所著',
    v5voc: '心無沾汙',
    PS: '134',
  },
  {
    tag: '134.8',
    v1voc: 'སྨོན་ལམ',
    v2voc: '願',
    v3voc: '-',
    v4voc: '-',
    v5voc: '所願',
    PS: '134',
  },
  {
    tag: '134.9',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '滿足',
    v3voc: '-',
    v4voc: '-',
    v5voc: '無不悉得',
    PS: '134',
  },
  {
    tag: '134.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '134.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '134.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '135.1',
    v1voc: 'ཁ་ཟས་',
    v2voc: '食',
    v3voc: '食',
    v4voc: '食',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.2',
    v1voc: 'མི་བསོད་པ་',
    v2voc: '不美(食)',
    v3voc: '不美(食)',
    v4voc: '不美(食)',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.3',
    v1voc: 'ཐོབ་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '得',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.4',
    v1voc: 'ཚེ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.7',
    v1voc: 'ཏིང་ངེ་འཛིན་',
    v2voc: '三昧味',
    v3voc: '三昧',
    v4voc: '好惡無異',
    v5voc: '-',
    PS: '135',
  },
  {
    tag: '135.8',
    v1voc: 'ཐམས་ཅད་',
    v2voc: '諸',
    v3voc: '成滿',
    v4voc: '-',
    v5voc: '-',
    PS: '135',
  },
  {
    tag: '135.9',
    v1voc: 'ཐོབ་པ',
    v2voc: '獲得',
    v3voc: '具足',
    v4voc: '-',
    v5voc: '-',
    PS: '135',
  },
  {
    tag: '135.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '135.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '136.1',
    v1voc: 'ཁ་ཟས',
    v2voc: '食',
    v3voc: '食',
    v4voc: '',
    v5voc: '食',
    PS: null,
  },
  {
    tag: '136.2',
    v1voc: 'སྣུམ་བག',
    v2voc: '柔軟(食)',
    v3voc: '柔軟(食)',
    v4voc: '',
    v5voc: '(麁飯)',
    PS: null,
  },
  {
    tag: '136.3',
    v1voc: 'ཐོབ་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '-',
    v5voc: '得',
    PS: null,
  },
  {
    tag: '136.4',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '136.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '136.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '136.7',
    v1voc: 'སྙིང་རྗེ་ཆེན་པོ་',
    v2voc: '大悲',
    v3voc: '大悲',
    v4voc: '-',
    v5voc: '無不愍傷',
    PS: '136',
  },
  {
    tag: '136.8',
    v1voc: 'ཡོངས་སུ་བསྒོམས་',
    v2voc: '熏',
    v3voc: '熏',
    v4voc: '-',
    v5voc: '-',
    PS: '136',
  },
  {
    tag: '136.9',
    v1voc: 'སེམས་',
    v2voc: '心意',
    v3voc: '心意',
    v4voc: '-',
    v5voc: '心',
    PS: '136',
  },
  {
    tag: '136.10',
    v1voc: 'འཇམ་པར་',
    v2voc: '柔軟',
    v3voc: '柔軟',
    v4voc: '-',
    v5voc: '柔軟',
    PS: '136',
  },
  {
    tag: '136.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '136.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '136.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '137.1',
    v1voc: 'སྣུམ་བག་མེད་པ',
    v2voc: '麤澀',
    v3voc: '麤澀',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.2',
    v1voc: 'ཁ་ཟས་',
    v2voc: '食',
    v3voc: '食',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.3',
    v1voc: 'ཐོབ་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.4',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.7',
    v1voc: 'འཇིག་རྟེན་',
    v2voc: '世',
    v3voc: '世間',
    v4voc: '-',
    v5voc: '-',
    PS: '137',
  },
  {
    tag: '137.8',
    v1voc: 'སྲེད་པ',
    v2voc: '貪愛',
    v3voc: '愛味',
    v4voc: '-',
    v5voc: '-',
    PS: '137',
  },
  {
    tag: '137.9',
    v1voc: 'བྲལ/ བྲལ་བ',
    v2voc: '絕',
    v3voc: '遠離',
    v4voc: '-',
    v5voc: '-',
    PS: '137',
  },
  {
    tag: '137.10',
    v1voc: 'སྣུམ་བག་མེད་པའི་སེམས',
    v2voc: '心無染著',
    v3voc: '-',
    v4voc: '-',
    v5voc: '',
    PS: '137',
  },
  {
    tag: '137.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '137.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '138.1',
    v1voc: 'ཁ་ཟས་',
    v2voc: '飯',
    v3voc: '食',
    v4voc: '飯',
    v5voc: '飯',
    PS: null,
  },
  {
    tag: '138.2',
    v1voc: 'ཟ་བ',
    v2voc: '飯食',
    v3voc: '嚥',
    v4voc: '向口',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '138.3',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '時',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '138.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '138.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '138.6',
    v1voc: 'ཆོས་ལ་དགའ་བ',
    v2voc: '法喜',
    v3voc: '法喜',
    v4voc: '-',
    v5voc: '常飽於經',
    PS: '138',
  },
  {
    tag: '138.7',
    v1voc: 'ཡོངས་སུ་རྒྱས་པ',
    v2voc: '充滿',
    v3voc: '充滿',
    v4voc: '-',
    v5voc: '食足',
    PS: '138',
  },
  {
    tag: '138.8',
    v1voc: 'བསམ་གཏན་གྱི་ཟས་ཟ་བ',
    v2voc: '禪悅為食',
    v3voc: '禪悅為食',
    v4voc: '諸佛法味',
    v5voc: '禪',
    PS: '138',
  },
  {
    tag: '138.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '138.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '138.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '138.13',
    v1voc: 'རབ་ཏུ་དགའ་བ',
    v2voc: '(法喜充滿)',
    v3voc: '(法喜充滿)',
    v4voc: '(得諸經諸佛法味)',
    v5voc: '(常飽於經)',
    PS: null,
  },
  {
    tag: '139.1',
    v1voc: 'རོ་མྱོང་བ',
    v2voc: '受味',
    v3voc: '所食雜味',
    v4voc: '所噉雜味',
    v5voc: '食味',
    PS: null,
  },
  {
    tag: '139.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '139.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '139.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '139.5',
    v1voc: 'བདུད་རྩིའི་རོས་ངོམས་པ',
    v2voc: '甘露',
    v3voc: '甘露',
    v4voc: '甘露',
    v5voc: '甘露',
    PS: null,
  },
  {
    tag: '139.6',
    v1voc: 'ངོམས་པ',
    v2voc: '滿足',
    v3voc: '化成',
    v4voc: '化成',
    v5voc: '逮得',
    PS: null,
  },
  {
    tag: '139.7',
    v1voc: 'སྐྱེས་བུ་ཆེན་པོ',
    v2voc: '佛',
    v3voc: '佛',
    v4voc: '佛',
    v5voc: '佛',
    PS: '139',
  },
  {
    tag: '139.8',
    v1voc: 'མཚན',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '139',
  },
  {
    tag: '139.9',
    v1voc: 'རོ་བྲོ་བའི་མཆོག',
    v2voc: '上味',
    v3voc: '上味',
    v4voc: '味味',
    v5voc: '所化味',
    PS: '139',
  },
  {
    tag: '139.10',
    v1voc: 'ཐོབ་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '139.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '139.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '139.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '140.1',
    v1voc: 'ཟན་ཟོས་པ',
    v2voc: '飯食已訖',
    v3voc: '飯食已訖',
    v4voc: '飯食已訖',
    v5voc: '飽已',
    PS: null,
  },
  {
    tag: '140.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '140.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '140.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '140.5',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན',
    v2voc: '佛法',
    v3voc: '成十種力',
    v4voc: '成十種力',
    v5voc: '佛經極過去',
    PS: '140',
  },
  {
    tag: '140.7',
    v1voc: 'བྱ་བ་བྱས་པ',
    v2voc: '所作皆辨',
    v3voc: '德行充盈',
    v4voc: '德行充盈',
    v5voc: '所作爲，悉成足',
    PS: '140',
  },
  {
    tag: '140.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '140.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '140.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '141.1',
    v1voc: 'ཆོས་སྟོན་པ',
    v2voc: '說法',
    v3voc: '說法',
    v4voc: '呪願達嚫',
    v5voc: '說經、呪願',
    PS: null,
  },
  {
    tag: '141.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '時',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '141.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '141.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '141.5',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས་',
    v2voc: '法要',
    v3voc: '佛法',
    v4voc: '佛，十二部經',
    v5voc: '佛諸深經',
    PS: '141',
  },
  {
    tag: '141.6',
    v1voc: 'ཡང་དག་པར་གཞོལ',
    v2voc: '廣宣',
    v3voc: '深達',
    v4voc: '悉令通',
    v5voc: '悉入',
    PS: '141',
  },
  {
    tag: '141.7',
    v1voc: 'སྤོབས་པ་མི་ཟད་པ',
    v2voc: '無盡辯',
    v3voc: '無盡辯',
    v4voc: '-',
    v5voc: '所說道無有盡',
    PS: '141',
  },
  {
    tag: '141.8',
    v1voc: 'ལྡན་པ',
    v2voc: '得\t',
    v3voc: '得',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '141.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '141.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '141.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '142.1',
    v1voc: 'ཕྱིར་འབྱུང་བ',
    v2voc: '從舍出',
    v3voc: '出堂',
    v4voc: '罷坐退去',
    v5voc: '說經、呪願已，出去',
    PS: null,
  },
  {
    tag: '142.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '142.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '142.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: '142',
  },
  {
    tag: '142.5',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཡེ་ཤེས',
    v2voc: '佛智',
    v3voc: '佛智',
    v4voc: '三甘露',
    v5voc: '佛智慧',
    PS: '142',
  },
  {
    tag: '142.6',
    v1voc: 'ཉམས་སུ་མྱོང',
    v2voc: '深入',
    v3voc: '深入',
    v4voc: '得',
    v5voc: '悉受得',
    PS: '142',
  },
  {
    tag: '142.7',
    v1voc: 'ཁམས་གསུམ་',
    v2voc: '三界',
    v3voc: '三界',
    v4voc: '-',
    v5voc: '三處色',
    PS: '142',
  },
  {
    tag: '142.8',
    v1voc: 'བྱུང་བ',
    v2voc: '永出',
    v3voc: '永出',
    v4voc: '-',
    v5voc: '出',
    PS: null,
  },
  {
    tag: '142.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '142.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '142.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '143.1',
    v1voc: 'ཆུ་འབོག་པ',
    v2voc: '入水',
    v3voc: '入水',
    v4voc: '入水',
    v5voc: '入水',
    PS: null,
  },
  {
    tag: '143.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '時',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '143.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '143.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '143.5',
    v1voc: 'དུས་གསུམ',
    v2voc: '三世',
    v3voc: '三世',
    v4voc: '三塗',
    v5voc: '過去、當來、今現在',
    PS: '143',
  },
  {
    tag: '143.6',
    v1voc: 'ཉམས་སུ་མྱོང་',
    v2voc: '等',
    v3voc: '等達',
    v4voc: '等於',
    v5voc: '平等',
    PS: '143',
  },
  {
    tag: '143.7',
    v1voc: 'ཐམས་ཅད་མཁྱེན་པའི་ཡེ་ཤེས',
    v2voc: '一切智',
    v3voc: '佛道',
    v4voc: '身口意淨',
    v5voc: '佛智慧',
    PS: '143',
  },
  {
    tag: '143.8',
    v1voc: 'འབོགས་པ',
    v2voc: '入',
    v3voc: '深入',
    v4voc: '-',
    v5voc: '入',
    PS: '143',
  },
  {
    tag: '143.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '143.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '143.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '144.1',
    v1voc: 'ཁྲུས་བྱེད་པ',
    v2voc: '洗浴身體',
    v3voc: '澡浴身體',
    v4voc: '澡浴身體',
    v5voc: '浴',
    PS: null,
  },
  {
    tag: '144.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '144.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '144.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '144.5',
    v1voc: 'འོད',
    v2voc: '光',
    v3voc: '光明',
    v4voc: '-',
    v5voc: '明',
    PS: '144',
  },
  {
    tag: '144.6',
    v1voc: 'འོད་མཐའ་ཡས་པ་དང་ལྡན',
    v2voc: '內、外(光潔)',
    v3voc: '無量',
    v4voc: '見生死際',
    v5voc: '極照至邊',
    PS: '144',
  },
  {
    tag: '144.7',
    v1voc: 'ལུས',
    v2voc: '身',
    v3voc: '身',
    v4voc: '-',
    v5voc: '',
    PS: '144',
  },
  {
    tag: '144.8',
    v1voc: 'སེམས་',
    v2voc: '心',
    v3voc: '心',
    v4voc: '心',
    v5voc: '心',
    PS: '144',
  },
  {
    tag: '144.9',
    v1voc: 'དྲི་མ',
    v2voc: '垢',
    v3voc: '垢',
    v4voc: '垢',
    v5voc: '垢',
    PS: '144',
  },
  {
    tag: '144.10',
    v1voc: 'མེད་པ',
    v2voc: '無',
    v3voc: '無',
    v4voc: '蕩除',
    v5voc: '洗除',
    PS: null,
  },
  {
    tag: '144.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '144.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '144.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '145.1',
    v1voc: 'དྲོ་བ་ལ་སྤྱོད་པ',
    v2voc: '盛暑炎毒',
    v3voc: '盛暑炎熾',
    v4voc: '盛暑熱極',
    v5voc: '見熱',
    PS: null,
  },
  {
    tag: '145.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '145.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '145.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '145.5',
    v1voc: 'མུ་མེད་པར་ཕྱིན་པ',
    v2voc: '一切皆盡',
    v3voc: '（得淸涼定）',
    v4voc: '得(淸涼定）',
    v5voc: '（極過度去）',
    PS: '145',
  },
  {
    tag: '145.6',
    v1voc: 'ཡོངས་སུ་གདུང་བ',
    v2voc: '衆惱',
    v3voc: '煩惱熱',
    v4voc: '一切苦',
    v5voc: '熱',
    PS: '145',
  },
  {
    tag: '145.7',
    v1voc: 'བསིལ་བ',
    v2voc: '捨離',
    v3voc: '離',
    v4voc: '滅',
    v5voc: '遠離於',
    PS: '145',
  },
  {
    tag: '145.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '145.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '145.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '146.1',
    v1voc: 'བསིལ་བ་ལ་སྤྱོད་པ',
    v2voc: '涼',
    v3voc: '隆寒冰結',
    v4voc: '冰凍寒甚',
    v5voc: '見寒',
    PS: null,
  },
  {
    tag: '146.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '146.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '146.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: '146',
  },
  {
    tag: '146.5',
    v1voc: 'ཤིན་ཏུ་བསིལ་བར་གྱུར',
    v2voc: '究竟淸涼',
    v3voc: '究竟解脫',
    v4voc: '心冷愛除',
    v5voc: '得極明涼好處',
    PS: '146',
  },
  {
    tag: '146.6',
    v1voc: 'བླ་ན་མེད་པ',
    v2voc: '無上',
    v3voc: '無上',
    v4voc: '無復情欲',
    v5voc: '-',
    PS: '146',
  },
  {
    tag: '146.7',
    v1voc: 'བསིལ་བའི་དངོས་པོ་',
    v2voc: '(無上)法',
    v3voc: '(無上)淸涼',
    v4voc: '-',
    v5voc: '-',
    PS: '146',
  },
  {
    tag: '146.8',
    v1voc: 'ཁོང་དུ་ཆུད/ ཁོང་དུ་ཆུད་པ',
    v2voc: '證',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '146.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '146.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '146.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '147.1',
    v1voc: 'ཆོས་ཐོབ་པར་བྱེད་པ',
    v2voc: '諷誦經',
    v3voc: '諷誦經典',
    v4voc: '誦讀經偈',
    v5voc: '誦經',
    PS: null,
  },
  {
    tag: '147.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '147.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '147.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '147.5',
    v1voc: 'སངས་རྒྱས་ཀྱི་ཆོས་ཀྱི་གཏམ་',
    v2voc: '佛所說',
    v3voc: '一切法',
    v4voc: '諸法',
    v5voc: '諸經處',
    PS: '147',
  },
  {
    tag: '147.7',
    v1voc: 'རྗེས་སུ་འགྲོ་',
    v2voc: '順',
    v3voc: '攝',
    v4voc: '博解',
    v5voc: '解於',
    PS: '147',
  },
  {
    tag: '147.8',
    v1voc: 'ཆོས་ཀྱི་དབྱིངས་དང་འདྲིས་པ',
    v2voc: '總持不忘',
    v3voc: '得總持門',
    v4voc: '得無漏忘',
    v5voc: '攬持諸慧',
    PS: '147',
  },
  {
    tag: '147.9',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '147.10',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '147.11',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '148.1',
    v1voc: 'སངས་རྒྱས་',
    v2voc: '佛',
    v3voc: '如來',
    v4voc: '佛',
    v5voc: '佛',
    PS: null,
  },
  {
    tag: '148.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '得見',
    v5voc: '見',
    PS: null,
  },
  {
    tag: '148.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '148.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '148.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '148.6',
    v1voc: 'སངས་རྒྱས་ཐམས་ཅད་',
    v2voc: '一切佛',
    v3voc: '諸最勝',
    v4voc: '佛',
    v5voc: '諸佛',
    PS: '148',
  },
  {
    tag: '148.7',
    v1voc: 'འགྲོགས་པ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '與……會',
    v5voc: '與……共會',
    PS: '148',
  },
  {
    tag: '148.8',
    v1voc: 'སྒྲིབ་པ་མེད་པའི་མིག',
    v2voc: '無礙眼',
    v3voc: '佛眼',
    v4voc: '七覺意',
    v5voc: '無所罣礙',
    PS: '148',
  },
  {
    tag: '148.9',
    v1voc: 'ལྡན་པ',
    v2voc: '得',
    v3voc: '得',
    v4voc: '行',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '148.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '148.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '148.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '149.1',
    v1voc: 'མིག་མི་འགེབས་པར་ལྟ་བ',
    v2voc: '諦觀佛',
    v3voc: '諦觀如來',
    v4voc: '見佛圖像',
    v5voc: '上向視佛',
    PS: null,
  },
  {
    tag: '149.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '149.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '149.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '149.5',
    v1voc: 'ཀུན་ཏུ་མཛེས་པ',
    v2voc: '端正嚴好',
    v3voc: '端正',
    v4voc: '-',
    v5voc: '-',
    PS: '149',
  },
  {
    tag: '149.6',
    v1voc: 'ཀུན་ཏུ་བཟང/ ཀུན་ཏུ་བཟང་པོ',
    v2voc: '普賢',
    v3voc: '佛',
    v4voc: '悉睹十方，眼無障蔽',
    v5voc: '-',
    PS: '149',
  },
  {
    tag: '149.7',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '149.8',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '149.9',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '150.1',
    v1voc: 'མཆོད་རྟེན',
    v2voc: '佛塔',
    v3voc: '佛塔廟',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.2',
    v1voc: 'མཐོང་བ',
    v2voc: '見',
    v3voc: '見',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.3',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.6',
    v1voc: 'འགྲོ་བ་ཀུན་',
    v2voc: '天人',
    v3voc: '天人',
    v4voc: '-',
    v5voc: '-',
    PS: '150',
  },
  {
    tag: '150.7',
    v1voc: 'མཆོད་པར་འོས',
    v2voc: '受……供',
    v3voc: '受……敬',
    v4voc: '-',
    v5voc: '-',
    PS: '150',
  },
  {
    tag: '150.8',
    v1voc: 'མཆོད་རྟེན་ལྟ་བུ',
    v2voc: '塔',
    v3voc: '塔',
    v4voc: '-',
    v5voc: '-',
    PS: '150',
  },
  {
    tag: '150.9',
    v1voc: 'ལྟ་བུ',
    v2voc: '如',
    v3voc: '如',
    v4voc: '-',
    v5voc: '-',
    PS: '150',
  },
  {
    tag: '150.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '150.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '151.1',
    v1voc: 'ལྟ་བ',
    v2voc: '觀塔',
    v3voc: '觀塔',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '151.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '151.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '151.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '-',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '151.5',
    v1voc: 'ལྷ་དང་བཅས་པའི་འཇིག་རྟེན',
    v2voc: '諸天及人',
    v3voc: '天、人',
    v4voc: '-',
    v5voc: '-',
    PS: '151',
  },
  {
    tag: '151.6',
    v1voc: 'ལྟ་བ',
    v2voc: '所共瞻仰',
    v3voc: '宗仰',
    v4voc: '-',
    v5voc: '-',
    PS: '151',
  },
  {
    tag: '151.7',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '-',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '151.8',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '151.9',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '152.1',
    v1voc: 'སྤྱི་བོས་ཐུག་པ',
    v2voc: '頂禮於塔',
    v3voc: '頂禮佛塔',
    v4voc: '拜謁佛',
    v5voc: '爲佛禮拜頭腦著地',
    PS: null,
  },
  {
    tag: '152.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '',
    v4voc: '時',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '152.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '152.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '152.5',
    v1voc: 'ལྷ་དང་བཅས་པའི་འཇིག་རྟེན',
    v2voc: '一切天、人',
    v3voc: '(得道如佛)',
    v4voc: '(得道如佛)',
    v5voc: '天上、天下',
    PS: '152',
  },
  {
    tag: '152.6',
    v1voc: 'སྤྱི་གཙུག་ལྟར་མི་སྣང་བ',
    v2voc: '無能見頂',
    v3voc: '無能見頂',
    v4voc: '莫能見頂',
    v5voc: '無有能逮見佛頭上者',
    PS: '152',
  },
  {
    tag: '152.7',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '152.8',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '152.9',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '153.1',
    v1voc: 'གཡས་ཕྱོགས',
    v2voc: '右',
    v3voc: '右',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '153.2',
    v1voc: 'བསྐོར་བ་བྱེད་པ',
    v2voc: '遶',
    v3voc: '遶',
    v4voc: '旋',
    v5voc: '繞',
    PS: null,
  },
  {
    tag: '153.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '153.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '153.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '153.6',
    v1voc: 'ཐམས་ཅད་མཁྱེན་པ་ཉིད',
    v2voc: '成一切智',
    v3voc: '究暢道意',
    v4voc: '究暢道意',
    v5voc: '經明',
    PS: '153',
  },
  {
    tag: '153.7',
    v1voc: 'དོན་དང་མཐུན་པ',
    v2voc: '所行無逆',
    v3voc: '履行正路',
    v4voc: '施行福祐',
    v5voc: '繞極善，所作爲皆究竟',
    PS: '153',
  },
  {
    tag: '153.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '153.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '153.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '154.1',
    v1voc: 'ལན་གསུམ',
    v2voc: '三帀',
    v3voc: '三帀',
    v4voc: '三帀',
    v5voc: '三帀',
    PS: null,
  },
  {
    tag: '154.2',
    v1voc: 'བསྐོར་བ',
    v2voc: '遶',
    v3voc: '遶',
    v4voc: '遶',
    v5voc: '繞',
    PS: null,
  },
  {
    tag: '154.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '154.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '154.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '154.6',
    v1voc: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ་',
    v2voc: '佛道',
    v3voc: '佛道',
    v4voc: '(不斷四喜)',
    v5voc: '佛道',
    PS: '154',
  },
  {
    tag: '154.7',
    v1voc: 'མོས་པའི་རབ་དང་ལྡན་པ',
    v2voc: '心無懈歇',
    v3voc: '得一向意',
    v4voc: '得一向意',
    v5voc: '(所作爲心常勇)',
    PS: '154',
  },
  {
    tag: '154.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '154.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '154.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '155.1',
    v1voc: 'སངས་རྒྱས',
    v2voc: '佛',
    v3voc: '如來',
    v4voc: '-',
    v5voc: '佛',
    PS: null,
  },
  {
    tag: '155.2',
    v1voc: 'ཡོན་ཏན་',
    v2voc: '功德',
    v3voc: '-',
    v4voc: '-',
    v5voc: '功德',
    PS: null,
  },
  {
    tag: '155.3',
    v1voc: 'བརྗོད་པ',
    v2voc: '讚',
    v3voc: '讚詠',
    v4voc: '行詠歌經',
    v5voc: '稱譽',
    PS: null,
  },
  {
    tag: '155.4',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '155.5',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '155.6',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '155.7',
    v1voc: 'ཡོན་ཏན་',
    v2voc: '德',
    v3voc: '功德',
    v4voc: '念佛恩德',
    v5voc: '功德',
    PS: '155',
  },
  {
    tag: '155.8',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '(衆德)悉具',
    v3voc: '度(功德)岸',
    v4voc: '(行法供養)',
    v5voc: '極過度',
    PS: '155',
  },
  {
    tag: '155.9',
    v1voc: 'ཡོན་ཏན་',
    v2voc: '稱歎',
    v3voc: '歎',
    v4voc: '-',
    v5voc: '-',
    PS: '155',
  },
  {
    tag: '155.10',
    v1voc: 'མི་ཟད་པ',
    v2voc: '無盡',
    v3voc: '無窮盡',
    v4voc: '-',
    v5voc: '不可計',
    PS: '155',
  },
  {
    tag: '155.11',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '155.12',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '155.13',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '156.1',
    v1voc: 'མཚན་',
    v2voc: '佛相',
    v3voc: '佛相好',
    v4voc: '佛',
    v5voc: '佛相',
    PS: null,
  },
  {
    tag: '156.2',
    v1voc: 'བརྗོད་པ',
    v2voc: '讚',
    v3voc: '讚',
    v4voc: '讚',
    v5voc: '稱譽',
    PS: null,
  },
  {
    tag: '156.3',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '156.4',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '156.5',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '156.6',
    v1voc: 'མཚན་ཉིད་མེད་པའི་ཆོས',
    v2voc: '無相法',
    v3voc: '(光明神德)',
    v4voc: '光明神德',
    v5voc: '',
    PS: '156',
  },
  {
    tag: '156.7',
    v1voc: 'གཞོལ',
    v2voc: '證',
    v3voc: '',
    v4voc: '-',
    v5voc: '-',
    PS: '156',
  },
  {
    tag: '156.8',
    v1voc: 'ཡན་ལག་དམ་པ',
    v2voc: '佛身',
    v3voc: '佛法身',
    v4voc: '佛法身',
    v5voc: '佛經身',
    PS: '156',
  },
  {
    tag: '156.9',
    v1voc: 'ཕུན་སུམ་ཚོགས་པ',
    v2voc: '成就',
    v3voc: '-',
    v4voc: '-',
    v5voc: '悉具足',
    PS: '156',
  },
  {
    tag: '156.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '156.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '156.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '157.1',
    v1voc: 'རྐང་པ་འཁྲུ་བ',
    v2voc: '洗足',
    v3voc: '洗足',
    v4voc: '洗足',
    v5voc: '洗足',
    PS: null,
  },
  {
    tag: '157.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '157.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '157.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '157.5',
    v1voc: 'དྲི་མ་མེད་པའི་མཐར་ཕྱིན',
    v2voc: '所行無礙',
    v3voc: '究竟解脫',
    v4voc: '周遍十方',
    v5voc: '無所復罣礙悉入具',
    PS: '157',
  },
  {
    tag: '157.6',
    v1voc: 'རྫུ་འཕྲུལ་གྱི་རྐང་པ',
    v2voc: '神足力',
    v3voc: '四神足',
    v4voc: '四神足',
    v5voc: '佛神足',
    PS: '157',
  },
  {
    tag: '157.7',
    v1voc: 'ཕ་རོལ་ཏུ་ཕྱིན་པ',
    v2voc: '具',
    v3voc: '得',
    v4voc: '得',
    v5voc: '得',
    PS: '157',
  },
  {
    tag: '157.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '157.9',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '157.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '158.1',
    v1voc: 'ལུས་སྨྱོང་བ',
    v2voc: '寢息',
    v3voc: '寢息',
    v4voc: '寢息',
    v5voc: '臥坐',
    PS: null,
  },
  {
    tag: '158.2',
    v1voc: 'ཚེ་',
    v2voc: '時',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '158.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '158.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '衆生',
    v3voc: '衆生',
    v4voc: '衆生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '158.5',
    v1voc: 'བསམ་པ་',
    v2voc: '心',
    v3voc: '心',
    v4voc: '-',
    v5voc: '-',
    PS: '158',
  },
  {
    tag: '158.6',
    v1voc: 'རྙོག་པ་མེད / རྙོག་པ་མེད་པ',
    v2voc: '無動亂',
    v3voc: '(心)淨無穢',
    v4voc: '無復五蓋',
    v5voc: '不復繫於愛欲',
    PS: '158',
  },
  {
    tag: '158.7',
    v1voc: 'ལུས་',
    v2voc: '身',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: '158',
  },
  {
    tag: '158.8',
    v1voc: 'འདུ་བྱེད',
    v2voc: '得',
    v3voc: '諸行',
    v4voc: '-',
    v5voc: '勤苦',
    PS: '158',
  },
  {
    tag: '158.9',
    v1voc: 'ཤིན་ཏུ་བདེ་བར་',
    v2voc: '安隱',
    v3voc: '休息',
    v4voc: '離於闇冥',
    v5voc: '悉淨潔',
    PS: '158',
  },
  {
    tag: '158.10',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '158.11',
    v1voc: 'ཅེས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '158.12',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '159.1',
    v1voc: 'གཉིད་སད་པ',
    v2voc: '睡眠始寤',
    v3voc: '晨朝覺悟',
    v4voc: '臥覺',
    v5voc: '覺起',
    PS: null,
  },
  {
    tag: '159.2',
    v1voc: 'ཚེ་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '時',
    PS: null,
  },
  {
    tag: '159.3',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔས་',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '菩薩',
    PS: null,
  },
  {
    tag: '159.4',
    v1voc: 'སེམས་ཅན་ཐམས་ཅད་',
    v2voc: '眾生',
    v3voc: '眾生',
    v4voc: '眾生',
    v5voc: '十方天下人',
    PS: null,
  },
  {
    tag: '159.5',
    v1voc: 'ཕྱོགས་བཅུ་ཐམས་ཅད་',
    v2voc: '周顧十方',
    v3voc: '(不捨)十方',
    v4voc: '(不捨)十方',
    v5voc: '-',
    PS: '159',
  },
  {
    tag: '159.6',
    v1voc: 'ཐམས་ཅད་མཁྱེན་པའི་ཡེ་ཤེས་',
    v2voc: '一切智',
    v3voc: '一切智',
    v4voc: '',
    v5voc: '佛智慧',
    PS: '159',
  },
  {
    tag: '159.7',
    v1voc: 'ཤིན་ཏུ་རྣམ་པར་སངས་རྒྱས་པ',
    v2voc: '覺',
    v3voc: '覺',
    v4voc: '',
    v5voc: '-',
    PS: '159',
  },
  {
    tag: '159.8',
    v1voc: 'གྱུར་ཅིག་',
    v2voc: '當願',
    v3voc: '當願',
    v4voc: '當願',
    v5voc: '皆使',
    PS: null,
  },
  {
    tag: '159.9',
    v1voc: 'ཅེས་',
    v2voc: '',
    v3voc: '',
    v4voc: '',
    v5voc: '言',
    PS: null,
  },
  {
    tag: '159.10',
    v1voc: 'སེམས་བསྐྱེད་',
    v2voc: '-',
    v3voc: '',
    v4voc: '',
    v5voc: '心念',
    PS: null,
  },
  {
    tag: '159.11',
    v1voc: 'མཐུ་ཆེན་པོ་ཐོབ་པ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '得佛十八　不絕之法',
    v5voc: '得十力',
    PS: null,
  },
  {
    tag: '160.1',
    v1voc: 'ཀྱེ་རྒྱལ་བའི་སྲས་',
    v2voc: '佛子',
    v3voc: '佛子',
    v4voc: '-',
    v5voc: '',
    PS: null,
  },
  {
    tag: '160.2',
    v1voc: 'བྱང་ཆུབ་སེམས་དཔའ་',
    v2voc: '諸菩薩',
    v3voc: '菩薩',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.3',
    v1voc: 'སེམས་ཀྱི་ལས་ཡིད་ལ་བྱེད་པའི་སྦྱོར་བ་',
    v2voc: '用心',
    v3voc: '身、口、意業',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.4',
    v1voc: 'ཡོན་ཏན་གྱི་ཁྱད་པར་',
    v2voc: '勝妙功德',
    v3voc: '勝妙功德',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.5',
    v1voc: 'འདི་དག་དང་གཞན་ཐམས་ཅད་ཀྱང་ཐོབ་པ',
    v2voc: '則獲一切',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.6',
    v1voc: 'ལྷ་དང་འཇིག་རྟེན་དུ་བཅས་པ',
    v2voc: '一切世間',
    v3voc: '諸天',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.7',
    v1voc: 'བདུད་དུ་བཅས་པ',
    v2voc: '魔',
    v3voc: '魔',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.8',
    v1voc: 'ཚངས་པར་བཅས་པ',
    v2voc: '梵',
    v3voc: '梵',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.9',
    v1voc: 'དགེ་སྦྱོང་',
    v2voc: '沙門',
    v3voc: '沙門',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.10',
    v1voc: 'བྲམ་ཟེ་',
    v2voc: '婆羅門',
    v3voc: '婆羅門',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.11',
    v1voc: 'སྐྱེ་དགུ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.12',
    v1voc: 'ལྷ',
    v2voc: '-',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.13',
    v1voc: 'དྲི་ཟ',
    v2voc: '乾闥婆',
    v3voc: '-',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.14',
    v1voc: 'མི',
    v2voc: '-',
    v3voc: '人',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.15',
    v1voc: 'ལྷ་མ་ཡིན',
    v2voc: '阿脩羅',
    v3voc: '非人',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.17',
    v1voc: 'ཉན་ཐོས',
    v2voc: '聲聞',
    v3voc: '聲聞',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.18',
    v1voc: 'རང་སངས་རྒྱས',
    v2voc: '緣覺',
    v3voc: '緣覺',
    v4voc: '-',
    v5voc: '-',
    PS: null,
  },
  {
    tag: '160.20',
    v1voc: 'མི་འཕྲོགས་པར་འགྱུར་བ',
    v2voc: '所不能動',
    v3voc: '所不能動',
    v4voc: '',
    v5voc: '',
    PS: null,
  }],
}];



// WEBPACK FOOTER //
// ./src/components/data/vocabularies.js